

(function (window, document) {
    window.AppaltiMap = window.AppaltiMap || {};

    function qs(sel, root) {
        return (root || document).querySelector(sel);
    }

    function setStatus(text) {
        var el = qs('[data-appaltimap-status]');
        if (!el) return;
        el.textContent = text || '';
    }

    function setOverlayVisible(visible, title, hint) {
        var overlay = qs('[data-appaltimap-overlay]');
        if (!overlay) return;
        overlay.hidden = !visible;
        overlay.setAttribute('aria-hidden', visible ? 'false' : 'true');
        if (!visible) return;

        var titleEl = overlay.querySelector('.appaltimap-overlay__title');
        var hintEl = overlay.querySelector('.appaltimap-overlay__hint');
        if (titleEl && title) titleEl.textContent = title;
        if (hintEl && hint) hintEl.textContent = hint;
    }

    function getMagicFromUrl() {
        try {
            var url = new URL(window.location.href);
            return url.searchParams.get('magic');
        } catch (e) {
            return null;
        }
    }

    function getApiBaseFromDom() {
        var mapEl = qs('#appaltimap-map');
        if (!mapEl) return '';
        var base = mapEl.getAttribute('data-api-base') || '';
        return base;
    }

    function getMemberUuidFromDom() {
        var mapEl = qs('#appaltimap-map');
        if (!mapEl) return '';
        return mapEl.getAttribute('data-member-uuid') || '';
    }

    function getMemberIdFromDom() {
        var mapEl = qs('#appaltimap-map');
        if (!mapEl) return '';
        return mapEl.getAttribute('data-member-id') || '';
    }

    // ---------------------------------------------------------------------
    // Home map: Esplorazione (radar) vs Company Profile (territori)
    // ---------------------------------------------------------------------

    var VG_REGIONI_GEOJSON_URL = 'https://raw.githubusercontent.com/openpolis/geojson-italy/master/geojson/limits_IT_regions.geojson';
    var VG_HOME_COMPANY_SOURCE = 'vg-home-company-territories';
    var VG_HOME_COMPANY_FILL = 'vg-home-company-territories-fill';
    var VG_HOME_COMPANY_LINE_LEGACY = 'vg-home-company-territories-line';
    var VG_HOME_COMPANY_LINE_HALO = 'vg-home-company-territories-line-halo';
    var VG_HOME_COMPANY_LINE_DASH = 'vg-home-company-territories-line-dash';
    var VG_HOME_MAP_AREA_MODE_STORAGE_KEY = 'vg-home-map-area-mode';
    var _vgHomeGatewaySessionOk = false;

    function persistHomeMapAreaMode(mode) {
        try {
            if (mode === 'company' || mode === 'explore') {
                localStorage.setItem(VG_HOME_MAP_AREA_MODE_STORAGE_KEY, mode);
            }
        } catch (e) {}
    }

    function fetchGhostSessionTokenHome() {
        return fetch('/members/api/session/', { method: 'GET', credentials: 'include' })
            .then(function (r) {
                if (r.status === 204) return null;
                if (!r.ok) return r.text().then(function (t) { throw new Error('Ghost session HTTP ' + r.status + (t ? ' ' + t.slice(0, 120) : '')); });
                return r.text();
            })
            .then(function (token) {
                token = (token || '').trim();
                return token || null;
            });
    }

    function gatewaySessionLoginHome(sessionToken) {
        var api = String(getApiBaseFromDom() || '').replace(/\/+$/, '');
        if (!api) return Promise.reject(new Error('API base mancante'));
        return fetch(api + '/auth/ghost/session/login', {
            method: 'POST',
            credentials: 'include',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ session_token: sessionToken })
        }).then(function (r) {
            return r.json().then(function (data) {
                if (!r.ok) {
                    var d = (data && data.detail) ? String(data.detail) : '';
                    throw new Error(d || ('Gateway login HTTP ' + r.status));
                }
                return data;
            });
        });
    }

    function ensureGatewaySessionHome() {
        if (_vgHomeGatewaySessionOk) return Promise.resolve();
        return fetchGhostSessionTokenHome()
            .then(function (token) {
                if (!token) throw new Error('Accedi per caricare il profilo aziendale');
                return gatewaySessionLoginHome(token);
            })
            .then(function () {
                _vgHomeGatewaySessionOk = true;
            });
    }

    function fetchCompanyBundleForHomeMap() {
        var api = String(getApiBaseFromDom() || '').replace(/\/+$/, '');
        if (!api) return Promise.reject(new Error('API base mancante'));
        return fetch(api + '/company-profiles?limit=1&offset=0', {
            credentials: 'include',
            headers: { Accept: 'application/json' }
        })
            .then(function (r) {
                return r.json().then(function (j) {
                    if (!r.ok) throw new Error((j && j.detail && String(j.detail)) || ('HTTP ' + r.status));
                    return j;
                });
            })
            .then(function (list) {
                var items = (list && list.items) ? list.items : [];
                if (!items.length) return { profileId: null, territories: [], cpv: [] };
                var pid = items[0].id;
                return fetch(api + '/company-profiles/' + encodeURIComponent(pid) + '/bundle', {
                    credentials: 'include',
                    headers: { Accept: 'application/json' }
                }).then(function (r2) {
                    return r2.json().then(function (j2) {
                        if (!r2.ok) throw new Error((j2 && j2.detail && String(j2.detail)) || ('HTTP ' + r2.status));
                        return j2;
                    });
                }).then(function (bundle) {
                    return {
                        profileId: pid,
                        territories: (bundle && bundle.territories) ? bundle.territories : [],
                        cpv: (bundle && bundle.cpv) ? bundle.cpv : []
                    };
                });
            });
    }

    function buildItalyMultiPolygonFromRegionsGeojson(gj) {
        var polys = [];
        (gj && gj.features ? gj.features : []).forEach(function (f) {
            if (!f || !f.geometry) return;
            if (f.geometry.type === 'Polygon') polys.push(f.geometry.coordinates);
            if (f.geometry.type === 'MultiPolygon') polys = polys.concat(f.geometry.coordinates);
        });
        if (!polys.length) return null;
        return { type: 'MultiPolygon', coordinates: polys };
    }

    function fetchItalyMultiPolygonHome() {
        return fetch(VG_REGIONI_GEOJSON_URL, { headers: { Accept: 'application/json' } })
            .then(function (r) {
                if (!r.ok) throw new Error('Regione Italia HTTP ' + r.status);
                return r.json();
            })
            .then(buildItalyMultiPolygonFromRegionsGeojson);
    }

    function normalizeGeoJsonTypeName(typ) {
        if (!typ || typeof typ !== 'string') return typ;
        var lower = typ.toLowerCase();
        if (lower === 'polygon') return 'Polygon';
        if (lower === 'multipolygon') return 'MultiPolygon';
        if (lower === 'feature') return 'Feature';
        if (lower === 'geometrycollection') return 'GeometryCollection';
        return typ;
    }

    /**
     * DB / Survey may store a raw Geometry, a GeoJSON Feature, or (rarely) a GeometryCollection.
     * MapLibre needs Polygon or MultiPolygon at Feature.geometry.
     */
    function unwrapTerritoryGeometry(g) {
        if (g == null) return null;
        while (typeof g === 'string') {
            try {
                g = JSON.parse(g);
            } catch (e) {
                return null;
            }
        }
        if (typeof g !== 'object') return null;

        var typ = normalizeGeoJsonTypeName(g.type);
        if (typ === 'Feature' && g.geometry) {
            return unwrapTerritoryGeometry(g.geometry);
        }
        if (typ === 'GeometryCollection' && Array.isArray(g.geometries)) {
            var polys = [];
            g.geometries.forEach(function (sub) {
                var u = unwrapTerritoryGeometry(sub);
                if (u && u.type === 'Polygon' && u.coordinates) polys.push(u.coordinates);
                if (u && u.type === 'MultiPolygon' && u.coordinates) polys = polys.concat(u.coordinates);
            });
            if (!polys.length) return null;
            return { type: 'MultiPolygon', coordinates: polys };
        }
        if (typ === 'Polygon' && g.coordinates) {
            return { type: 'Polygon', coordinates: g.coordinates };
        }
        if (typ === 'MultiPolygon' && g.coordinates) {
            return { type: 'MultiPolygon', coordinates: g.coordinates };
        }
        return null;
    }

    function territoryGeometryFromRow(t) {
        if (!t || typeof t !== 'object') return null;
        var raw = t.geometry_geojson;
        if (raw == null && t.geometryGeojson != null) raw = t.geometryGeojson;
        return unwrapTerritoryGeometry(raw);
    }

    function territoriesRowsToFeatureCollection(territories) {
        var features = [];
        (territories || []).forEach(function (t, i) {
            var g = territoryGeometryFromRow(t);
            if (!g) return;
            features.push({
                type: 'Feature',
                id: 'cp-territory-' + i,
                properties: { label: String((t.territory_label != null) ? t.territory_label : '') },
                geometry: g
            });
        });
        return { type: 'FeatureCollection', features: features };
    }

    function bboxFromGeometryCoords(geom) {
        if (!geom || !geom.coordinates) return null;
        var minLon = Infinity;
        var minLat = Infinity;
        var maxLon = -Infinity;
        var maxLat = -Infinity;
        function ring(pts) {
            (pts || []).forEach(function (p) {
                if (!p || p.length < 2) return;
                var lon = Number(p[0]);
                var lat = Number(p[1]);
                if (!isFinite(lon) || !isFinite(lat)) return;
                minLon = Math.min(minLon, lon);
                minLat = Math.min(minLat, lat);
                maxLon = Math.max(maxLon, lon);
                maxLat = Math.max(maxLat, lat);
            });
        }
        if (geom.type === 'Polygon') {
            (geom.coordinates || []).forEach(ring);
        } else if (geom.type === 'MultiPolygon') {
            (geom.coordinates || []).forEach(function (poly) {
                (poly || []).forEach(ring);
            });
        } else {
            return null;
        }
        if (!isFinite(minLon) || minLon > maxLon || minLat > maxLat) return null;
        return [minLon, minLat, maxLon, maxLat];
    }

    function bboxFromFeatureCollection(fc) {
        var b = null;
        (fc && fc.features ? fc.features : []).forEach(function (f) {
            var bb = f && f.geometry ? bboxFromGeometryCoords(f.geometry) : null;
            if (!bb) return;
            if (!b) b = bb.slice();
            else {
                b[0] = Math.min(b[0], bb[0]);
                b[1] = Math.min(b[1], bb[1]);
                b[2] = Math.max(b[2], bb[2]);
                b[3] = Math.max(b[3], bb[3]);
            }
        });
        return b;
    }

    function featureCollectionBboxToQueryString(fc) {
        var bb = bboxFromFeatureCollection(fc);
        if (!bb || bb.length < 4) return null;
        return bb.join(',');
    }

    function pointInPolygonHome(point, ring) {
        try {
            if (!point || !ring || ring.length < 3) return false;
            var x = point[0];
            var y = point[1];
            var inside = false;
            for (var i = 0, j = ring.length - 1; i < ring.length; j = i++) {
                var xi = ring[i][0];
                var yi = ring[i][1];
                var xj = ring[j][0];
                var yj = ring[j][1];
                var intersect = ((yi > y) !== (yj > y)) &&
                    (x < (xj - xi) * (y - yi) / (yj - yi + 0.0) + xi);
                if (intersect) inside = !inside;
            }
            return inside;
        } catch (e) {
            return false;
        }
    }

    function pointInGeometryHome(point, geom) {
        if (!point || !geom || !geom.coordinates) return false;
        if (geom.type === 'Polygon') {
            var outer = geom.coordinates[0];
            return pointInPolygonHome(point, outer);
        }
        if (geom.type === 'MultiPolygon') {
            var polys = geom.coordinates || [];
            for (var p = 0; p < polys.length; p++) {
                var rings = polys[p];
                var r0 = rings && rings[0];
                if (r0 && pointInPolygonHome(point, r0)) return true;
            }
        }
        return false;
    }

    /** point: [lon, lat]; fc: GeoJSON FeatureCollection from company territories layer */
    function pointInCompanyFeatureCollection(point, fc) {
        if (!point || !fc || !Array.isArray(fc.features)) return false;
        for (var i = 0; i < fc.features.length; i++) {
            var f = fc.features[i];
            if (f && f.geometry && pointInGeometryHome(point, f.geometry)) return true;
        }
        return false;
    }

    function vgPageGutterPx() {
        // Read the actual pixel value of the site gutter (shared with toolbar/menu/posts)
        // so MapLibre fitBounds padding matches the layout margin.
        try {
            if (!document || !document.body) return NaN;
            var el = document.createElement('div');
            el.style.cssText =
                'position:absolute;visibility:hidden;pointer-events:none;left:0;top:0;' +
                'width:0;height:0;padding-left:var(--vg-page-gutter);';
            document.body.appendChild(el);
            var px = parseFloat((window.getComputedStyle(el).paddingLeft || '').replace('px', ''));
            if (el && el.parentNode) el.parentNode.removeChild(el);
            if (isFinite(px) && px > 0) return px;
        } catch (e) {}
        return NaN;
    }

    function vgMapFitPaddingPx() {
        var g = vgPageGutterPx();
        // Fallback to previous values if CSS var not readable.
        if (!isFinite(g) || g <= 0) g = 56;
        return Math.max(12, Math.min(96, Math.round(g)));
    }

    function fitMapBoundsFromBBox(map, bboxArr) {
        if (!map || !bboxArr || bboxArr.length < 4) return;
        var minLon = bboxArr[0];
        var minLat = bboxArr[1];
        var maxLon = bboxArr[2];
        var maxLat = bboxArr[3];
        if (!isFinite(minLon) || !isFinite(minLat) || !isFinite(maxLon) || !isFinite(maxLat)) return;
        if (minLon >= maxLon || minLat >= maxLat) return;
        try {
            map.fitBounds([[minLon, minLat], [maxLon, maxLat]], { padding: vgMapFitPaddingPx(), duration: 550 });
        } catch (e) {}
    }

    function italyApproxBboxHome() {
        return [6.6, 36.6, 18.9, 47.2];
    }

    function fitExploreModeHomeBounds(map) {
        var g = window.AppaltiMap && window.AppaltiMap._savedAreaGeojson;
        var bb = (g && g.type === 'Polygon') ? bboxFromGeometryCoords(g) : null;
        if (bb) fitMapBoundsFromBBox(map, bb);
        else fitMapBoundsFromBBox(map, italyApproxBboxHome());
    }

    function clearTerraDrawVisualizationHome(draw) {
        if (!draw) return;
        try { draw.setMode('render'); } catch (e0) {}
        try {
            if (typeof draw.clear === 'function') {
                draw.clear();
            } else if (typeof draw.getSnapshot === 'function' && typeof draw.removeFeatures === 'function') {
                var snap = draw.getSnapshot() || [];
                var ids = [];
                snap.forEach(function (f) {
                    if (f && f.id != null) ids.push(f.id);
                });
                if (ids.length) draw.removeFeatures(ids);
            }
        } catch (e1) {}
        if (window.AppaltiMap) window.AppaltiMap._savedAreaFeatureId = null;
    }

    function restoreTerraDrawRadarPolygonHome(draw) {
        if (!draw || !window.AppaltiMap) return;
        var geom = window.AppaltiMap._savedAreaGeojson;
        if (!geom || geom.type !== 'Polygon' || !geom.coordinates) return;
        try {
            var id = (typeof draw.getFeatureId === 'function') ? draw.getFeatureId() : String(Date.now());
            var feature = { type: 'Feature', id: id, geometry: geom, properties: { mode: 'polygon' } };
            if (typeof draw.addFeatures === 'function') {
                draw.addFeatures([feature]);
                window.AppaltiMap._savedAreaFeatureId = id;
            }
        } catch (e) {}
    }

    function removeHomeCompanyTerritoryLayers(map) {
        if (!map) return;
        try {
            if (map.getLayer(VG_HOME_COMPANY_LINE_DASH)) map.removeLayer(VG_HOME_COMPANY_LINE_DASH);
            if (map.getLayer(VG_HOME_COMPANY_LINE_HALO)) map.removeLayer(VG_HOME_COMPANY_LINE_HALO);
            if (map.getLayer(VG_HOME_COMPANY_LINE_LEGACY)) map.removeLayer(VG_HOME_COMPANY_LINE_LEGACY);
            if (map.getLayer(VG_HOME_COMPANY_FILL)) map.removeLayer(VG_HOME_COMPANY_FILL);
            if (map.getSource(VG_HOME_COMPANY_SOURCE)) map.removeSource(VG_HOME_COMPANY_SOURCE);
        } catch (e) {}
    }

    function setHomeCompanyTerritoriesLayerData(map, featureCollection) {
        if (!map) return;
        var data = featureCollection || { type: 'FeatureCollection', features: [] };
        var sdCount = 0;
        function onStyleData() {
            sdCount += 1;
            if (apply()) return;
            if (sdCount > 25) map.off('styledata', onStyleData);
        }
        function apply() {
            if (!map.isStyleLoaded || !map.isStyleLoaded()) return false;
            var beforeId = map.getLayer('appaltimap-clusters') ? 'appaltimap-clusters' : undefined;
            try {
                if (!map.getSource(VG_HOME_COMPANY_SOURCE)) {
                    map.addSource(VG_HOME_COMPANY_SOURCE, { type: 'geojson', data: data });
                    map.addLayer({
                        id: VG_HOME_COMPANY_FILL,
                        type: 'fill',
                        source: VG_HOME_COMPANY_SOURCE,
                        paint: {
                            'fill-color': '#0d9488',
                            'fill-opacity': 0.4,
                            'fill-outline-color': 'rgba(255, 255, 255, 0.35)'
                        }
                    }, beforeId);
                    // Bordo bicolore: alone chiaro continuo + tratteggio scuro (i “buchi” del dash mostrano il chiaro)
                    map.addLayer({
                        id: VG_HOME_COMPANY_LINE_HALO,
                        type: 'line',
                        source: VG_HOME_COMPANY_SOURCE,
                        layout: { 'line-join': 'round', 'line-cap': 'round' },
                        paint: {
                            'line-color': '#fef9c3',
                            'line-width': 5,
                            'line-opacity': 0.92
                        }
                    }, beforeId);
                    map.addLayer({
                        id: VG_HOME_COMPANY_LINE_DASH,
                        type: 'line',
                        source: VG_HOME_COMPANY_SOURCE,
                        layout: { 'line-join': 'round', 'line-cap': 'round' },
                        paint: {
                            'line-color': '#134e4a',
                            'line-width': 2.25,
                            'line-opacity': 1,
                            'line-dasharray': [3, 2.5]
                        }
                    }, beforeId);
                } else {
                    map.getSource(VG_HOME_COMPANY_SOURCE).setData(data);
                }
            } catch (e) {
                if (typeof console !== 'undefined' && console.warn) {
                    console.warn('vg-home company territories layer:', e);
                }
                return false;
            }
            try { map.off('styledata', onStyleData); } catch (eOff) {}
            return true;
        }
        if (apply()) return;
        var attempts = 0;
        function scheduleRetry() {
            attempts += 1;
            if (attempts > 40) return;
            if (apply()) return;
            window.requestAnimationFrame(scheduleRetry);
        }
        scheduleRetry();
        map.on('styledata', onStyleData);
        try {
            map.once('idle', function () { apply(); });
        } catch (eId) {}
    }

    function updateHomeMapModeToggleButton(btn) {
        if (!btn) return;
        var mode = (window.AppaltiMap && window.AppaltiMap._homeMapAreaMode) || 'explore';
        var icon = btn.querySelector('[data-appaltimap-map-mode-icon]');
        if (mode === 'company') {
            btn.setAttribute('aria-pressed', 'true');
            btn.title = 'Modalità Company Profile (territori salvati)';
            btn.setAttribute('aria-label', 'Modalità Company Profile (territori salvati)');
            if (icon) icon.textContent = '🏢';
            btn.classList.add('is-company-mode');
        } else {
            btn.setAttribute('aria-pressed', 'false');
            btn.title = 'Modalità esplorazione (area radar)';
            btn.setAttribute('aria-label', 'Modalità esplorazione (area radar)');
            if (icon) icon.textContent = '🌍';
            btn.classList.remove('is-company-mode');
        }
    }

    function syncAllHomeMapModeToggleButtons() {
        try {
            document.querySelectorAll('[data-appaltimap-action="map-area-mode-toggle"], [data-vg-ai-map-mode-toggle]').forEach(function (btn) {
                updateHomeMapModeToggleButton(btn);
            });
        } catch (e) {}
    }

    function buildCompanyOrItalyFeatureCollection(territories) {
        var fc = territoriesRowsToFeatureCollection(territories);
        if (fc.features.length) return Promise.resolve(fc);
        return fetchItalyMultiPolygonHome().then(function (geom) {
            if (!geom) throw new Error('Impossibile caricare i confini Italia');
            return {
                type: 'FeatureCollection',
                features: [{ type: 'Feature', properties: { label: 'Italia' }, geometry: geom }]
            };
        });
    }

    // ---------------------------------------------------------------------
    // AI result card: Density heatmap (Radar Densità Gare) rendered in-chat
    // ---------------------------------------------------------------------

    function pad2(n) { return (n < 10 ? '0' : '') + n; }
    function toISODate(d) { return d.getFullYear() + '-' + pad2(d.getMonth() + 1) + '-' + pad2(d.getDate()); }
    function parseISODate(s) {
        var t = String(s || '').trim();
        if (!t) return null;
        var m = t.match(/^(\d{4})-(\d{2})-(\d{2})/);
        if (!m) return null;
        return new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
    }
    function parseEuroNumber(v) {
        if (v == null || v === '') return NaN;
        if (typeof v === 'number' && isFinite(v)) return v;
        var s = String(v).trim().replace(/\s/g, '');
        if (!s) return NaN;
        if (s.indexOf(',') !== -1 && s.indexOf('.') !== -1) return parseFloat(s.replace(/\./g, '').replace(',', '.'), 10);
        if (s.indexOf(',') !== -1) return parseFloat(s.replace(',', '.'), 10);
        return parseFloat(s, 10);
    }
    function formatEuroIt(v) {
        var n = parseEuroNumber(v);
        if (!isFinite(n)) return '—';
        return n.toLocaleString('it-IT', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
    }

    function densityEscapeHtml(s) {
        return String(s || '')
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;');
    }

    function densityRenderMarkdownSimple(text) {
        var s = String(text || '');
        if (!s) return '';
        try {
            if (typeof marked !== 'undefined' && marked && typeof marked.parse === 'function') {
                var html = marked.parse(s, { breaks: true, gfm: true });
                if (typeof DOMPurify !== 'undefined' && DOMPurify && typeof DOMPurify.sanitize === 'function') {
                    html = DOMPurify.sanitize(html, {
                        USE_PROFILES: { html: true },
                        ADD_TAGS: ['span', 'details', 'summary', 'div'],
                        ADD_ATTR: ['title', 'open'],
                        ALLOWED_ATTR: ['href', 'src', 'alt', 'title', 'target', 'rel', 'class', 'id', 'aria-label', 'role']
                    });
                }
                return html;
            }
        } catch (e) {}
        return '<p>' + densityEscapeHtml(s).replace(/\n/g, '<br>') + '</p>';
    }

    var MONTHS_IT = ['Gen', 'Feb', 'Mar', 'Apr', 'Mag', 'Giu', 'Lug', 'Ago', 'Set', 'Ott', 'Nov', 'Dic'];
    var DOW_IT = ['L', 'M', 'M', 'G', 'V', 'S', 'D'];

    function buildCalendarDays(df, dt) {
        var start = new Date(df.getFullYear(), df.getMonth(), df.getDate());
        var end = new Date(dt.getFullYear(), dt.getMonth(), dt.getDate());
        var dow = (start.getDay() + 6) % 7; // 0=Mon ..6=Sun
        start.setDate(start.getDate() - dow);
        var days = [];
        for (var d = new Date(start); d <= end; d.setDate(d.getDate() + 1)) {
            days.push(new Date(d.getFullYear(), d.getMonth(), d.getDate()));
        }
        var last = days[days.length - 1];
        var lastDow = (last.getDay() + 6) % 7;
        for (var i = lastDow; i < 6; i++) {
            var nd = new Date(last.getFullYear(), last.getMonth(), last.getDate());
            nd.setDate(nd.getDate() + (i - lastDow) + 1);
            days.push(nd);
        }
        return days;
    }

    function quantizeLevels(values) {
        var nums = (values || []).filter(function (x) { return isFinite(x) && x > 0; }).sort(function (a, b) { return a - b; });
        if (!nums.length) return function () { return 0; };
        function q(p) {
            var idx = Math.floor((nums.length - 1) * p);
            return nums[Math.max(0, Math.min(nums.length - 1, idx))];
        }
        var t1 = q(0.25);
        var t2 = q(0.50);
        var t3 = q(0.75);
        return function (v) {
            var n = Number(v);
            if (!isFinite(n) || n <= 0) return 0;
            if (n <= t1) return 1;
            if (n <= t2) return 2;
            if (n <= t3) return 3;
            return 4;
        };
    }

    function renderMonths(monthsEl, windowDf, windowDt, activeDf, activeDt) {
        if (!monthsEl) return;
        monthsEl.innerHTML = '';
        var days = buildCalendarDays(windowDf, windowDt);
        var cols = Math.ceil(days.length / 7);
        monthsEl.style.setProperty('--rd-cols', String(cols));
        var lastMonth = null;
        for (var c = 0; c < cols; c++) {
            var pick = null;
            for (var r = 0; r < 7; r++) {
                var dx = days[c * 7 + r];
                if (!dx) continue;
                if (dx >= windowDf && dx <= windowDt) { pick = dx; break; }
            }
            if (!pick) continue;
            var m = pick.getMonth();
            if (lastMonth === null || m !== lastMonth) {
                lastMonth = m;
                var lab = document.createElement('span');
                lab.className = 'radar-density__month';
                lab.textContent = MONTHS_IT[m] || '';
                lab.style.gridColumn = String(c + 1);
                var monthStart = new Date(pick.getFullYear(), pick.getMonth(), 1);
                var monthEnd = new Date(pick.getFullYear(), pick.getMonth() + 1, 0);
                if (monthEnd >= activeDf && monthStart <= activeDt) lab.classList.add('is-in-range');
                monthsEl.appendChild(lab);
            }
        }
    }

    function renderDow(dowEl) {
        if (!dowEl) return;
        dowEl.innerHTML = '';
        for (var i = 0; i < 7; i++) {
            var s = document.createElement('span');
            s.className = 'radar-density__dow-letter';
            s.textContent = DOW_IT[i] || '';
            dowEl.appendChild(s);
        }
    }

    function buildLegend(el, clsPrefix, labels) {
        if (!el) return;
        el.innerHTML = '';
        var wrap = document.createElement('div');
        wrap.className = 'radar-density__legend-inner';
        var left = document.createElement('span');
        left.className = 'radar-density__legend-label';
        left.textContent = labels[0];
        var right = document.createElement('span');
        right.className = 'radar-density__legend-label';
        right.textContent = labels[labels.length - 1];
        wrap.appendChild(left);
        var steps = document.createElement('div');
        steps.className = 'radar-density__legend-steps';
        for (var i = 0; i < 5; i++) {
            var s = document.createElement('span');
            s.className = 'radar-density__cell ' + clsPrefix + ' level-' + i;
            s.setAttribute('aria-hidden', 'true');
            steps.appendChild(s);
        }
        wrap.appendChild(steps);
        wrap.appendChild(right);
        el.appendChild(wrap);
    }

    function renderHeatmap(gridEl, clsPrefix, windowDf, windowDt, activeDf, activeDt, seriesMap, levelForValue, valueLabelFn, onPickDay, onHoverDay) {
        if (!gridEl) return;
        gridEl.innerHTML = '';
        var days = buildCalendarDays(windowDf, windowDt);
        var cols = Math.ceil(days.length / 7);
        gridEl.style.setProperty('--rd-cols', String(cols));
        var now = new Date();
        var today0 = new Date(now.getFullYear(), now.getMonth(), now.getDate());
        days.forEach(function (d) {
            var isWindowDay = d >= windowDf && d <= windowDt;
            if (!isWindowDay) {
                var empty = document.createElement('span');
                empty.className = 'radar-density__cell is-empty';
                empty.setAttribute('aria-hidden', 'true');
                gridEl.appendChild(empty);
                return;
            }
            var iso = toISODate(d);
            var inRange = d >= activeDf && d <= activeDt;
            var isPast = d < today0;
            var val = seriesMap[iso] != null ? seriesMap[iso] : 0;
            var level = levelForValue(val);
            var btn = document.createElement('button');
            btn.type = 'button';
            btn.className = 'radar-density__cell ' + clsPrefix + ' level-' + level + (inRange ? '' : ' is-out') + (isPast ? ' is-past' : '');
            btn.disabled = !inRange;
            btn.setAttribute('data-day', iso);
            var t = iso + ': ' + valueLabelFn(val);
            btn.setAttribute('aria-label', t);
            btn.setAttribute('title', t);
            btn.addEventListener('click', function () {
                if (!inRange) return;
                onPickDay(iso);
            });
            if (typeof onHoverDay === 'function') {
                btn.addEventListener('mouseenter', function () {
                    if (!inRange) return;
                    onHoverDay(iso, btn, val);
                });
            }
            gridEl.appendChild(btn);
        });
    }

    function renderDensityHeatmapCardInto(cardEl, payload, den) {
        if (!cardEl || !den) return null;
        if (typeof window.Tabulator === 'undefined') {
            // no Tabulator → cannot do inline day table; keep card empty so summary may contain fallback link
            return null;
        }
        var metric = String(den.metric || 'count').toLowerCase();
        var df = parseISODate(den.date_from);
        var dt = parseISODate(den.date_to);
        if (!df || !dt) return null;

        var series = Array.isArray(den.series) ? den.series : [];
        var mapCount = {};
        var mapSum = {};
        var counts = [];
        var sums = [];
        series.forEach(function (it) {
            var d = String(it.date || '').slice(0, 10);
            if (!d) return;
            var c = Number(it.tenders_count || 0);
            var s = Number(it.amount_sum || 0);
            mapCount[d] = c;
            mapSum[d] = s;
            counts.push(c);
            sums.push(s);
        });
        var levelCount = quantizeLevels(counts);
        var levelSum = quantizeLevels(sums);

        var windowDf = new Date(dt.getFullYear(), dt.getMonth() - 11, 1);
        var windowDt = new Date(dt.getFullYear(), dt.getMonth(), dt.getDate());

        var wrap = document.createElement('div');
        wrap.className = 'vg-ai-result-card__density';
        cardEl.appendChild(wrap);

        var periodBox = document.createElement('div');
        periodBox.className = 'vg-ai-density-period-insight vg-markdown';
        var analysisBox = document.createElement('div');
        analysisBox.className = 'vg-ai-density-analysis vg-markdown';
        wrap.appendChild(periodBox);
        wrap.appendChild(analysisBox);
        try {
            if (den.summary && den.summary.count) {
                var ps0 = den.summary;
                var c0 = ps0.count;
                var a0 = ps0.amount || {};
                var bullets0 = [];
                if (c0.peak_day) bullets0.push('Picco **numero gare**: ' + c0.peak_day + ' (' + c0.peak_value + ' gare)');
                if (a0.peak_day) bullets0.push('Picco **importi**: ' + a0.peak_day + ' (' + formatEuroIt(a0.peak_value_eur) + ')');
                if (c0.avg_per_day != null) bullets0.push('Media giornaliera: **' + c0.avg_per_day + '** gare');
                if (a0.avg_per_day_eur != null) bullets0.push('Media importi/giorno: **' + formatEuroIt(a0.avg_per_day_eur) + '**');
                if (c0.delta_pct_vs_prev != null) {
                    bullets0.push('Gare vs periodo precedente: **' + (c0.delta_pct_vs_prev > 0 ? '+' : '') + c0.delta_pct_vs_prev + '%**');
                }
                if (a0.delta_pct_vs_prev != null) {
                    bullets0.push('Importi vs periodo precedente: **' + (a0.delta_pct_vs_prev > 0 ? '+' : '') + a0.delta_pct_vs_prev + '%**');
                }
                if (bullets0.length) {
                    periodBox.innerHTML = densityRenderMarkdownSimple('### Sintesi periodo\n\n- ' + bullets0.join('\n- '));
                }
            }
        } catch (ePs0) {}
        try {
            if (den.analysis_text_md) analysisBox.innerHTML = densityRenderMarkdownSimple(den.analysis_text_md);
        } catch (eAz0) {}

        function createBlock(kind) {
            var block = document.createElement('div');
            block.className = 'radar-density__heatmap-block';
            var titleRow = document.createElement('div');
            titleRow.className = 'radar-density__title-row';
            var h = document.createElement('h3');
            h.className = 'radar-page__table-title';
            h.textContent = kind === 'amount' ? 'Somma importi (EUR, per giorno)' : 'Numero gare (per giorno)';
            var meta = document.createElement('span');
            meta.className = 'radar-density__title-meta';
            meta.textContent = String(den.query_label || '').trim();
            titleRow.appendChild(h);
            titleRow.appendChild(meta);
            block.appendChild(titleRow);

            var leg = document.createElement('div');
            leg.className = 'radar-density__legend';
            block.appendChild(leg);

            var chart = document.createElement('div');
            chart.className = 'radar-density__chart';
            var months = document.createElement('div');
            months.className = 'radar-density__months';
            months.setAttribute('aria-hidden', 'true');
            months.setAttribute('data-months', kind);
            var dow = document.createElement('div');
            dow.className = 'radar-density__dow';
            dow.setAttribute('aria-hidden', 'true');
            var grid = document.createElement('div');
            grid.className = 'radar-density__grid';
            grid.setAttribute('role', 'grid');
            grid.setAttribute('aria-label', kind === 'amount' ? 'Heatmap somma importi' : 'Heatmap numero gare');
            chart.appendChild(months);
            chart.appendChild(dow);
            chart.appendChild(grid);
            block.appendChild(chart);

            // Keep month labels horizontally aligned with the grid when scrolling.
            try {
                var syncing = false;
                function syncScroll(src, dst) {
                    if (syncing) return;
                    syncing = true;
                    try { dst.scrollLeft = src.scrollLeft; } catch (eS) {}
                    syncing = false;
                }
                grid.addEventListener('scroll', function () { syncScroll(grid, months); });
                months.addEventListener('scroll', function () { syncScroll(months, grid); });
            } catch (eSync) {}

            return { block: block, legend: leg, months: months, dow: dow, grid: grid };
        }

        var blocks = [];
        if (metric === 'both' || metric === 'count') blocks.push({ kind: 'count' });
        if (metric === 'both' || metric === 'amount') blocks.push({ kind: 'amount' });

        var selectedDay = null;
        var dayHint = document.createElement('p');
        dayHint.className = 'radar-density__day-hint';
        dayHint.textContent = 'Clicca un giorno nella heatmap per vedere le gare.';
        wrap.appendChild(dayHint);

        var dayInsightWrap = document.createElement('div');
        dayInsightWrap.className = 'vg-ai-result-card__density-insight';
        wrap.appendChild(dayInsightWrap);

        var dayTableWrap = document.createElement('div');
        dayTableWrap.className = 'vg-ai-result-card__density-table';
        wrap.appendChild(dayTableWrap);

        var tab = null;
        var tabBuilt = false;
        var insightCache = {};
        var hoverTimer = null;
        var insightBarChart = null;

        function densityAiContext() {
            var ctx = {};
            try {
                if (window.AppaltiMap && window.AppaltiMap._map && typeof window.AppaltiMap._map.getBounds === 'function') {
                    var b = window.AppaltiMap._map.getBounds();
                    ctx.bbox = [b.getWest(), b.getSouth(), b.getEast(), b.getNorth()].join(',');
                    ctx.zoom = Math.floor(Number(window.AppaltiMap._map.getZoom())) || 0;
                }
            } catch (e0) {}
            try {
                var geom = window.AppaltiMap && window.AppaltiMap._savedAreaGeojson;
                if (geom && geom.type === 'Polygon' && geom.coordinates && geom.coordinates.length) {
                    var ring = geom.coordinates[0] || [];
                    var minLon = 999, minLat = 999, maxLon = -999, maxLat = -999;
                    ring.forEach(function (p) {
                        if (!p || p.length < 2) return;
                        var lon = Number(p[0]);
                        var lat = Number(p[1]);
                        if (isNaN(lon) || isNaN(lat)) return;
                        minLon = Math.min(minLon, lon);
                        minLat = Math.min(minLat, lat);
                        maxLon = Math.max(maxLon, lon);
                        maxLat = Math.max(maxLat, lat);
                    });
                    if (minLon <= maxLon && minLat <= maxLat) {
                        ctx.bbox_saved_area = [minLon, minLat, maxLon, maxLat].join(',');
                    }
                }
            } catch (e1) {}
            try { ctx.outcomes = (typeof getSelectedOutcomes === 'function') ? getSelectedOutcomes().join(',') : ''; } catch (e2) {}
            try { ctx.cpv = (typeof getCpvFilterStringForAiContext === 'function') ? getCpvFilterStringForAiContext() : ''; } catch (e3) {}
            try { ctx.member_uuid = getMemberUuidFromDom(); } catch (e4) {}
            try {
                var mid = getMemberIdFromDom();
                if (mid) ctx.member_id = mid;
            } catch (e5) {}
            return ctx;
        }

        function densityInsightApiUrl() {
            return (String(getApiBaseFromDom() || '').replace(/\/+$/, '') || '') + '/ai/density-day-insight';
        }

        function renderInsightPanel(ins) {
            dayInsightWrap.innerHTML = '';
            if (!ins) return;
            var pctRaw = ins.top3_amount_share != null ? Number(ins.top3_amount_share) : 0;
            var pct = Math.round(pctRaw * 1000) / 10;
            var head = document.createElement('div');
            head.className = 'vg-ai-density-day-head vg-markdown';
            head.innerHTML = densityRenderMarkdownSimple(
                '**' + ins.day_iso + '** · ' + ins.tenders_count + ' gare · Totale ' + formatEuroIt(ins.amount_sum_eur) +
                    ' · Media ' + formatEuroIt(ins.amount_avg_eur) + ' · Mediana ' + formatEuroIt(ins.amount_median_eur) +
                    ' · Top 3 sul valore: **' + pct + '%**'
            );
            dayInsightWrap.appendChild(head);

            var conc = document.createElement('div');
            conc.className = 'vg-ai-density-conc';
            var pFill = Math.min(100, Math.max(0, pct));
            conc.innerHTML = '<div class="vg-ai-density-conc-label">Concentrazione valore (top 3 gare)</div>' +
                '<div class="vg-ai-density-conc-bar" role="progressbar" aria-valuenow="' + pFill + '" aria-valuemin="0" aria-valuemax="100">' +
                '<span style="width:' + pFill + '%"></span></div>';
            dayInsightWrap.appendChild(conc);

            // Dedicated wrapper: Chart.js (maintainAspectRatio:false) sizes to parent; if the canvas
            // parent is the full insight panel, the chart stretches to the whole column height.
            var chartWrap = document.createElement('div');
            chartWrap.className = 'vg-ai-density-insight-chart-wrap';
            var canvas = document.createElement('canvas');
            canvas.className = 'vg-ai-density-insight-chart';
            chartWrap.appendChild(canvas);
            dayInsightWrap.appendChild(chartWrap);

            if (insightBarChart && typeof insightBarChart.destroy === 'function') {
                try { insightBarChart.destroy(); } catch (eD) {}
            }
            insightBarChart = null;
            if (typeof window.Chart !== 'undefined' && ins.histogram && ins.histogram.length) {
                var labels = ins.histogram.map(function (h) { return h.bucket_label; });
                var counts = ins.histogram.map(function (h) { return Number(h.count || 0); });
                insightBarChart = new window.Chart(canvas.getContext('2d'), {
                    type: 'bar',
                    data: {
                        labels: labels,
                        datasets: [{
                            label: 'Gare per fascia di importo',
                            data: counts,
                            backgroundColor: 'rgba(37,99,235,0.45)',
                            borderColor: 'rgba(37,99,235,1)',
                            borderWidth: 1
                        }]
                    },
                    options: {
                        responsive: true,
                        maintainAspectRatio: false,
                        plugins: { legend: { display: false } },
                        scales: { y: { beginAtZero: true, ticks: { precision: 0 } } }
                    }
                });
            }

            if (ins.top_tenders && ins.top_tenders.length) {
                var ul = document.createElement('ul');
                ul.className = 'vg-ai-density-top-tenders';
                ins.top_tenders.forEach(function (t, idx) {
                    var li = document.createElement('li');
                    var amt = formatEuroIt(t.amount_eur);
                    var href = (t.procedure_url_path || '').trim();
                    if (!href && t.procedure_id) {
                        var slug = String(t.procedure_id).toLowerCase().trim()
                            .replace(/[^a-z0-9-]/g, '-')
                            .replace(/-+/g, '-')
                            .replace(/^-|-$/g, '');
                        if (slug) href = '/procedura-' + slug + '/';
                    }
                    var title = densityEscapeHtml(String(t.title || '—').slice(0, 140));
                    var buyer = densityEscapeHtml(t.buyer_name || '');
                    li.className = 'vg-density-top-tenders__item';
                    li.innerHTML =
                        '<span class="vg-density-top-rank" aria-hidden="true">' + (idx + 1) + '</span>' +
                        '<span class="vg-density-top-tenders__body">' + amt + (href
                            ? ' — <a href="' + densityEscapeHtml(href) + '" target="_blank" rel="noopener">' + title + '</a>'
                            : ' — ' + title) + (buyer ? ' <span class="vg-ai-density-buyer">(' + buyer + ')</span>' : '') +
                        '</span>';
                    ul.appendChild(li);
                });
                dayInsightWrap.appendChild(ul);
            }

            if (ins.cpv_breakdown && ins.cpv_breakdown.length) {
                var cpvEl = document.createElement('div');
                cpvEl.className = 'vg-ai-density-cpv';
                var cpvHtml = '<p class="radar-density__cpv-top-title"><strong>CPV (top)</strong></p><ul class="radar-density__cpv-top-list">';
                ins.cpv_breakdown.forEach(function (r) {
                    var crumb = (r && r.cpv_breadcrumb_html) ? String(r.cpv_breadcrumb_html) : '';
                    if (!crumb) {
                        crumb = '<code class="radar-density__cpv-code-fallback">' + densityEscapeHtml(r.cpv_prefix || '—') + '</code>';
                    }
                    cpvHtml +=
                        '<li class="radar-density__cpv-top-item">' +
                        '<span class="radar-density__cpv-crumb">' + crumb + '</span>' +
                        ' <span class="radar-density__cpv-top-meta">· ' + formatEuroIt(r.amount_sum_eur) + ' · ' + r.tenders_count + ' gare</span>' +
                        '</li>';
                });
                cpvHtml += '</ul>';
                cpvEl.innerHTML = cpvHtml;
                dayInsightWrap.appendChild(cpvEl);
            }
        }

        function loadInsight(dayIso, cb) {
            if (insightCache[dayIso]) {
                cb(insightCache[dayIso]);
                return;
            }
            var headers = { Accept: 'application/json', 'Content-Type': 'application/json' };
            var body = { day: dayIso, conversation_state: payload.conversation_state || {}, context: densityAiContext() };
            fetch(densityInsightApiUrl(), { method: 'POST', headers: headers, body: JSON.stringify(body) })
                .then(function (r) { return r.ok ? r.json() : Promise.reject(new Error('insight')); })
                .then(function (j) {
                    var ins = j && j.insight ? j.insight : null;
                    if (ins) insightCache[dayIso] = ins;
                    cb(ins);
                })
                .catch(function () { cb(null); });
        }

        function onHoverCell(dayIso, btn) {
            if (hoverTimer) clearTimeout(hoverTimer);
            hoverTimer = setTimeout(function () {
                loadInsight(dayIso, function (ins) {
                    if (!ins || !btn) return;
                    var pctR = ins.top3_amount_share != null ? Number(ins.top3_amount_share) : 0;
                    var pct = Math.round(pctR * 1000) / 10;
                    btn.setAttribute('title',
                        dayIso + '\nGare: ' + ins.tenders_count +
                        '\nTotale: ' + formatEuroIt(ins.amount_sum_eur) +
                        '\nMedia: ' + formatEuroIt(ins.amount_avg_eur) +
                        '\nMediana: ' + formatEuroIt(ins.amount_median_eur) +
                        '\nTop3 valore: ' + pct + '%');
                });
            }, 220);
        }

        function setSelectedDayLabel(dayIso) {
            dayHint.textContent = dayIso ? ('Gare con scadenza: ' + dayIso) : 'Clicca un giorno nella heatmap per vedere le gare.';
        }
        function highlightSelectedDay(dayIso) {
            try {
                wrap.querySelectorAll('.radar-density__cell.is-selected').forEach(function (b) { b.classList.remove('is-selected'); });
                if (!dayIso) return;
                wrap.querySelectorAll('.radar-density__cell[data-day="' + dayIso + '"]').forEach(function (b) { b.classList.add('is-selected'); });
            } catch (eH) {}
        }

        function buildDayTabulator() {
            if (tab) return tab;
            dayTableWrap.innerHTML = '';
            tab = new window.Tabulator(dayTableWrap, {
                layout: 'fitColumns',
                placeholder: 'Seleziona un giorno per vedere le gare',
                height: 360,
                index: 'ted_id',
                rowClick: function (e, row) {
                    try {
                        var t = e && e.target;
                        if (t && t.closest && t.closest('a')) return;
                        if (t && t.closest && t.closest('[data-vg-kanban-lamp]')) return;
                    } catch (ignore) {}
                    var data = row && row.getData ? (row.getData() || {}) : {};
                    var href = '';
                    try {
                        href = String(data.procedure_url_path || '').trim();
                    } catch (eP) { href = ''; }
                    // Normalize relative paths.
                    try {
                        if (href && href.charAt(0) === '/' && window.location && window.location.origin) {
                            href = window.location.origin.replace(/\/+$/, '') + href;
                        }
                    } catch (eAbs0) {}
                    if (!href) {
                        try {
                            var procId = data && data.procedure_id ? String(data.procedure_id).trim() : '';
                            if (procId) {
                                var slug = procId.toLowerCase().trim()
                                    .replace(/[^a-z0-9\\-]/g, '-')
                                    .replace(/-+/g, '-')
                                    .replace(/^-|-$/g, '');
                                var base = (typeof window !== 'undefined' && window.location && window.location.origin) ? window.location.origin : '';
                                if (slug) href = (base || '') + '/procedura-' + slug + '/';
                            }
                        } catch (eSlug) {}
                    }
                    if (href) {
                        // Avoid popup blockers: same-tab navigation. Ctrl/Cmd click opens a new tab.
                        if (e && (e.metaKey || e.ctrlKey)) {
                            window.open(href, '_blank', 'noopener');
                        } else {
                            window.location.href = href;
                        }
                        return;
                    }
                    var tid = data && data.ted_id ? String(data.ted_id).trim() : '';
                    if (tid) {
                        var tedHref = '/ted-' + encodeURIComponent(tid) + '/';
                        if (e && (e.metaKey || e.ctrlKey)) {
                            window.open(tedHref, '_blank', 'noopener');
                        } else {
                            window.location.href = tedHref;
                        }
                    }
                },
                pagination: true,
                paginationMode: 'remote',
                paginationSize: 25,
                paginationSizeSelector: [25, 50, 100, 200],
                ajaxURL: (String(getApiBaseFromDom() || '').replace(/\/+$/, '') || '') + '/ai/density-day-page',
                ajaxConfig: 'POST',
                ajaxContentType: 'json',
                // Tabulator 6: do not pin page here — merge would fight remote pagination params.
                ajaxParams: function () {
                    return {};
                },
                ajaxRequestFunc: function (url, config, params) {
                    var pageNum = params && params.page ? Number(params.page) : 1;
                    if (!isFinite(pageNum) || pageNum < 1) pageNum = 1;
                    if (!selectedDay) {
                        return Promise.resolve({ data: [], last_page: 1, current_page: pageNum });
                    }
                    var headers = { Accept: 'application/json', 'Content-Type': 'application/json' };
                    // This endpoint uses member_id/member_uuid (context) for paid checks; no Bearer token needed.
                    var body = {
                        page: pageNum,
                        size: params && params.size ? params.size : 25,
                        day: selectedDay,
                        conversation_state: payload.conversation_state || {},
                        context: densityAiContext()
                    };
                    return fetch(url, { method: 'POST', headers: headers, body: JSON.stringify(body) })
                        .then(function (r) { return r.ok ? r.json() : r.text().then(function (t2) { throw new Error(t2 || ('HTTP ' + r.status)); }); })
                        .then(function (j) {
                            var rows = Array.isArray(j && j.data) ? j.data : [];
                            var lp = j && j.last_page != null ? Number(j.last_page) : 1;
                            if (!isFinite(lp) || lp < 1) lp = 1;
                            return { data: rows, last_page: lp, current_page: pageNum };
                        });
                },
                dataSendParams: { page: 'page', size: 'size' },
                dataReceiveParams: { data: 'data', last_page: 'last_page', current_page: 'current_page' },
                columns: [
                    {
                        title: '',
                        field: '_vg_lamp',
                        width: 44,
                        hozAlign: 'center',
                        headerSort: false,
                        formatter: function (c) {
                            return window.VistaGareKanbanLamp
                                ? window.VistaGareKanbanLamp.formatterCell(c.getRow().getData())
                                : '';
                        }
                    },
                    {
                        title: 'Scadenza',
                        field: 'tender_period_end',
                        width: 130,
                        formatter: function (c) {
                            var v = c.getValue();
                            return v ? String(v).slice(0, 10) : '—';
                        }
                    },
                    {
                        title: 'Procedura',
                        field: 'procedure_id',
                        minWidth: 170,
                        formatter: function (c) {
                            var row = c.getRow().getData() || {};
                            var procId = row.procedure_id ? String(row.procedure_id).trim() : '';
                            if (!procId) return '—';
                            var href = '';
                            try { href = String(row.procedure_url_path || '').trim(); } catch (eP2) { href = ''; }
                            if (!href) {
                                var slug = procId.toLowerCase().trim()
                                    .replace(/[^a-z0-9\\-]/g, '-')
                                    .replace(/-+/g, '-')
                                    .replace(/^-|-$/g, '');
                                if (slug) href = '/procedura-' + slug + '/';
                            }
                            return href
                                ? ('<a href="' + href + '" target="_blank" rel="noopener">' + procId + '</a>')
                                : procId;
                        }
                    },
                    {
                        title: 'Titolo',
                        field: 'title',
                        minWidth: 260,
                        formatter: function (c) {
                            var row = c.getRow().getData() || {};
                            var t = row.title || '—';
                            var procHref = '';
                            try { procHref = String(row.procedure_url_path || '').trim(); } catch (eP3) { procHref = ''; }
                            if (!procHref) {
                                var procId = row.procedure_id ? String(row.procedure_id).trim() : '';
                                if (procId) {
                                    var slug = procId.toLowerCase().trim()
                                        .replace(/[^a-z0-9\\-]/g, '-')
                                        .replace(/-+/g, '-')
                                        .replace(/^-|-$/g, '');
                                    if (slug) procHref = '/procedura-' + slug + '/';
                                }
                            }
                            if (procHref) {
                                return '<a href="' + procHref + '" target="_blank" rel="noopener">' + String(t) + '</a>';
                            }
                            var tid = row.ted_id ? String(row.ted_id).trim() : '';
                            if (tid) {
                                var href = '/ted-' + encodeURIComponent(tid) + '/';
                                return '<a href="' + href + '" target="_blank" rel="noopener">' + String(t) + '</a>';
                            }
                            return String(t);
                        }
                    },
                    { title: 'Ente', field: 'buyer_name', minWidth: 180 },
                    {
                        title: 'Importo',
                        field: 'amount',
                        width: 140,
                        hozAlign: 'right',
                        formatter: function (c) { return formatEuroIt(c.getValue()); }
                    },
                    { title: 'Indirizzo', field: 'address', minWidth: 200 }
                ]
            });
            try {
                tab.on('tableBuilt', function () {
                    tabBuilt = true;
                    if (window.VistaGareKanbanLamp && tab) {
                        window.VistaGareKanbanLamp.wireTabulator(tab);
                    }
                    if (selectedDay) {
                        try { tab.setData(); } catch (eSet0) {}
                    }
                });
            } catch (eOn) {}
            return tab;
        }

        function pickDay(dayIso) {
            selectedDay = dayIso;
            setSelectedDayLabel(dayIso);
            highlightSelectedDay(dayIso);
            loadInsight(dayIso, function (ins) { renderInsightPanel(ins); });
            var t2 = buildDayTabulator();
            if (t2 && tabBuilt) {
                try { t2.setData(); } catch (eSet1) {}
            }
        }

        blocks.forEach(function (b) {
            var ui = createBlock(b.kind);
            wrap.insertBefore(ui.block, dayHint);
            if (b.kind === 'count') {
                buildLegend(ui.legend, 'rd-count', ['meno gare', 'più gare']);
                renderMonths(ui.months, windowDf, windowDt, df, dt);
                renderDow(ui.dow);
                renderHeatmap(ui.grid, 'rd-count', windowDf, windowDt, df, dt, mapCount, levelCount, function (v) { return (Number(v) || 0).toLocaleString('it-IT'); }, pickDay, onHoverCell);
            } else {
                buildLegend(ui.legend, 'rd-amount', ['importo minore', 'importo maggiore']);
                renderMonths(ui.months, windowDf, windowDt, df, dt);
                renderDow(ui.dow);
                renderHeatmap(ui.grid, 'rd-amount', windowDf, windowDt, df, dt, mapSum, levelSum, function (v) { return formatEuroIt(v); }, pickDay, onHoverCell);
            }
        });

        return { tab: tab, insightChart: function () { return insightBarChart; } };
    }

    
    function buildAppaltiMapBaseStyle() {
        return {
            version: 8,
            sources: {
                osm: {
                    type: 'raster',
                    tiles: ['https://tile.openstreetmap.org/{z}/{x}/{y}.png'],
                    tileSize: 256,
                    attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                }
            },
            layers: [{ id: 'osm-tiles', type: 'raster', source: 'osm', minzoom: 0, maxzoom: 19 }]
        };
    }

    function europeBoundsLngLat() {
        // Rough bbox for Europe (generous margin). Used to prevent "zoom to world".
        return [[-25.0, 30.0], [45.0, 72.0]];
    }

    function expandBounds(bounds, factor) {
        factor = Number(factor || 1);
        if (!bounds || bounds.length !== 2 || factor <= 0) return bounds;
        var sw = bounds[0], ne = bounds[1];
        var w = Number(sw[0]), s = Number(sw[1]), e = Number(ne[0]), n = Number(ne[1]);
        if (!isFinite(w) || !isFinite(s) || !isFinite(e) || !isFinite(n)) return bounds;
        var cx = (w + e) / 2;
        var cy = (s + n) / 2;
        var hw = ((e - w) / 2) * factor;
        var hh = ((n - s) / 2) * factor;
        return [[cx - hw, cy - hh], [cx + hw, cy + hh]];
    }

    function clampMapToEurope(map) {
        if (!map) return;
        var EU = europeBoundsLngLat();
        try {
            if (map.setMaxBounds) map.setMaxBounds(EU);
        } catch (eB) {}
        try {
            // Prevent zooming out beyond a full-Europe view.
            if (map.cameraForBounds && map.setMinZoom) {
                var cam = map.cameraForBounds(EU, { padding: vgMapFitPaddingPx() });
                if (cam && isFinite(cam.zoom)) {
                    map.setMinZoom(Math.max(0, cam.zoom - 0.25));
                }
            }
        } catch (eZ) {}
    }

    function createMap(mapEl) {
        if (!window.maplibregl) {
            throw new Error('MapLibre GL JS not loaded');
        }

        var map = new window.maplibregl.Map({
            container: mapEl.id || mapEl,
            style: buildAppaltiMapBaseStyle(),
            center: [12.5, 42.5],
            zoom: 6
        });

        map.once('load', function () {
            clampMapToEurope(map);
        });
        window.addEventListener('resize', function () {
            // Recompute minZoom after viewport changes (e.g. orientation/fullscreen).
            try { clampMapToEurope(map); } catch (eR) {}
        }, { passive: true });
        document.addEventListener('fullscreenchange', function () {
            try { clampMapToEurope(map); } catch (eF) {}
        });

        // Zoom + rotation (top-right)
        map.addControl(new window.maplibregl.NavigationControl(), 'top-right');

        // Layer list (top-right, below zoom)
        var layerListEl = document.createElement('div');
        layerListEl.className = 'maplibregl-ctrl appaltimap-layer-list';
        layerListEl.innerHTML =
            '<button type="button" class="appaltimap-layer-list-toggle" title="Layers" aria-label="Layers" aria-expanded="false">&#x2630; Layers</button>' +
            '<div class="appaltimap-layer-list-panel" role="region" aria-label="Map layers" hidden>' +
            '<div class="appaltimap-layer-list-item appaltimap-layer-list-item--base">OpenStreetMap (base)</div>' +
            '<label class="appaltimap-layer-list-item"><input type="checkbox" checked data-layer="regioni-italiane"> Regioni italiane</label>' +
            '<label class="appaltimap-layer-list-item"><input type="checkbox" checked data-layer="appaltimap-clusters"> Tenders (clusters)</label>' +
            '</div>';
        var toggleBtn = layerListEl.querySelector('.appaltimap-layer-list-toggle');
        var panel = layerListEl.querySelector('.appaltimap-layer-list-panel');
        toggleBtn.addEventListener('click', function () {
            var isHidden = panel.hidden;
            panel.hidden = !isHidden;
            toggleBtn.setAttribute('aria-expanded', isHidden ? 'true' : 'false');
        });
        layerListEl.querySelectorAll('input[data-layer]').forEach(function (input) {
            input.addEventListener('change', function () {
                var layerId = input.getAttribute('data-layer');
                var visible = input.checked ? 'visible' : 'none';
                var layersToSet = layerId === 'regioni-italiane'
                    ? ['regioni-italiane-fill', 'regioni-italiane-line']
                    : [layerId];
                layersToSet.forEach(function (id) {
                    if (map.getLayer(id)) map.setLayoutProperty(id, 'visibility', visible);
                });
            });
        });
        map.addControl({ onAdd: function () { return layerListEl; }, onRemove: function () {} }, 'top-right');

        // Scale (bottom-left)
        map.addControl(new window.maplibregl.ScaleControl({ unit: 'metric' }), 'bottom-left');

        // Fullscreen + Geolocate (bottom-right)
        var wrap = mapEl.closest('.appaltimap-map-wrap');
        var fsDiv = document.createElement('div');
        fsDiv.className = 'maplibregl-ctrl maplibregl-ctrl-group appaltimap-ctrl-group';
        var fsBtn = document.createElement('button');
        fsBtn.type = 'button';
        fsBtn.className = 'appaltimap-ctrl appaltimap-ctrl-fullscreen';
        fsBtn.setAttribute('aria-label', 'Fullscreen');
        fsBtn.title = 'Fullscreen';
        fsBtn.innerHTML = '&#x26F6;';
        if (wrap) {
            fsBtn.addEventListener('click', function () {
                if (!document.fullscreenElement) {
                    wrap.requestFullscreen().catch(function () {});
                } else {
                    document.exitFullscreen();
                }
            });
        }
        fsDiv.appendChild(fsBtn);
        map.addControl({ onAdd: function () { return fsDiv; }, onRemove: function () {} }, 'bottom-right');

        var geolocate = new window.maplibregl.GeolocateControl({
            positionOptions: { enableHighAccuracy: true },
            trackUserLocation: true,
            showUserHeading: true
        });
        geolocate.on('error', function () {
            setStatus('Location unavailable');
        });
        map.addControl(geolocate, 'bottom-right');

        map.on('load', function () {
            var REGIONI_GEOJSON = 'https://raw.githubusercontent.com/openpolis/geojson-italy/master/geojson/limits_IT_regions.geojson';
            map.addSource('regioni-italiane', {
                type: 'geojson',
                data: REGIONI_GEOJSON
            });
            map.addLayer({
                id: 'regioni-italiane-fill',
                type: 'fill',
                source: 'regioni-italiane',
                paint: {
                    'fill-color': 'rgba(180, 200, 220, 0.15)',
                    'fill-outline-color': 'rgba(80, 100, 120, 0.6)'
                }
            });
            map.addLayer({
                id: 'regioni-italiane-line',
                type: 'line',
                source: 'regioni-italiane',
                paint: {
                    'line-color': 'rgba(60, 80, 100, 0.7)',
                    'line-width': 1.2
                }
            });

            map.addSource('appaltimap-clusters', {
                type: 'geojson',
                data: { type: 'FeatureCollection', features: [] }
            });
            map.addLayer({
                id: 'appaltimap-clusters',
                type: 'circle',
                source: 'appaltimap-clusters',
                paint: {
                    'circle-radius': ['interpolate', ['linear'], ['get', 'count'], 0, 8, 100, 20, 1000, 28],
                    // Default (will be overridden by applyClusterColorForOutcome after first render).
                    'circle-color': '#1b6fff',
                    'circle-stroke-width': 2,
                    'circle-stroke-color': '#1b6fff',
                    'circle-opacity': 0.25
                }
            });

            map.addSource('appaltimap-regional-clusters', {
                type: 'geojson',
                data: { type: 'FeatureCollection', features: [] }
            });
            ensureRegionalTriangleImage(map);
            map.addLayer({
                id: 'appaltimap-regional-clusters',
                type: 'symbol',
                source: 'appaltimap-regional-clusters',
                layout: {
                    'icon-image': 'vg-regional-triangle',
                    'icon-size': ['interpolate', ['linear'], ['get', 'count'], 1, 0.55, 50, 0.85, 500, 1.15],
                    'icon-allow-overlap': true,
                    'icon-ignore-placement': true
                },
                paint: {
                    'icon-opacity': 0.9
                }
            });
        });

        map.on('error', function (e) {
            if (e && e.error) setStatus('Map error');
        });

        return map;
    }

    
    function boundsToBbox(map) {
        var b = map.getBounds();
        return [b.getWest(), b.getSouth(), b.getEast(), b.getNorth()].join(',');
    }

    function getSelectedOutcomes() {
        var inputs = document.querySelectorAll('.appaltimap-filter-input');
        var selected = [];
        inputs.forEach(function (input) {
            if (input.checked) {
                var v = input.getAttribute('data-outcome');
                if (v) selected.push(v);
            }
        });
        return selected;
    }

    /** Esiti per API mappa: rispetta i filtri UI; «scadute» include anche deserted lato Map Engine. */
    function buildOutcomesCsv(selectedOutcomes) {
        var out = (selectedOutcomes || []).slice(0);
        if (!out.length) return '';
        if (out.indexOf('expired_unawarded') !== -1 && out.indexOf('deserted') === -1) {
            out.push('deserted');
        }
        return out.join(',');
    }

    var OUTCOME_STORAGE_KEY = 'vg-map-outcome';
    var REGIONAL_STORAGE_KEY = 'vg-map-show-regional-gare';

    function applyRegionalGareGate() {
        var wrap = document.getElementById('appaltimap-regional-toggle-wrap');
        if (wrap) wrap.removeAttribute('hidden');
    }

    function ensureRegionalTriangleImage(map) {
        if (!map || map.hasImage('vg-regional-triangle')) return;
        var size = 32;
        var canvas = document.createElement('canvas');
        canvas.width = size;
        canvas.height = size;
        var ctx = canvas.getContext('2d');
        if (!ctx) return;
        ctx.clearRect(0, 0, size, size);
        ctx.fillStyle = '#d97706';
        ctx.strokeStyle = '#92400e';
        ctx.lineWidth = 1.5;
        ctx.beginPath();
        ctx.moveTo(size / 2, size - 4);
        ctx.lineTo(4, 6);
        ctx.lineTo(size - 4, 6);
        ctx.closePath();
        ctx.fill();
        ctx.stroke();
        var img = ctx.getImageData(0, 0, size, size);
        map.addImage('vg-regional-triangle', img, { pixelRatio: 2 });
    }

    function isRegionalGareEnabled() {
        var el = document.getElementById('appaltimap-regional-toggle');
        return !!(el && el.checked);
    }

    function isRegionalMapTender(t) {
        if (!t) return false;
        var src = String(t.source || '');
        if (src.indexOf('regional_') === 0) return true;
        var pid = String(t.procedure_id || '');
        return pid.indexOf('regional:') === 0;
    }

    function syncRegionalToggleVisualState() {
        var wrap = document.getElementById('appaltimap-regional-toggle-wrap');
        var el = document.getElementById('appaltimap-regional-toggle');
        if (!wrap || !el) return;
        wrap.classList.toggle('appaltimap-filter--regional-off', !el.checked);
        el.setAttribute('aria-pressed', el.checked ? 'true' : 'false');
    }

    function loadSavedRegionalToggle() {
        try {
            return window.localStorage.getItem(REGIONAL_STORAGE_KEY) === '1';
        } catch (e) {
            return false;
        }
    }

    function saveRegionalToggle(on) {
        try {
            window.localStorage.setItem(REGIONAL_STORAGE_KEY, on ? '1' : '0');
        } catch (e) {}
    }

    function applySavedRegionalToggle() {
        applyRegionalGareGate();
        var el = document.getElementById('appaltimap-regional-toggle');
        if (!el) return;
        el.checked = loadSavedRegionalToggle();
        syncRegionalToggleVisualState();
    }

    function loadSavedPrimaryOutcome() {
        try {
            return String(window.localStorage.getItem(OUTCOME_STORAGE_KEY) || '').trim();
        } catch (e) {
            return '';
        }
    }

    function savePrimaryOutcome(outcome) {
        try {
            window.localStorage.setItem(OUTCOME_STORAGE_KEY, String(outcome || ''));
        } catch (e) {}
    }

    function applySavedOutcomeSelection() {
        var saved = loadSavedPrimaryOutcome();
        if (!saved) return;
        var inputs = document.querySelectorAll('.appaltimap-filter-input');
        var found = false;
        inputs.forEach(function (input) {
            var v = input.getAttribute('data-outcome') || '';
            if (v === saved) {
                input.checked = true;
                found = true;
            } else {
                input.checked = false;
            }
        });
        return found;
    }

    function stripTrailingZerosToPrefix(code) {
        var s = String(code || '').replace(/\D/g, '');
        if (!s) return '';
        if (s.length > 8) s = s.slice(0, 8);
        s = s.replace(/0+$/g, '');
        return s;
    }

    function getCpvPrefix() {
        var el = document.getElementById('appaltimap-cpv-prefix');
        if (!el) return '';
        var v = String(el.value || '').trim();
        // '0' is not a meaningful prefix; treat it as empty (no filter).
        if (!v || v === '0') return '';
        return v;
    }

    /** Same normalization as the CPV search box → hidden prefix (digits, max 8, strip trailing zeros). */
    function normalizeCpvDigitsForApi(raw) {
        var digits = String(raw || '').replace(/\D/g, '');
        if (!digits) return '';
        if (digits.length > 8) digits = digits.slice(0, 8);
        var prefix = digits.replace(/0+$/g, '');
        if (!prefix) prefix = digits;
        if (prefix === '0') return '';
        return prefix;
    }

    /** Se più prefissi CPV sono incollati senza separatori (es. 4541114814812), prova partizioni 4-blocchi come il gateway. */
    var FOUR_PART_CPV_GLUE_PATTERNS = [
        [2, 4, 3, 4],
        [2, 4, 4, 4],
        [2, 4, 4, 3],
        [2, 3, 4, 4],
        [2, 2, 4, 4]
    ];

    function splitConcatenatedCompanyCpvDigits(digits) {
        var d = String(digits || '').replace(/\D/g, '');
        if (d.length < 10 || d.length > 24) return [];
        var pi, lens, sum, i, ln, parts, pos, chunk, stripped;
        for (pi = 0; pi < FOUR_PART_CPV_GLUE_PATTERNS.length; pi++) {
            lens = FOUR_PART_CPV_GLUE_PATTERNS[pi];
            sum = lens[0] + lens[1] + lens[2] + lens[3];
            if (sum !== d.length) continue;
            parts = [];
            pos = 0;
            for (i = 0; i < 4; i++) {
                ln = lens[i];
                chunk = d.slice(pos, pos + ln);
                pos += ln;
                stripped = chunk.replace(/^0+/, '') || chunk;
                if (stripped) parts.push(stripped);
            }
            if (parts.length === 4) return parts;
        }
        return [];
    }

    function prefixesFromOneCompanyCpvCode(code) {
        var out = [];
        var seenLocal = {};
        String(code || '').trim().split(/[,;\s]+/).forEach(function (piece) {
            piece = String(piece || '').trim();
            if (!piece) return;
            var d = piece.replace(/\D/g, '');
            if (!d) return;
            var list;
            if (d.length > 8) {
                var ch = splitConcatenatedCompanyCpvDigits(d);
                list = ch && ch.length ? ch : [];
            } else {
                list = [d];
            }
            list.forEach(function (raw) {
                var p = normalizeCpvDigitsForApi(raw);
                if (!p || seenLocal[p]) return;
                seenLocal[p] = true;
                out.push(p);
            });
        });
        return out;
    }

    function companyCpvPrefixesFromBundle(cpvRows) {
        var seen = {};
        var out = [];
        (cpvRows || []).forEach(function (row) {
            prefixesFromOneCompanyCpvCode(row && row.cpv_code).forEach(function (p) {
                if (!p || seen[p]) return;
                seen[p] = true;
                out.push(p);
            });
        });
        return out;
    }

    function getCpvFilterParamsForMap() {
        try {
            if (window.AppaltiMap && window.AppaltiMap._homeMapAreaMode === 'company') {
                var prefs = window.AppaltiMap._homeCompanyCpvPrefixes;
                if (!prefs || !prefs.length) return {};
                return { cpv_prefixes: prefs.join(',') };
            }
        } catch (e) { /* ignore */ }
        var p = getCpvPrefix();
        return p ? { cpv: p } : {};
    }

    function getCpvFilterStringForAiContext() {
        var o = getCpvFilterParamsForMap();
        if (o.cpv_prefixes) return o.cpv_prefixes;
        if (o.cpv) return o.cpv;
        return '';
    }

    window.AppaltiMap.getBugReportMapContext = function () {
        var ctx = { available: false };
        if (!window.AppaltiMap || !window.AppaltiMap._map) return ctx;
        ctx.available = true;
        var map = window.AppaltiMap._map;
        try {
            var b = map.getBounds();
            ctx.bbox = [b.getWest(), b.getSouth(), b.getEast(), b.getNorth()];
            ctx.zoom = Math.floor(Number(map.getZoom())) || 0;
            var center = map.getCenter();
            ctx.center = { lng: center.lng, lat: center.lat };
        } catch (e0) {}
        var layers = [];
        try {
            document.querySelectorAll('.appaltimap-layer-list input[data-layer]').forEach(function (inp) {
                if (inp.checked) layers.push(inp.getAttribute('data-layer'));
            });
        } catch (e1) {}
        ctx.activeLayers = layers;
        try {
            ctx.outcomes = getSelectedOutcomes();
        } catch (e2) {
            ctx.outcomes = [];
        }
        try {
            ctx.cpv = getCpvFilterStringForAiContext();
        } catch (e3) {
            ctx.cpv = '';
        }
        ctx.homeMapAreaMode = window.AppaltiMap._homeMapAreaMode || null;
        ctx.telegramNotifyMode = window.AppaltiMap._telegramNotifyMode || null;
        ctx.savedAreaPresent = !!(window.AppaltiMap._savedAreaGeojson);
        if (window.AppaltiMap._savedAreaGeojson) {
            try {
                var geom = window.AppaltiMap._savedAreaGeojson;
                if (geom.type === 'Polygon' && geom.coordinates && geom.coordinates[0]) {
                    var ring = geom.coordinates[0];
                    var minLon = 999, minLat = 999, maxLon = -999, maxLat = -999;
                    ring.forEach(function (p) {
                        if (!p || p.length < 2) return;
                        var lon = Number(p[0]);
                        var lat = Number(p[1]);
                        if (isNaN(lon) || isNaN(lat)) return;
                        minLon = Math.min(minLon, lon);
                        minLat = Math.min(minLat, lat);
                        maxLon = Math.max(maxLon, lon);
                        maxLat = Math.max(maxLat, lat);
                    });
                    if (minLon <= maxLon && minLat <= maxLat) {
                        ctx.savedAreaBbox = [minLon, minLat, maxLon, maxLat];
                    }
                }
            } catch (e4) {}
        }
        var cpvQ = document.getElementById('appaltimap-cpv-query');
        var cpvP = document.getElementById('appaltimap-cpv-prefix');
        if (cpvQ) ctx.cpvQuery = cpvQ.value || '';
        if (cpvP) ctx.cpvPrefix = cpvP.value || '';
        return ctx;
    };

    function applyHomeMapCpvToolbarForMode() {
        var wrap = document.querySelector('.appaltimap-cpv-wrap');
        var cpvInput = document.getElementById('appaltimap-cpv-query');
        var cpvPrefixEl = document.getElementById('appaltimap-cpv-prefix');
        var cpvClearBtn = document.getElementById('appaltimap-cpv-clear');
        if (!cpvInput || !cpvPrefixEl) return;
        var company = window.AppaltiMap && window.AppaltiMap._homeMapAreaMode === 'company';
        if (company) {
            if (!window.AppaltiMap._cpvExploreUiBackup) {
                window.AppaltiMap._cpvExploreUiBackup = {
                    input: cpvInput.value,
                    prefix: cpvPrefixEl.value
                };
            }
            var prefs = window.AppaltiMap._homeCompanyCpvPrefixes || [];
            cpvInput.value = prefs.join(', ');
            cpvInput.disabled = true;
            if (cpvClearBtn) cpvClearBtn.disabled = true;
            cpvPrefixEl.value = '';
            if (wrap) wrap.classList.add('appaltimap-cpv-wrap--company');
        } else {
            if (wrap) wrap.classList.remove('appaltimap-cpv-wrap--company');
            cpvInput.disabled = false;
            var bak = window.AppaltiMap._cpvExploreUiBackup;
            if (bak) {
                cpvPrefixEl.value = bak.prefix || '';
                cpvInput.value = bak.input || '';
                window.AppaltiMap._cpvExploreUiBackup = null;
            }
            syncCpvClearButtonState();
        }
        try {
            if (window.AppaltiMap && typeof window.AppaltiMap._homeCpvToolbarDidChange === 'function') {
                window.AppaltiMap._homeCpvToolbarDidChange();
            }
        } catch (e) { /* ignore */ }
    }

    function syncCpvClearButtonState() {
        var btn = document.getElementById('appaltimap-cpv-clear');
        if (!btn) return;
        var prefix = getCpvPrefix();
        btn.disabled = !prefix;
    }

    function persistTelegramCpvPrefix(apiBase, memberUuid, cpvPrefix) {
        if (!memberUuid) return Promise.resolve();
        return fetch(apiBase + '/telegram/cpv', {
            method: 'POST',
            headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
            body: JSON.stringify({ member_uuid: memberUuid, cpv_prefix: cpvPrefix || null })
        }).catch(function () {});
    }

    function applyClusterColorForOutcome(map) {
        var outcomes = getSelectedOutcomes();
        var primary = outcomes.length ? outcomes[0] : null;
        var color;
        if (!primary) {
            // Neutral grey when no filter is active (map will be empty anyway)
            color = '#6b7280';
        } else if (primary === 'awarded') {
            color = '#16a34a';
        } else if (primary === 'deserted') {
            color = '#6b7280';
        } else if (primary === 'expired_unawarded') {
            // Mixed: uncertain expired (orange) vs certain deserted (black).
            color = ['case', ['>', ['coalesce', ['get', 'deserted_count'], 0], 0], '#000000', '#ea580c'];
        } else {
            color = '#2563eb';
        }
        if (map.getLayer('appaltimap-clusters')) {
            map.setPaintProperty('appaltimap-clusters', 'circle-color', color);
            map.setPaintProperty('appaltimap-clusters', 'circle-stroke-color', color);
        }
    }

    function ClusterLayer(map) {
        this._map = map;
    }

    ClusterLayer.prototype.clear = function () {
        var src = this._map.getSource('appaltimap-clusters');
        if (src) src.setData({ type: 'FeatureCollection', features: [] });
    };

    function RegionalClusterLayer(map) {
        this._map = map;
    }

    RegionalClusterLayer.prototype.clear = function () {
        var src = this._map.getSource('appaltimap-regional-clusters');
        if (src) src.setData({ type: 'FeatureCollection', features: [] });
    };

    RegionalClusterLayer.prototype.render = function (clusters) {
        var map = this._map;
        var src = map.getSource('appaltimap-regional-clusters');
        if (!src) return;
        var features = (clusters || []).map(function (c) {
            var lat = c.lat != null ? Number(c.lat) : NaN;
            var lon = c.lon != null ? Number(c.lon) : NaN;
            if (lat !== lat || lon !== lon) return null;
            var props = { count: c.count || 0, amount_sum: c.amount_sum };
            if (c.bbox) props.bbox = c.bbox;
            if (c.regional_source) props.regional_source = c.regional_source;
            return {
                type: 'Feature',
                geometry: { type: 'Point', coordinates: [lon, lat] },
                properties: props
            };
        }).filter(Boolean);
        src.setData({ type: 'FeatureCollection', features: features });
    };

    function regionalSourceDisplayLabel(regionalSource) {
        var src = String(regionalSource || '').trim();
        if (!src) return '';
        if (src === 'regional_anac_sotto_soglia') return 'ANAC (sotto soglia)';
        var m = src.match(/^regional_reg_([a-z0-9_]+)_gare$/i);
        if (m && m[1]) {
            return m[1].replace(/_/g, ' ').replace(/\b\w/g, function (ch) { return ch.toUpperCase(); });
        }
        if (src.indexOf('regional_') === 0) {
            return src.slice('regional_'.length).replace(/_/g, ' ');
        }
        return '';
    }

    ClusterLayer.prototype.render = function (clusters) {
        var map = this._map;
        var src = map.getSource('appaltimap-clusters');
        if (!src) return;

        var features = (clusters || []).map(function (c) {
            var lat = c.lat != null ? Number(c.lat) : NaN;
            var lon = c.lon != null ? Number(c.lon) : NaN;
            if (lat !== lat || lon !== lon) return null;
            var props = { count: c.count || 0, amount_sum: c.amount_sum };
            if (c.bbox) props.bbox = c.bbox;
            if (c.deserted_count != null) props.deserted_count = Number(c.deserted_count) || 0;
            return {
                type: 'Feature',
                geometry: { type: 'Point', coordinates: [lon, lat] },
                properties: props
            };
        }).filter(Boolean);

        src.setData({ type: 'FeatureCollection', features: features });
    };

    var CLUSTER_REQUEST_TIMEOUT_MS = 15000;

    function refreshClusters(client, map, clusterLayer) {
        var selectedOutcomes = getSelectedOutcomes();
        // If no filters are selected, clear the map and do not load any clusters
        if (!selectedOutcomes.length) {
            setStatus('');
            clusterLayer.clear();
            return Promise.resolve();
        }

        setOverlayVisible(true, 'Loading map data…', 'Fetching clusters from the API.');
        setStatus('Loading…');

        var hideOverlay = function () {
            try {
                setOverlayVisible(false);
            } catch (e) {  }
        };

        var bbox;
        var zoom;
        try {
            bbox = boundsToBbox(map);
            zoom = map.getZoom();
        } catch (e) {
            setStatus('Map not ready');
            hideOverlay();
            return Promise.resolve();
        }

        var outcomes = buildOutcomesCsv(selectedOutcomes);
        var params = {
            bbox: bbox,
            zoom: Math.floor(Number(zoom)) || 0,
            outcomes: outcomes,
            source_scope: 'ted'
        };
        Object.assign(params, getCpvFilterParamsForMap());
        var cmd = new window.AppaltiMap.LoadClustersCommand(client, params);

        var timeoutPromise = new Promise(function (_, reject) {
            setTimeout(function () {
                reject(new Error('timeout'));
            }, CLUSTER_REQUEST_TIMEOUT_MS);
        });

        return Promise.race([cmd.execute(), timeoutPromise])
            .then(function (data) {
                hideOverlay();
                setStatus('');
                var list = Array.isArray(data) ? data : (data && (data.clusters || data.data)) || [];
                function doRender() {
                    try {
                        clusterLayer.clear();
                        clusterLayer.render(list);
                        applyClusterColorForOutcome(map);
                    } catch (e) {
                        setStatus('Map render failed');
                    }
                }
                var src = map.getSource('appaltimap-clusters');
                if (src) {
                    doRender();
                } else {
                    map.once('load', doRender);
                    var attempts = 0;
                    var poll = setInterval(function () {
                        if (map.getSource('appaltimap-clusters')) {
                            clearInterval(poll);
                            doRender();
                        } else if (++attempts > 60) {
                            clearInterval(poll);
                        }
                    }, 100);
                }
            })
            .catch(function (err) {
                var status = (err && err.message === 'timeout')
                    ? 'Request timed out'
                    : (err && err.status) ? ('HTTP ' + err.status) : 'Request failed';
                setStatus(status);
                hideOverlay();
            })
            .finally(hideOverlay);
    }

    function refreshRegionalClusters(client, map, regionalLayer) {
        if (!isRegionalGareEnabled()) {
            regionalLayer.clear();
            return Promise.resolve();
        }
        var selectedOutcomes = getSelectedOutcomes();
        if (!selectedOutcomes.length) {
            regionalLayer.clear();
            return Promise.resolve();
        }
        var bbox;
        var zoom;
        try {
            bbox = boundsToBbox(map);
            zoom = map.getZoom();
        } catch (e) {
            return Promise.resolve();
        }
        var params = {
            bbox: bbox,
            zoom: Math.floor(Number(zoom)) || 0,
            outcomes: buildOutcomesCsv(selectedOutcomes),
            source_scope: 'regional'
        };
        // Bandi regionali/ANAC: niente filtro CPV (campo spesso vuoto in Map Engine).
        var cmd = new window.AppaltiMap.LoadClustersCommand(client, params);
        function doRenderRegional(list) {
            try {
                regionalLayer.clear();
                regionalLayer.render(list);
                if (map.getLayer('appaltimap-regional-clusters')) {
                    map.setLayoutProperty('appaltimap-regional-clusters', 'visibility', 'visible');
                    try {
                        if (map.getLayer('appaltimap-clusters')) {
                            map.moveLayer('appaltimap-regional-clusters');
                        }
                    } catch (eMove) { /* ignore */ }
                }
            } catch (eRender) {
                setStatus('Regional map render failed');
            }
        }
        return cmd.execute().then(function (data) {
            var list = Array.isArray(data) ? data : (data && (data.clusters || data.data)) || [];
            var src = map.getSource('appaltimap-regional-clusters');
            if (src) {
                doRenderRegional(list);
                return;
            }
            map.once('load', function () { doRenderRegional(list); });
            var attempts = 0;
            var poll = window.setInterval(function () {
                if (map.getSource('appaltimap-regional-clusters')) {
                    window.clearInterval(poll);
                    doRenderRegional(list);
                } else if (++attempts > 60) {
                    window.clearInterval(poll);
                }
            }, 100);
        }).catch(function (err) {
            regionalLayer.clear();
            var msg = (err && err.status) ? ('Regional clusters HTTP ' + err.status) : 'Regional clusters failed';
            try { setStatus(msg); } catch (eSt) { /* ignore */ }
        });
    }

    function refreshAllMapClusters(client, map, clusterLayer, regionalLayer) {
        return refreshClusters(client, map, clusterLayer).then(function () {
            return refreshRegionalClusters(client, map, regionalLayer);
        });
    }

    function outcomesForMapRequest() {
        return buildOutcomesCsv(getSelectedOutcomes());
    }

    function expandRegionalPopupBbox(bboxStr) {
        if (!bboxStr) return bboxStr;
        var parts = String(bboxStr).split(',').map(function (x) { return Number(x); });
        if (parts.length !== 4 || parts.some(function (n) { return n !== n; })) return bboxStr;
        var padLon = Math.max((parts[2] - parts[0]) * 1.2, 0.12);
        var padLat = Math.max((parts[3] - parts[1]) * 1.2, 0.08);
        return [parts[0] - padLon, parts[1] - padLat, parts[2] + padLon, parts[3] + padLat].join(',');
    }

    function clusterCountFromProps(props) {
        if (!props) return 0;
        var n = Number(props.count);
        return isFinite(n) && n > 0 ? Math.floor(n) : 0;
    }

    function regionalSlugPart(s) {
        return String(s || '').toLowerCase().trim()
            .replace(/[^a-z0-9]+/g, '-').replace(/-+/g, '-').replace(/^-|-$/g, '');
    }

    function regionalPlaceLabel(t) {
        if (!t) return '';
        var loc = (t.execution_locality || '').trim();
        var addr = (t.delivery_address || t.address || '').trim();
        if (loc) return loc;
        if (addr && addr.length >= 8) return addr.length > 80 ? addr.slice(0, 77) + '…' : addr;
        return '';
    }

    function regionalPortalLabel(t) {
        if (!t) return '';
        return (t.portal_region || '').trim();
    }

    function regionalPathFromProcedureId(procId) {
        var pid = String(procId || '').trim();
        if (pid.indexOf('regional:') !== 0) return '';
        var rest = pid.slice('regional:'.length);
        var colon = rest.indexOf(':');
        if (colon < 0) return '';
        var src = regionalSlugPart(rest.slice(0, colon));
        var sid = regionalSlugPart(rest.slice(colon + 1));
        if (!src || !sid) return '';
        var raw = ('gara-regionale-' + src + '-' + sid).replace(/-+/g, '-').replace(/^-|-$/g, '');
        if (src === 'anac-sotto-soglia' || raw.length > 80 || sid.length > 40) {
            return '';
        }
        return '/' + raw + '/';
    }

    function openClusterPopup(client, map, popup, lngLat, props, sourceScope) {
        var bbox = (props && props.bbox) || (function () {
            var lng = lngLat.lng;
            var lat = lngLat.lat;
            var zoom = typeof map.getZoom === 'function' ? map.getZoom() : 10;
            var cellDeg = 10 / Math.pow(2, zoom);
            var delta = Math.max(cellDeg * 0.6, 0.015);
            return [lng - delta, lat - delta, lng + delta, lat + delta].join(',');
        })();
        var regionalSource = (props && props.regional_source) ? String(props.regional_source).trim() : '';
        if (sourceScope === 'regional' && !regionalSource) {
            bbox = expandRegionalPopupBbox(bbox);
        }
        popup.setLngLat(lngLat).setHTML('<div class="appaltimap-popup-loading">Caricamento bandi…</div>').addTo(map);
        var clusterN = clusterCountFromProps(props);
        var popupLimit = sourceScope === 'regional'
            ? (regionalSource ? Math.min(Math.max(clusterN, 5), 50) : 80)
            : 30;
        var popupOutcomes = outcomesForMapRequest();
        var popupParams = { bbox: bbox, limit: popupLimit, outcomes: popupOutcomes };
        if (sourceScope) popupParams.source_scope = sourceScope;
        if (regionalSource) popupParams.regional_source = regionalSource;
        if (sourceScope !== 'regional') {
            Object.assign(popupParams, getCpvFilterParamsForMap());
        }
        // regional popup: solo source_scope + regional_source, mai CPV toolbar
        client.getTenders(popupParams)
            .then(function (data) {
                var items = (data && data.items) ? data.items : [];
                if (sourceScope === 'regional' && items.length && popupParams.source_scope === 'regional') {
                    items = items.filter(function (t) {
                        var src = String((t && t.source) || '');
                        var pid = String((t && t.procedure_id) || '');
                        var ok = src.indexOf('regional_') === 0 || pid.indexOf('regional:') === 0;
                        if (ok && regionalSource) {
                            ok = src === regionalSource;
                        }
                        return ok;
                    });
                }
                function esc(s) {
                    if (s == null || s === undefined) return '';
                    return String(s)
                        .replace(/&/g, '&amp;')
                        .replace(/</g, '&lt;')
                        .replace(/>/g, '&gt;')
                        .replace(/"/g, '&quot;');
                }
                function row(label, value) {
                    if (value == null || value === '') return '';
                    return '<div class="appaltimap-popup-row"><strong>' + esc(label) + '</strong> ' + esc(value) + '</div>';
                }
                function formatEndDate(isoStr) {
                    if (!isoStr || typeof isoStr !== 'string') return null;
                    try {
                        var d = new Date(isoStr);
                        if (isNaN(d.getTime())) return isoStr;
                        return d.toLocaleDateString(undefined, { day: 'numeric', month: 'short', year: 'numeric' });
                    } catch (e) {
                        return isoStr;
                    }
                }
                function formatAmountIt(amount, currency) {
                    if (amount == null || amount === '') return null;
                    var n;
                    if (typeof amount === 'number' && isFinite(amount)) {
                        n = amount;
                    } else {
                        var s = String(amount).trim().replace(/\s/g, '');
                        if (s.indexOf(',') !== -1 && s.indexOf('.') !== -1) {
                            n = parseFloat(s.replace(/\./g, '').replace(',', '.'), 10);
                        } else if (s.indexOf(',') !== -1) {
                            n = parseFloat(s.replace(',', '.'), 10);
                        } else {
                            n = parseFloat(s, 10);
                        }
                    }
                    if (isNaN(n)) return null;
                    var formatted = n.toLocaleString('it-IT', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
                    var sym = (currency && String(currency).trim().toUpperCase() === 'EUR') ? '€' : (currency || '€');
                    return formatted + ' ' + sym;
                }
                function sanitizeTedIdForSlug(tedId) {
                    if (!tedId || typeof tedId !== 'string') return '';
                    var s = tedId.toLowerCase().trim().replace(/[^a-z0-9\-]/g, '-').replace(/-+/g, '-').replace(/^-|-$/g, '');
                    return s.length > 200 ? '' : s;
                }
                function isRegionalTender(t) {
                    if (sourceScope === 'regional') return true;
                    if (!t) return false;
                    var src = String(t.source || '');
                    if (src.indexOf('regional_') === 0) return true;
                    var pid = String(t.procedure_id || '');
                    return pid.indexOf('regional:') === 0;
                }
                function articleUrlForTender(t) {
                    var base = (typeof window !== 'undefined' && window.location && window.location.origin) ? window.location.origin : 'https://vistagare.it';
                    base = String(base || '').replace(/\/+$/, '');
                    if (isRegionalTender(t)) {
                        var path = (t.procedure_url_path || regionalPathFromProcedureId(t.procedure_id) || '').trim();
                        if (path) {
                            return base + (path.charAt(0) === '/' ? path : '/' + path);
                        }
                        var gslug = t.ghost_slug || '';
                        if (gslug) {
                            gslug = String(gslug).replace(/^\/+|\/+$/g, '');
                            return base + '/' + gslug + '/';
                        }
                        return '';
                    }
                    var procId = t.procedure_id || '';
                    if (!procId) return '';
                    var slug = sanitizeTedIdForSlug(procId);
                    return slug ? base + '/procedura-' + slug + '/' : '';
                }
                function articleLinkLabel(t) {
                    return isRegionalTender(t) ? 'Scheda gara' : 'Vai all\'articolo';
                }
                function portalUrlForTender(t) {
                    if (!isRegionalTender(t)) return '';
                    var ext = t.canonical_url || t.source_url;
                    if (ext && /^https?:\/\//i.test(String(ext))) return String(ext).trim();
                    return '';
                }
                var html = '<div class="appaltimap-popup-tenders">';
                if (sourceScope === 'regional') {
                    var portalHdr = regionalSourceDisplayLabel(regionalSource);
                    html += '<p class="appaltimap-popup-summary"><em>Gare regionali'
                        + (portalHdr ? ' — ' + esc(portalHdr) : ' (non TED)')
                        + '</em></p>';
                }
                if (items.length === 0) {
                    if (clusterN > 0) {
                        html += '<p>Nessun bando trovato nel riquadro del triangolo (~' + clusterN + ' in cluster) con i filtri attivi. Prova un altro esito (es. «Gare scadute ma non assegnate») o zooma.</p>';
                    } else {
                        html += '<p>Nessun bando in quest\'area.</p>';
                    }
                } else {
                    var summary = items.length === 1 ? '1 bando' : items.length + ' bandi';
                    var clusterTotal = clusterN;
                    if (clusterTotal > items.length) {
                        summary += ' (nei filtri attivi; in mappa ~' + clusterTotal + ')';
                    }
                    html += '<p class="appaltimap-popup-summary">' + summary + '</p>';
                    items.forEach(function (t) {
                        var artUrl = articleUrlForTender(t);
                        var isAwarded = String(t.status || '').toLowerCase() === 'awarded';
                        html += '<div class="appaltimap-popup-tender">';
                        if (isRegionalTender(t)) {
                            var placeLbl = regionalPlaceLabel(t);
                            var portalLbl = regionalPortalLabel(t);
                            if (placeLbl) html += row('Luogo', placeLbl);
                            if (portalLbl && portalLbl.toLowerCase() !== (placeLbl || '').toLowerCase()) {
                                html += row('Portale fonte', portalLbl);
                            }
                            html += row('Stazione appaltante', t.buyer_name);
                        } else {
                            html += row('Stazione appaltante', t.buyer_name);
                        }
                        if (isRegionalTender(t)) {
                            var regDl = formatEndDate(t.tender_period_end || t.deadline);
                            html += row('Scadenza', regDl || 'Non disponibile');
                        } else {
                            html += row('Scadenza', formatEndDate(t.tender_period_end || t.deadline));
                        }
                        html += row('Titolo', t.title);
                        html += row('Descrizione', t.description);
                        var importoLabel = isAwarded ? 'Importo aggiudicato' : 'Importo stimato';
                        html += row(importoLabel, formatAmountIt(t.amount, t.currency));
                        if (t.award_winner) html += row('Aggiudicatario', t.award_winner);
                        html += row('Categoria', t.category);
                        if (!isRegionalTender(t)) {
                            html += row('Indirizzo', t.address);
                        } else if (t.address && String(t.address).trim() !== String(regionalPlaceLabel(t) || '').trim()) {
                            html += row('Indirizzo geocodificato', t.address);
                        }
                        if (artUrl) {
                            html += '<div class="appaltimap-popup-row"><strong>Scheda</strong> <a href="' + esc(artUrl) + '" class="appaltimap-popup-link">' + esc(articleLinkLabel(t)) + '</a></div>';
                        } else if (isRegionalTender(t)) {
                            html += '<div class="appaltimap-popup-row appaltimap-popup-row--muted"><em>Scheda non ancora pubblicata; eseguire sync gare regionali.</em></div>';
                        }
                        var portalUrl = portalUrlForTender(t);
                        if (portalUrl) {
                            html += '<div class="appaltimap-popup-row"><strong>Portale</strong> <a href="' + esc(portalUrl) + '" class="appaltimap-popup-link" target="_blank" rel="noopener noreferrer">Bando ufficiale</a></div>';
                        }
                        html += '</div>';
                    });
                }
                html += '</div>';
                popup.setHTML(html);
                if (window.VgKanbanLamp && typeof window.VgKanbanLamp.wireTabulator === 'function') {
                    try { window.VgKanbanLamp.syncPopupLamps(popup.getElement()); } catch (eL) {}
                }
            })
            .catch(function () {
                popup.setHTML('<div class="appaltimap-popup-error">Impossibile caricare i bandi.</div>');
            });
    }

    function initHomeMap() {
        var mapEl = qs('#appaltimap-map');
        if (!mapEl) return;

        if (window.AppaltiMap._telegramNotifyMode == null) {
            window.AppaltiMap._telegramNotifyMode = 'all';
        }
        if (window.AppaltiMap._lastAiGeo === undefined) {
            window.AppaltiMap._lastAiGeo = null;
        }
        if (window.AppaltiMap._homeMapAreaMode == null) {
            window.AppaltiMap._homeMapAreaMode = 'explore';
        }
        if (window.AppaltiMap._homeCompanyTerritoriesFC === undefined) {
            window.AppaltiMap._homeCompanyTerritoriesFC = null;
        }
        if (window.AppaltiMap._homeCompanyCpvPrefixes === undefined) {
            window.AppaltiMap._homeCompanyCpvPrefixes = null;
        }

        var apiBase = getApiBaseFromDom();
        var tokenStore = new window.AppaltiMap.TokenStore('appaltimap_auth');
        var memberUuid = (mapEl.getAttribute('data-member-uuid') || '').trim();
        var client = new window.AppaltiMap.ApiGatewayClient({
            baseUrl: apiBase,
            tokenStore: tokenStore,
            memberUuid: memberUuid || null
        });

        // Restore last selected outcome (ongoing/awarded/expired) across reloads/navigation.
        applySavedOutcomeSelection();

        var magic = getMagicFromUrl();
        var exchangePromise = Promise.resolve();
        if (magic) {
            exchangePromise = new window.AppaltiMap.ExchangeTokenCommand(client, magic)
                .execute()
                .then(function () {
                    setStatus('Signed in for map access.');
                })
                .catch(function () {
                    setStatus('Token exchange failed.');
                });
        }

        var map = createMap(mapEl);
        // expose for AI chat effects/context (best-effort; not a stable public API)
        window.AppaltiMap = window.AppaltiMap || {};
        window.AppaltiMap._map = map;
        var clusterLayer = new ClusterLayer(map);
        var regionalLayer = new RegionalClusterLayer(map);
        applySavedRegionalToggle();

        // TerraDraw: initialize AFTER MapLibre has loaded to avoid adapter errors.
        var drawReady = false;
        function initTerraDraw() {
            if (drawReady) return;
            if (!window.terraDraw || !window.terraDrawMaplibreGlAdapter) return;
            try {
                window.AppaltiMap.draw = new window.terraDraw.TerraDraw({
                    adapter: new window.terraDrawMaplibreGlAdapter.TerraDrawMapLibreGLAdapter({ map: map }),
                    modes: [
                        new window.terraDraw.TerraDrawFreehandMode(),
                        new window.terraDraw.TerraDrawPolygonMode(),
                        new window.terraDraw.TerraDrawRectangleMode(),
                        new window.terraDraw.TerraDrawSelectMode({
                            allowManualDeselection: true,
                            flags: {
                                polygon: {
                                    feature: {
                                        draggable: true,
                                        coordinates: { midpoints: true, draggable: true, deletable: true }
                                    }
                                },
                                rectangle: {
                                    feature: {
                                        draggable: true,
                                        coordinates: { midpoints: true, draggable: true, deletable: true }
                                    }
                                },
                                freehand: {
                                    feature: {
                                        draggable: true,
                                        coordinates: { midpoints: true, draggable: true, deletable: true }
                                    }
                                }
                            }
                        }),
                        new window.terraDraw.TerraDrawRenderMode({ modeName: 'render', styles: {} })
                    ]
                });
                window.AppaltiMap.draw.start();
                window.AppaltiMap.draw.setMode('render');
                drawReady = true;
                window.AppaltiMap._savedAreaFeatureId = null;
                window.AppaltiMap._savedAreaGeojson = null;
                loadSavedArea();
            } catch (err) {
                drawReady = false;
                if (typeof console !== 'undefined' && console.warn) {
                    console.warn('TerraDraw init failed:', err);
                }
            }
        }

        function loadSavedArea() {
            var draw = window.AppaltiMap.draw;
            var memberUuid = getMemberUuidFromDom();
            if (!draw || !drawReady || !memberUuid) return;
            var apiBase = getApiBaseFromDom().replace(/\/+$/, '');
            fetch(apiBase + '/telegram/settings?member=' + encodeURIComponent(memberUuid), { headers: { 'Accept': 'application/json' } })
                .then(function (r) { if (!r.ok) throw r; return r.json(); })
                .then(function (data) {
                    window.AppaltiMap._telegramNotifyMode = (data && data.mode) || 'all';
                    try {
                        if (window.AppaltiMap._refreshAiMinimap) window.AppaltiMap._refreshAiMinimap();
                    } catch (eRm) {}
                    if (!data || data.mode !== 'area' || !data.area || !data.area.geojson) return;
                    var geom;
                    try { geom = JSON.parse(data.area.geojson); } catch (e) { return; }
                    if (!geom || geom.type !== 'Polygon' || !geom.coordinates) return;
                    window.AppaltiMap._savedAreaGeojson = geom;
                    var id = (typeof draw.getFeatureId === 'function') ? draw.getFeatureId() : String(Date.now());
                    // Important: keep this as a polygon feature so "select" mode can show vertices & edit it.
                    var feature = { type: 'Feature', id: id, geometry: geom, properties: { mode: 'polygon' } };
                    if (typeof draw.addFeatures === 'function') {
                        draw.addFeatures([feature]);
                        window.AppaltiMap._savedAreaFeatureId = id;
                    }

                    if (window.AppaltiMap._homeMapAreaMode === 'company') {
                        clearTerraDrawVisualizationHome(draw);
                    } else {
                        // Auto-zoom to saved area when entering the map.
                        try {
                            var ring = geom.coordinates && geom.coordinates[0];
                            if (!ring || !ring.length) return;
                            var minLon = Infinity, minLat = Infinity, maxLon = -Infinity, maxLat = -Infinity;
                            ring.forEach(function (p) {
                                if (!p || p.length < 2) return;
                                var lon = Number(p[0]);
                                var lat = Number(p[1]);
                                if (!isFinite(lon) || !isFinite(lat)) return;
                                minLon = Math.min(minLon, lon);
                                minLat = Math.min(minLat, lat);
                                maxLon = Math.max(maxLon, lon);
                                maxLat = Math.max(maxLat, lat);
                            });
                            if (isFinite(minLon) && isFinite(minLat) && isFinite(maxLon) && isFinite(maxLat) && minLon < maxLon && minLat < maxLat) {
                                map.fitBounds([[minLon, minLat], [maxLon, maxLat]], { padding: vgMapFitPaddingPx(), duration: 700 });
                            }
                        } catch (e) {}
                    }
                })
                .catch(function () {  });
        }

        map.on('load', initTerraDraw);

        // Activate "draw area" icon: let paid users draw a polygon and save it to the gateway DB.
        var memberUuid = getMemberUuidFromDom();
        var drawBtn = document.querySelector('[data-appaltimap-action="draw-area"]');
        if (drawBtn && memberUuid) {
            var saving = false;
            var saveTimer = null;

            function persistGeometry(geom) {
                if (!geom) return;
                if (window.AppaltiMap._homeMapAreaMode === 'company') return;
                window.AppaltiMap._savedAreaGeojson = geom;
                try {
                    if (window.AppaltiMap._refreshAiMinimap) window.AppaltiMap._refreshAiMinimap();
                } catch (eRf) {}
                setStatus('Salvataggio area…');
                fetch(getApiBaseFromDom().replace(/\/+$/, '') + '/telegram/area', {
                    method: 'POST',
                    headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
                    body: JSON.stringify({ member_uuid: memberUuid, geojson: geom })
                })
                    .then(function (r) {
                        if (!r.ok) {
                            var err = new Error('http ' + r.status);
                            err._status = r.status;
                            throw err;
                        }
                        return r.json();
                    })
                    .then(function () {
                        setStatus('Area salvata.');
                    })
                    .catch(function (e) {
                        var code = e && e._status ? (' (HTTP ' + e._status + ')') : '';
                        setStatus('Errore salvataggio area' + code);
                    });
            }

            drawBtn.addEventListener('click', function () {
                try {
                    if (window.AppaltiMap._homeMapAreaMode === 'company') {
                        setStatus('Passa a modalità esplorazione per disegnare l\'area radar.');
                        return;
                    }
                    if (!window.AppaltiMap.draw || !drawReady) {
                        setStatus('Strumento disegno in caricamento…');
                        return;
                    }
                    var existingId = window.AppaltiMap._savedAreaFeatureId;
                    if (existingId && typeof window.AppaltiMap.draw.hasFeature === 'function' && window.AppaltiMap.draw.hasFeature(existingId)) {
                        window.AppaltiMap.draw.setMode('select');
                        if (typeof window.AppaltiMap.draw.selectFeature === 'function') {
                            window.AppaltiMap.draw.selectFeature(existingId);
                        }
                        setStatus("Modifica l'area trascinando i punti.");
                    } else {
                        window.AppaltiMap.draw.setMode('polygon');
                        setStatus("Disegna un'area e chiudi il poligono.");
                    }
                } catch (e) {
                    setStatus('Disegno non disponibile');
                }
            });

            // Paid-tier "Search pins": render all tenders (filtered by saved area if any)
            // inside #site-main using Tabulator.
            var searchBtn = document.querySelector('[data-appaltimap-action="search-pins"]');
            if (searchBtn) {
                function ITALY_BBOX() {
                    // minLon,minLat,maxLon,maxLat (approx bbox for Italy)
                    return '6.60,36.60,18.90,47.20';
                }

                function bboxFromPolygonGeojson(polyGeo) {
                    // polyGeo: GeoJSON Polygon { type:'Polygon', coordinates:[ring] }
                    try {
                        if (!polyGeo || polyGeo.type !== 'Polygon' || !polyGeo.coordinates || !polyGeo.coordinates.length) return null;
                        var ring = polyGeo.coordinates[0] || [];
                        if (!ring.length) return null;
                        var minLon = 999, minLat = 999, maxLon = -999, maxLat = -999;
                        ring.forEach(function (p) {
                            if (!p || p.length < 2) return;
                            var lon = Number(p[0]);
                            var lat = Number(p[1]);
                            if (isNaN(lon) || isNaN(lat)) return;
                            minLon = Math.min(minLon, lon);
                            minLat = Math.min(minLat, lat);
                            maxLon = Math.max(maxLon, lon);
                            maxLat = Math.max(maxLat, lat);
                        });
                        if (minLon > maxLon || minLat > maxLat) return null;
                        return [minLon, minLat, maxLon, maxLat].join(',');
                    } catch (e) {
                        return null;
                    }
                }

                function pointInPolygon(point, ring) {
                    // Ray-casting algorithm. point=[lon,lat], ring=[[lon,lat],...]
                    try {
                        if (!point || !ring || ring.length < 3) return false;
                        var x = point[0];
                        var y = point[1];
                        var inside = false;
                        for (var i = 0, j = ring.length - 1; i < ring.length; j = i++) {
                            var xi = ring[i][0], yi = ring[i][1];
                            var xj = ring[j][0], yj = ring[j][1];
                            var intersect = ((yi > y) !== (yj > y)) &&
                                (x < (xj - xi) * (y - yi) / (yj - yi + 0.0) + xi);
                            if (intersect) inside = !inside;
                        }
                        return inside;
                    } catch (e) {
                        return false;
                    }
                }

                function formatAmountIt(amount, currency) {
                    if (amount == null || amount === '') return '';
                    var n;
                    if (typeof amount === 'number' && isFinite(amount)) {
                        n = amount;
                    } else {
                        var s = String(amount).trim().replace(/\s/g, '');
                        if (s.indexOf(',') !== -1 && s.indexOf('.') !== -1) {
                            n = parseFloat(s.replace(/\./g, '').replace(',', '.'), 10);
                        } else if (s.indexOf(',') !== -1) {
                            n = parseFloat(s.replace(',', '.'), 10);
                        } else {
                            n = parseFloat(s, 10);
                        }
                    }
                    if (isNaN(n)) return '';
                    var formatted = n.toLocaleString('it-IT', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
                    var sym = (currency && String(currency).trim().toUpperCase() === 'EUR') ? '€' : (currency || '€');
                    return formatted + ' ' + sym;
                }

                function formatDate(isoStr) {
                    if (!isoStr || typeof isoStr !== 'string') return '';
                    try {
                        var d = new Date(isoStr);
                        if (isNaN(d.getTime())) return isoStr;
                        return d.toLocaleDateString(undefined, { day: 'numeric', month: 'short', year: 'numeric' });
                    } catch (e) {
                        return isoStr;
                    }
                }

                function clearAndMountTabulator() {
                    var main = document.getElementById('site-main');
                    if (!main) return null;
                    main.innerHTML =
                        '<section id="appaltimap-cronologia-search" class="appaltimap-cronologia" aria-label="Cronologia dei bandi">' +
                        '<h2 id="appaltimap-search-results" class="appaltimap-search-results-title">Elenco dei bandi</h2>' +
                        '<div id="appaltimap-tabulator" style="margin-top:16px;">Caricamento bandi…</div>' +
                        '</section>';
                    return '#appaltimap-tabulator';
                }

                function readSearchSpecFromHash() {
                    try {
                        var h = window.location.hash || '';
                        if (h.indexOf('#search=') !== 0) return null;
                        var raw = h.slice('#search='.length);
                        if (!raw) return null;
                        // New readable format: #search=outcome:ongoing&area:1
                        // Legacy format: #search=<urlencoded querystring like outcome=ongoing&area=1>
                        if (raw.indexOf('outcome:') !== -1 || raw.indexOf('area:') !== -1 || raw.indexOf('&area') !== -1) {
                            var outcome = '';
                            var areaVal = '';
                            var parts = raw.split('&');
                            parts.forEach(function (p) {
                                if (!p) return;
                                if (p.indexOf('outcome:') === 0) outcome = p.slice('outcome:'.length);
                                else if (p.indexOf('outcome=') === 0) outcome = p.slice('outcome='.length);
                                else if (p.indexOf('area:') === 0) areaVal = p.slice('area:'.length);
                                else if (p.indexOf('area=') === 0) areaVal = p.slice('area='.length);
                            });
                            var areaFlag = areaVal === '1' || areaVal === 'true' || areaVal === 'yes';
                            return { outcome: outcome, area: areaFlag };
                        }

                        var decoded = '';
                        try { decoded = decodeURIComponent(raw); } catch (e) { decoded = raw; }
                        var sp = new URLSearchParams(decoded);
                        var outcomeOld = sp.get('outcome') || '';
                        var areaOld = sp.get('area');
                        var areaFlagOld = areaOld === '1' || areaOld === 'true' || areaOld === 'yes';
                        return { outcome: outcomeOld, area: areaFlagOld };
                    } catch (e) {
                        return null;
                    }
                }

                function applySearchSpecToFilters(spec) {
                    if (!spec || !spec.outcome) return;
                    document.querySelectorAll('.appaltimap-filter-input').forEach(function (input) {
                        var v = input.getAttribute('data-outcome') || '';
                        input.checked = (v === spec.outcome);
                    });
                }

                function setSearchHash(outcome, areaFlag) {
                    try {
                        var outcomeVal = outcome || '';
                        // Readable hash (no URL encoding):
                        //   #search=outcome:ongoing&area:1
                        var newHash = '#search=outcome:' + outcomeVal + '&area:' + (areaFlag ? '1' : '0');
                        if (window.location.hash === newHash) return;
                        window.AppaltiMap._searchUpdatingHash = true;
                        window.location.hash = newHash;
                        window.setTimeout(function () {
                            window.AppaltiMap._searchUpdatingHash = false;
                        }, 80);
                    } catch (e) {
                        // ignore
                    }
                }

                searchBtn.addEventListener('click', function () {
                    try {
                        if (!window.Tabulator) {
                            setStatus('Tabella non disponibile');
                            return;
                        }
                        var mountSel = clearAndMountTabulator();
                        if (!mountSel) return;
                        try {
                            var anchor = document.getElementById('appaltimap-search-results');
                            if (anchor && anchor.scrollIntoView) anchor.scrollIntoView({ behavior: 'smooth', block: 'start' });
                        } catch (e) {  }

                        // If URL asks for "area", but we don't have it yet, wait a bit and re-run.
                        var spec = readSearchSpecFromHash();
                        var forceArea = spec && spec.area === true;

                        var companyFc = window.AppaltiMap._homeCompanyTerritoriesFC;
                        var useCompany = window.AppaltiMap._homeMapAreaMode === 'company' &&
                            companyFc &&
                            Array.isArray(companyFc.features) &&
                            companyFc.features.length > 0;

                        var areaGeom = window.AppaltiMap._savedAreaGeojson;
                        var polyRing = null;
                        var bbox = null;

                        if (forceArea && !useCompany && (!areaGeom || areaGeom.type !== 'Polygon')) {
                            setStatus('Caricamento area…');
                            var tries = 0;
                            var t = window.setInterval(function () {
                                tries++;
                                areaGeom = window.AppaltiMap._savedAreaGeojson;
                                if (areaGeom && areaGeom.type === 'Polygon' && areaGeom.coordinates && areaGeom.coordinates.length) {
                                    window.clearInterval(t);
                                    // Trigger again now that area is available.
                                    try { searchBtn.click(); } catch (e) {}
                                } else if (tries > 20) {
                                    window.clearInterval(t);
                                    // Fall back to "all Italy" if area never loads.
                                    forceArea = false;
                                    areaGeom = window.AppaltiMap._savedAreaGeojson;
                                    // Continue without area.
                                }
                            }, 300);
                            return;
                        }

                        if (useCompany) {
                            bbox = featureCollectionBboxToQueryString(companyFc) || ITALY_BBOX();
                        } else if (areaGeom && areaGeom.type === 'Polygon' && areaGeom.coordinates && areaGeom.coordinates.length) {
                            polyRing = areaGeom.coordinates[0] || null;
                            bbox = bboxFromPolygonGeojson(areaGeom);
                        }
                        if (!bbox) bbox = ITALY_BBOX();

                        var selectedOutcomes = getSelectedOutcomes();
                        // Only these 3 outcome groups are shown in the requested UI.
                        var wantedOutcomes = (selectedOutcomes || []).filter(function (o) {
                            return o === 'ongoing' || o === 'awarded' || o === 'expired_unawarded';
                        });
                        if (!wantedOutcomes.length) wantedOutcomes = selectedOutcomes || [];

                        // Match Tabulator header background with the map pin color.
                        var primaryOutcome = wantedOutcomes && wantedOutcomes.length ? wantedOutcomes[0] : null;
                        var headerBg = primaryOutcome === 'awarded'
                            ? '#16a34a'
                            : (primaryOutcome === 'expired_unawarded' ? '#ea580c' : '#2563eb');
                        var tabEl = document.getElementById('appaltimap-tabulator');
                        if (tabEl && tabEl.style && tabEl.style.setProperty) {
                            tabEl.style.setProperty('--vg-tabulator-header-bg', headerBg);
                        }

                        // Persist current search in browser history via URL hash.
                        setSearchHash(primaryOutcome || '', useCompany || (!!polyRing && polyRing.length >= 3));

                        var limit = 1000;
                        var safetyMax = 20000;
                        var tedOutcomes = buildOutcomesCsv(wantedOutcomes);
                        var regionalOutcomes = buildOutcomesCsv(wantedOutcomes);

                        // CPV solo su TED; regional/ANAC non hanno CPV in ingest.
                        function fetchScopePages(sourceScope, outcomesStr, withCpv) {
                            var acc = [];
                            var offset = 0;
                            function fetchPage() {
                                var params = { bbox: bbox, limit: limit, offset: offset };
                                if (outcomesStr) params.outcomes = outcomesStr;
                                if (sourceScope) params.source_scope = sourceScope;
                                if (withCpv && sourceScope !== 'regional') {
                                    Object.assign(params, getCpvFilterParamsForMap());
                                }
                                return client.getTenders(params).then(function (data) {
                                    var items = (data && data.items) ? data.items : [];
                                    if (!items.length) return acc;
                                    acc = acc.concat(items);
                                    if (acc.length >= safetyMax) return acc;
                                    var next = data && data.next_offset;
                                    if (next === null || next === undefined) return acc;
                                    offset = next;
                                    return fetchPage();
                                });
                            }
                            return fetchPage();
                        }

                        var fetchTed = fetchScopePages('ted', tedOutcomes, true);
                        var fetchRegional = isRegionalGareEnabled()
                            ? fetchScopePages('regional', regionalOutcomes, false)
                            : Promise.resolve([]);

                        Promise.all([fetchTed, fetchRegional])
                            .then(function (parts) {
                                var tedItems = parts[0] || [];
                                var regionalItems = parts[1] || [];
                                var all = tedItems.concat(regionalItems);
                                var filtered = all;
                                if (useCompany && companyFc) {
                                    filtered = [];
                                    all.forEach(function (t) {
                                        var c = t && t.geom && t.geom.coordinates ? t.geom.coordinates : null;
                                        if (!c || c.length < 2) return;
                                        if (pointInCompanyFeatureCollection(c, companyFc)) filtered.push(t);
                                    });
                                } else if (polyRing && polyRing.length >= 3) {
                                    filtered = [];
                                    all.forEach(function (t) {
                                        var c = t && t.geom && t.geom.coordinates ? t.geom.coordinates : null;
                                        if (!c || c.length < 2) return;
                                        if (pointInPolygon(c, polyRing)) filtered.push(t);
                                    });
                                }

                                function sanitizeSlug(v) {
                                    if (!v || typeof v !== 'string') return '';
                                    return v.toLowerCase().trim()
                                        .replace(/[^a-z0-9\-]/g, '-')
                                        .replace(/-+/g, '-')
                                        .replace(/^-|-$/g, '');
                                }

                                function escHtml(s) {
                                    if (s == null) return '';
                                    return String(s)
                                        .replace(/&/g, '&amp;')
                                        .replace(/</g, '&lt;')
                                        .replace(/>/g, '&gt;')
                                        .replace(/"/g, '&quot;')
                                        .replace(/'/g, '&#39;');
                                }

                                function procedureUrlForTender(t) {
                                    var base = (typeof window !== 'undefined' && window.location && window.location.origin) ? window.location.origin : 'https://vistagare.it';
                                    base = String(base || '').replace(/\/+$/, '');
                                    if (isRegionalMapTender(t)) {
                                        var path = (t.procedure_url_path || regionalPathFromProcedureId(t.procedure_id) || '').trim();
                                        if (path) return base + (path.charAt(0) === '/' ? path : '/' + path);
                                        var gslug = t.ghost_slug || '';
                                        if (gslug) {
                                            gslug = String(gslug).replace(/^\/+|\/+$/g, '');
                                            return base + '/' + gslug + '/';
                                        }
                                        return '';
                                    }
                                    var procId = (t && t.procedure_id) ? String(t.procedure_id) : '';
                                    if (!procId) return '';
                                    var slug = sanitizeSlug(procId);
                                    return slug ? (base + '/procedura-' + slug + '/') : '';
                                }

                                function portalLabelForTender(t) {
                                    if (!isRegionalMapTender(t)) return 'TED';
                                    return regionalPortalLabel(t) || regionalSourceDisplayLabel(t.source) || 'Regionale';
                                }

                                if (regionalItems.length) {
                                    var titleEl = document.getElementById('appaltimap-search-results');
                                    if (titleEl) {
                                        var nTed = tedItems.length;
                                        var nReg = regionalItems.length;
                                        titleEl.textContent = 'Elenco dei bandi (' + nTed + ' TED'
                                            + (nReg ? ', ' + nReg + ' regionali/ANAC in fondo' : '') + ')';
                                    }
                                }

                                // Render table
                                var popupTab = new window.Tabulator(mountSel, {
                                    data: filtered,
                                    index: function (row) {
                                        return String((row && (row.ted_id || row.procedure_id)) || '');
                                    },
                                    layout: 'fitColumns',
                                    height: '70vh',
                                    pagination: true,
                                    paginationSize: 20,
                                    movableColumns: true,
                                    columns: [
                                        {
                                            title: '',
                                            field: '_vg_lamp',
                                            width: 44,
                                            hozAlign: 'center',
                                            headerSort: false,
                                            formatter: function (cell) {
                                                return window.VistaGareKanbanLamp
                                                    ? window.VistaGareKanbanLamp.formatterCell(cell.getRow().getData())
                                                    : '';
                                            }
                                        },
                                        {
                                            title: 'Scadenza / Aggiudicazione',
                                            field: 'tender_period_end',
                                            formatter: function (cell) {
                                                var row = cell.getRow().getData();
                                                var isAwarded = String(row && row.status ? row.status : '').toLowerCase() === 'awarded';
                                                var dateVal = row ? (row.tender_period_end || row.publication_date) : null;
                                                return formatDate(dateVal);
                                            },
                                            sorter: function (a, b, aRow, bRow) {
                                                // Use the same displayed "dateVal" logic for consistent sorting.
                                                var ra = aRow && aRow.getData ? aRow.getData() : null;
                                                var rb = bRow && bRow.getData ? bRow.getData() : null;
                                                var da = ra ? (ra.tender_period_end || ra.publication_date) : null;
                                                var db = rb ? (rb.tender_period_end || rb.publication_date) : null;
                                                var ta = da ? new Date(da).getTime() : NaN;
                                                var tb = db ? new Date(db).getTime() : NaN;
                                                if (isNaN(ta) && isNaN(tb)) return 0;
                                                if (isNaN(ta)) return 1;
                                                if (isNaN(tb)) return -1;
                                                return ta - tb;
                                            }
                                        },
                                        { title: 'Fonte', field: 'source', width: 110, formatter: function (cell) {
                                            return escHtml(portalLabelForTender(cell.getRow().getData()));
                                        }},
                                        { title: 'Stazione appaltante', field: 'buyer_name' },
                                        { title: 'Titolo', field: 'title' },
                                        { title: 'Categoria', field: 'category' },
                                        { title: 'Stato', field: 'status' },
                                        {
                                            title: 'Importo',
                                            field: 'amount',
                                            formatter: function (cell) {
                                                var row = cell.getRow();
                                                return formatAmountIt(row.getData().amount, row.getData().currency);
                                            }
                                        },
                                        { title: 'Indirizzo', field: 'address' },
                                        {
                                            title: 'Procedura (link)',
                                            field: 'procedure_id',
                                            formatter: function (cell) {
                                                var t = cell.getRow().getData();
                                                var procId = t && t.procedure_id ? String(t.procedure_id) : '';
                                                var url = procedureUrlForTender(t);
                                                if (!procId || !url) return '';
                                                return '<a href="' + escHtml(url) + '" class="appaltimap-popup-link">' + escHtml(procId) + '</a>';
                                            }
                                        }
                                    ]
                                });
                                if (window.VistaGareKanbanLamp && popupTab) {
                                    window.VistaGareKanbanLamp.wireTabulator(popupTab);
                                }
                            })
                            .catch(function () {
                                var main = document.getElementById('site-main');
                                if (main) main.innerHTML = '<div class="appaltimap-popup-error">Impossibile caricare la tabella.</div>';
                            });
                    } catch (e) {
                        setStatus('Errore tabella');
                    }
                });
            }

            // Enable back/forward navigation between searches.
            // When URL hash contains `#search=...`, rebuild the table accordingly.
            try {
                if (!searchBtn) return;
                function readSearchSpecFromHashOuter() {
                    try {
                        var h = window.location.hash || '';
                        if (h.indexOf('#search=') !== 0) return null;
                        var raw = h.slice('#search='.length);
                        if (!raw) return null;
                        if (raw.indexOf('outcome:') !== -1 || raw.indexOf('area:') !== -1 || raw.indexOf('&area') !== -1) {
                            var outcome = '';
                            var areaVal = '';
                            var parts = raw.split('&');
                            parts.forEach(function (p) {
                                if (!p) return;
                                if (p.indexOf('outcome:') === 0) outcome = p.slice('outcome:'.length);
                                else if (p.indexOf('outcome=') === 0) outcome = p.slice('outcome='.length);
                                else if (p.indexOf('area:') === 0) areaVal = p.slice('area:'.length);
                                else if (p.indexOf('area=') === 0) areaVal = p.slice('area='.length);
                            });
                            var areaFlag = areaVal === '1' || areaVal === 'true' || areaVal === 'yes';
                            return { outcome: outcome, area: areaFlag };
                        }

                        var decoded = '';
                        try { decoded = decodeURIComponent(raw); } catch (e) { decoded = raw; }
                        var sp = new URLSearchParams(decoded);
                        var outcomeOld = sp.get('outcome') || '';
                        var areaOld = sp.get('area');
                        var areaFlagOld = areaOld === '1' || areaOld === 'true' || areaOld === 'yes';
                        return { outcome: outcomeOld, area: areaFlagOld };
                    } catch (e) {
                        return null;
                    }
                }

                function applySearchSpecToFiltersOuter(spec) {
                    if (!spec || !spec.outcome) return;
                    document.querySelectorAll('.appaltimap-filter-input').forEach(function (input) {
                        var v = input.getAttribute('data-outcome') || '';
                        input.checked = (v === spec.outcome);
                    });
                }

                function runFromSearchHash() {
                    if (window.AppaltiMap && window.AppaltiMap._searchUpdatingHash) return;
                    var spec = readSearchSpecFromHashOuter();
                    if (!spec) return;
                    applySearchSpecToFiltersOuter(spec);
                    try { searchBtn.click(); } catch (e) {}
                }
                window.addEventListener('hashchange', function () {
                    if (window.AppaltiMap && window.AppaltiMap._searchUpdatingHash) return;
                    runFromSearchHash();
                });
                runFromSearchHash();
            } catch (e) {
                // ignore
            }

            // When a polygon is finished, persist it
            try {
                // Register finish listener once TerraDraw is ready
                function attachFinishListener() {
                    if (!window.AppaltiMap.draw || !drawReady) return;
                    window.AppaltiMap.draw.on('finish', function (id) {
                    if (window.AppaltiMap._homeMapAreaMode === 'company') return;
                    if (saving) return;
                    saving = true;
                    var snap = window.AppaltiMap.draw.getSnapshot ? window.AppaltiMap.draw.getSnapshot() : [];
                    var feature = null;
                    (snap || []).forEach(function (f) {
                        if (f && f.id === id) feature = f;
                    });
                    if (!feature || !feature.geometry) {
                        saving = false;
                        return;
                    }
                    window.AppaltiMap._savedAreaFeatureId = id;
                    persistGeometry(feature.geometry);
                    try {
                        window.AppaltiMap.draw.setMode('select');
                        if (typeof window.AppaltiMap.draw.selectFeature === 'function') {
                            window.AppaltiMap.draw.selectFeature(id);
                        }
                    } catch (e) {  }
                    saving = false;
                    });
                }
                map.on('load', attachFinishListener);

                // Persist edits to the existing polygon (select mode updates)
                function attachChangeListener() {
                    if (!window.AppaltiMap.draw || !drawReady) return;
                    window.AppaltiMap.draw.on('change', function (ids, type) {
                        if (window.AppaltiMap._homeMapAreaMode === 'company') return;
                        var existingId = window.AppaltiMap._savedAreaFeatureId;
                        if (!existingId) return;
                        if (!ids || !ids.length) return;
                        var hit = false;
                        ids.forEach(function (x) { if (x === existingId) hit = true; });
                        if (!hit) return;
                        if (saveTimer) window.clearTimeout(saveTimer);
                        saveTimer = window.setTimeout(function () {
                            var f = window.AppaltiMap.draw.getSnapshotFeature ? window.AppaltiMap.draw.getSnapshotFeature(existingId) : null;
                            if (f && f.geometry) persistGeometry(f.geometry);
                        }, 1200);
                    });
                }
                map.on('load', attachChangeListener);
            } catch (e) {
                // ignore if events are not supported
            }
        }

        var modeToggleBtnHome = document.querySelector('[data-appaltimap-action="map-area-mode-toggle"]');
        var drawAreaBtnHome = document.querySelector('[data-appaltimap-action="draw-area"]');

        window.AppaltiMap._applyExploreModeFromAi = function () {
            window.AppaltiMap._homeMapAreaMode = 'explore';
            window.AppaltiMap._homeCompanyTerritoriesFC = null;
            window.AppaltiMap._homeCompanyCpvPrefixes = null;
            persistHomeMapAreaMode('explore');
            removeHomeCompanyTerritoryLayers(map);
            if (drawReady && window.AppaltiMap.draw) {
                restoreTerraDrawRadarPolygonHome(window.AppaltiMap.draw);
            }
            if (drawAreaBtnHome) drawAreaBtnHome.disabled = false;
            syncAllHomeMapModeToggleButtons();
            applyHomeMapCpvToolbarForMode();
            fitExploreModeHomeBounds(map);
            setStatus('');
            try { refreshAllMapClusters(client, map, clusterLayer, regionalLayer); } catch (eR) {}
            try {
                if (window.AppaltiMap._refreshAiMinimap) window.AppaltiMap._refreshAiMinimap();
            } catch (eM) {}
        };

        window.AppaltiMap._runHomeMapAreaModeToggle = function () {
            var current = (window.AppaltiMap._homeMapAreaMode === 'company') ? 'company' : 'explore';
            if (current === 'company') {
                window.AppaltiMap._applyExploreModeFromAi();
                return;
            }
            setStatus('Carico territori profilo…');
            if (drawAreaBtnHome) drawAreaBtnHome.disabled = true;
            ensureGatewaySessionHome()
                .then(function () { return fetchCompanyBundleForHomeMap(); })
                .then(function (data) {
                    return buildCompanyOrItalyFeatureCollection((data && data.territories) ? data.territories : [])
                        .then(function (fc) {
                            return { fc: fc, bundle: data };
                        });
                })
                .then(function (packed) {
                    var fc = packed && packed.fc;
                    var bundle = packed && packed.bundle;
                    if (!drawReady || !window.AppaltiMap.draw) {
                        throw new Error('Mappa non pronta');
                    }
                    window.AppaltiMap._homeMapAreaMode = 'company';
                    window.AppaltiMap._homeCompanyTerritoriesFC = fc;
                    window.AppaltiMap._homeCompanyCpvPrefixes = companyCpvPrefixesFromBundle(bundle && bundle.cpv);
                    clearTerraDrawVisualizationHome(window.AppaltiMap.draw);
                    setHomeCompanyTerritoriesLayerData(map, fc);
                    if (drawAreaBtnHome) drawAreaBtnHome.disabled = true;
                    syncAllHomeMapModeToggleButtons();
                    applyHomeMapCpvToolbarForMode();
                    var bb = bboxFromFeatureCollection(fc);
                    if (bb) fitMapBoundsFromBBox(map, bb);
                    setStatus('');
                    persistHomeMapAreaMode('company');
                    try { refreshAllMapClusters(client, map, clusterLayer, regionalLayer); } catch (eR) {}
                    try {
                        if (window.AppaltiMap._refreshAiMinimap) window.AppaltiMap._refreshAiMinimap();
                    } catch (eM2) {}
                })
                .catch(function (err) {
                    window.AppaltiMap._homeMapAreaMode = 'explore';
                    window.AppaltiMap._homeCompanyTerritoriesFC = null;
                    window.AppaltiMap._homeCompanyCpvPrefixes = null;
                    persistHomeMapAreaMode('explore');
                    syncAllHomeMapModeToggleButtons();
                    applyHomeMapCpvToolbarForMode();
                    if (drawAreaBtnHome) drawAreaBtnHome.disabled = false;
                    var msg = (err && err.message) ? String(err.message) : 'Errore';
                    setStatus('Territori profilo: ' + msg);
                });
        };

        if (modeToggleBtnHome && memberUuid) {
            syncAllHomeMapModeToggleButtons();
            modeToggleBtnHome.addEventListener('click', function () {
                if (typeof window.AppaltiMap._runHomeMapAreaModeToggle === 'function') {
                    window.AppaltiMap._runHomeMapAreaModeToggle();
                }
            });

            (function scheduleRestoreHomeMapAreaModeFromStorage() {
                var wantCompany = false;
                try {
                    wantCompany = localStorage.getItem(VG_HOME_MAP_AREA_MODE_STORAGE_KEY) === 'company';
                } catch (e) {
                    return;
                }
                if (!wantCompany) return;

                function attemptRestore() {
                    if (window.AppaltiMap._homeMapAreaMode === 'company') return;
                    if (!drawReady || !window.AppaltiMap.draw) return;
                    try {
                        modeToggleBtnHome.click();
                    } catch (e2) {}
                }

                function onMapReady() {
                    window.setTimeout(function () {
                        if (drawReady && window.AppaltiMap.draw) {
                            attemptRestore();
                            return;
                        }
                        var n = 0;
                        var iv = window.setInterval(function () {
                            n += 1;
                            if (drawReady && window.AppaltiMap.draw) {
                                window.clearInterval(iv);
                                attemptRestore();
                            } else if (n > 80) {
                                window.clearInterval(iv);
                            }
                        }, 50);
                    }, 0);
                }

                try {
                    if (map.isStyleLoaded && map.isStyleLoaded()) {
                        onMapReady();
                    } else {
                        map.once('load', onMapReady);
                    }
                } catch (eM) {
                    map.once('load', onMapReady);
                }
            })();
        }

        // When filters change, update colors and reload clusters/tenders for current bbox
        document.querySelectorAll('.appaltimap-filter-input').forEach(function (input) {
            input.addEventListener('change', function () {
                if (input.hasAttribute('data-regional-toggle')) {
                    saveRegionalToggle(!!input.checked);
                    syncRegionalToggleVisualState();
                    onRefresh();
                    return;
                }
                if (input.checked) {
                    // Radio-style behaviour: only one outcome active at a time (non tocca «Gare regionali»)
                    document.querySelectorAll('.appaltimap-filter-input').forEach(function (other) {
                        if (other !== input && !other.hasAttribute('data-regional-toggle')) {
                            other.checked = false;
                        }
                    });
                    savePrimaryOutcome(input.getAttribute('data-outcome') || '');
                } else {
                    // If user unchecks all, clear saved outcome.
                    if (!getSelectedOutcomes().length) savePrimaryOutcome('');
                }
                applyClusterColorForOutcome(map);
                onRefresh();
                // If the paid-tier search table is already visible, refresh it too.
                try {
                    if (document.getElementById('appaltimap-tabulator')) {
                        var sb = document.querySelector('[data-appaltimap-action="search-pins"]');
                        if (sb && typeof sb.click === 'function') sb.click();
                    }
                } catch (e) {  }
            });
        });

        // Popup on cluster click: fetch tenders in bbox and show Who pays, Title, Description, Amount, Address
        var popup = new window.maplibregl.Popup({ closeButton: true, closeOnClick: false, maxWidth: '400px' });
        map.on('click', 'appaltimap-clusters', function (e) {
            var props = e.features[0] && e.features[0].properties;
            if (!props) return;
            openClusterPopup(client, map, popup, e.lngLat, props, 'ted');
        });

        map.on('click', 'appaltimap-regional-clusters', function (e) {
            var feat = e.features && e.features[0];
            if (!feat) return;
            var props = Object.assign({}, feat.properties || {});
            if (!clusterCountFromProps(props) && e.point && map.queryRenderedFeatures) {
                try {
                    var hits = map.queryRenderedFeatures(e.point, { layers: ['appaltimap-regional-clusters'] });
                    if (hits && hits[0] && hits[0].properties) {
                        props.count = hits[0].properties.count;
                        if (!props.bbox && hits[0].properties.bbox) props.bbox = hits[0].properties.bbox;
                    }
                } catch (eQ) { /* ignore */ }
            }
            openClusterPopup(client, map, popup, e.lngLat, props, 'regional');
        });

        map.on('dblclick', 'appaltimap-clusters', function (e) {
            var ev = e.originalEvent || e;
            if (ev) {
                ev.preventDefault();
                ev.stopPropagation();
            }
            map.flyTo({ center: e.lngLat, zoom: 19, duration: 600 });
        });
        map.on('dblclick', 'appaltimap-regional-clusters', function (e) {
            var ev = e.originalEvent || e;
            if (ev) {
                ev.preventDefault();
                ev.stopPropagation();
            }
            map.flyTo({ center: e.lngLat, zoom: 19, duration: 600 });
        });

        map.on('mouseenter', 'appaltimap-clusters', function () {
            map.getCanvas().style.cursor = 'pointer';
        });
        map.on('mouseleave', 'appaltimap-clusters', function () {
            map.getCanvas().style.cursor = '';
        });
        map.on('mouseenter', 'appaltimap-regional-clusters', function () {
            map.getCanvas().style.cursor = 'pointer';
        });
        map.on('mouseleave', 'appaltimap-regional-clusters', function () {
            map.getCanvas().style.cursor = '';
        });

        function onRefresh() {
            return refreshAllMapClusters(client, map, clusterLayer, regionalLayer);
        }

        // CPV filter (autocomplete + immediate refresh).
        // Reuses the same backend autocomplete as radar pages: /radar/hub/cpv-suggest.
        (function initCpvFilter() {
            var cpvInput = document.getElementById('appaltimap-cpv-query');
            var cpvPrefixEl = document.getElementById('appaltimap-cpv-prefix');
            var cpvClearBtn = document.getElementById('appaltimap-cpv-clear');
            var cpvList = document.getElementById('appaltimap-cpv-list');
            if (!cpvInput || !cpvPrefixEl || !cpvList) return;
            var memberUuid = getMemberUuidFromDom();

            syncCpvClearButtonState();

            var lastFetch = 0;
            var pendingSuggest;
            var cpvRefreshTimer = null;
            var lastPrefix = getCpvPrefix();
            var lastResolvedPrefix = '';
            window.AppaltiMap._homeCpvToolbarDidChange = function () {
                lastPrefix = getCpvPrefix();
                lastResolvedPrefix = '';
            };

            function render(items) {
                while (cpvList.firstChild) cpvList.removeChild(cpvList.firstChild);
                (items || []).forEach(function (it) {
                    var opt = document.createElement('option');
                    var code = it.code_main || '';
                    var label = it.label_it || '';
                    opt.value = code + (label ? ' — ' + label : '');
                    cpvList.appendChild(opt);
                });
            }

            function resolveAndShowLabel(prefix) {
                var p = String(prefix || '').trim();
                if (!p || p === lastResolvedPrefix) return Promise.resolve();
                lastResolvedPrefix = p;
                var url = apiBase + '/radar/hub/cpv-suggest?q=' + encodeURIComponent(p) + '&limit=1';
                return fetch(url, { headers: { Accept: 'application/json' } })
                    .then(function (r) { return r.ok ? r.json() : {}; })
                    .then(function (data) {
                        var it = data && data.items && data.items[0];
                        if (!it) return;
                        var code = String(it.code_main || '').trim();
                        var label = String(it.label_it || '').trim();
                        if (!code) return;
                        cpvInput.value = code + (label ? ' — ' + label : '');
                    })
                    .catch(function () {});
            }

            function fetchSuggest(q) {
                var now = Date.now();
                lastFetch = now;
                var url = apiBase + '/radar/hub/cpv-suggest?q=' + encodeURIComponent(q) + '&limit=15';
                return fetch(url, { headers: { Accept: 'application/json' } })
                    .then(function (r) {
                        if (!r.ok) throw r;
                        return r.json();
                    })
                    .then(function (data) {
                        if (lastFetch !== now) return;
                        render((data && data.items) || []);
                    })
                    .catch(function () {});
            }

            function setPrefixFromInput() {
                var raw = String(cpvInput.value || '').trim();
                var digits = raw.replace(/\D/g, '');
                if (!digits) {
                    cpvPrefixEl.value = '';
                    syncCpvClearButtonState();
                    return '';
                }

                if (digits.length > 8) digits = digits.slice(0, 8);
                var prefix = digits.replace(/0+$/g, '');
                if (!prefix) prefix = digits;
                if (prefix === '0') prefix = '';

                cpvPrefixEl.value = prefix;
                syncCpvClearButtonState();
                return prefix;
            }

            function triggerCpvRefresh() {
                onRefresh();
                // If the paid-tier table is visible, refresh it too.
                var tabEl = document.getElementById('appaltimap-tabulator');
                if (tabEl) {
                    var sb = document.querySelector('[data-appaltimap-action="search-pins"]');
                    if (sb && typeof sb.click === 'function') sb.click();
                }
            }

            function scheduleCpvRefresh() {
                var prefix = getCpvPrefix();
                if (prefix === lastPrefix) return;
                lastPrefix = prefix;
                persistTelegramCpvPrefix(apiBase, memberUuid, prefix);
                if (cpvRefreshTimer) window.clearTimeout(cpvRefreshTimer);
                cpvRefreshTimer = window.setTimeout(function () {
                    triggerCpvRefresh();
                }, 250);
            }

            cpvInput.addEventListener('input', function () {
                setPrefixFromInput();
                scheduleCpvRefresh();

                var q = String(cpvInput.value || '').trim();
                if (pendingSuggest) window.clearTimeout(pendingSuggest);
                if (q.length < 2 && !/\d/.test(q)) return;
                pendingSuggest = window.setTimeout(function () {
                    fetchSuggest(q);
                }, 180);
            });

            cpvInput.addEventListener('blur', function () {
                var p = setPrefixFromInput();
                scheduleCpvRefresh();
                resolveAndShowLabel(p);
            });

            if (cpvClearBtn) {
                cpvClearBtn.addEventListener('click', function () {
                    cpvInput.value = '';
                    cpvPrefixEl.value = '';
                    syncCpvClearButtonState();
                    lastPrefix = '';
                    lastResolvedPrefix = '';
                    persistTelegramCpvPrefix(apiBase, memberUuid, '');
                    if (cpvRefreshTimer) window.clearTimeout(cpvRefreshTimer);
                    triggerCpvRefresh();
                });
            }

            // Hydrate CPV filter from backend preference.
            if (memberUuid) {
                fetch(apiBase + '/telegram/settings?member=' + encodeURIComponent(memberUuid), { headers: { Accept: 'application/json' } })
                    .then(function (r) { return r.ok ? r.json() : {}; })
                    .then(function (data) {
                        if (data && data.mode) window.AppaltiMap._telegramNotifyMode = data.mode;
                        if (window.AppaltiMap._homeMapAreaMode === 'company') return;
                        var p = String((data && data.cpv_prefix) || '').trim();
                        if (!p) return;
                        cpvPrefixEl.value = p;
                        lastPrefix = p;
                        lastResolvedPrefix = '';
                        syncCpvClearButtonState();
                        resolveAndShowLabel(p);
                        triggerCpvRefresh();
                    })
                    .catch(function () {});
            }
        })();

        exchangePromise.finally(function () {
            map.once('load', onRefresh);
        });

        var refreshTimer = null;
        function scheduleRefresh() {
            if (refreshTimer) window.clearTimeout(refreshTimer);
            refreshTimer = window.setTimeout(onRefresh, 250);
        }
        map.on('moveend', scheduleRefresh);

        var reloadBtn = qs('[data-appaltimap-action="reload"]');
        if (reloadBtn) {
            reloadBtn.addEventListener('click', function () {
                onRefresh();
            });
        }
    }

    document.addEventListener('DOMContentLoaded', function () {
        try {
            initHomeMap();
        } catch (e) {
            setStatus('Map failed to initialize.');
        }
    });

    // VistaGare AI chat (paid-only): frontend orchestrator only.
    (function initAiChat() {
        function qsAi(sel) { return document.querySelector(sel); }
        var modal = qsAi('[data-vg-ai-modal]');
        if (!modal) return;
        var openBtn = qsAi('[data-appaltimap-action="ai-chat"]');
        var closeBtn = qsAi('[data-vg-ai-close]');
        var messagesEl = qsAi('[data-vg-ai-messages]');
        var form = qsAi('[data-vg-ai-form]');
        var input = qsAi('[data-vg-ai-input]');
        var summaryEl = qsAi('[data-vg-ai-summary]');
        var tableEl = qsAi('[data-vg-ai-table]');
        var chartBlock = qsAi('[data-vg-ai-chart-block]');
        var chartTitleEl = qsAi('[data-vg-ai-chart-title]');
        var chartSubEl = qsAi('[data-vg-ai-chart-subtitle]');
        var chartCanvas = qsAi('[data-vg-ai-chart]');
        var clearBtn = qsAi('[data-vg-ai-clear]');
        var exportPdfBtn = qsAi('[data-vg-ai-export-pdf]');
        var minimapToggle = qsAi('[data-vg-ai-minimap-toggle]');
        var minimapWrapEl = qsAi('[data-vg-ai-minimap-wrap]');
        var confirmWrap = qsAi('[data-vg-ai-confirm]');
        var confirmCancel = qsAi('[data-vg-ai-confirm-cancel]');
        var confirmOk = qsAi('[data-vg-ai-confirm-ok]');
        var confirmBackdrop = qsAi('[data-vg-ai-confirm-backdrop]');
        if (!openBtn || !closeBtn || !messagesEl || !form || !input || !summaryEl || !tableEl) return;

        // Results feed (right panel) enabled for all paid users.
        var isBetaResultsUser = true;

        var resultsWrap = summaryEl && summaryEl.parentElement ? summaryEl.parentElement : null; // .vg-ai-results
        var resultsFeedEl = null;
        var resultsCards = []; // [{ el, tab, chart }]

        function enableResultsFeedMode() {
            if (!resultsWrap) return;
            resultsWrap.classList.add('vg-ai-results--feed');
            resultsFeedEl = document.createElement('div');
            resultsFeedEl.className = 'vg-ai-results-feed';
            resultsWrap.appendChild(resultsFeedEl);
        }

        var apiBase = getApiBaseFromDom().replace(/\/+$/, '');
        var tokenStore = new window.AppaltiMap.TokenStore('appaltimap_auth');
        var authToken = function () { return tokenStore.getToken() || ''; };

        var history = [];
        var tab;
        
        var lastConversationState = null;
        
        var lastTabulatorSnapshot = null;
        // One-shot flag: next request tells backend to ignore any continuity state.
        var _vgAiForceResetNext = false;
        // Prevent repeated full-load fetch loops for the same tenders query.
        var _vgAiFullLoadKey = null;

        var minimapUserPinned = false;
        var minimapShownForLoading = false;
        var minimapAutoHideTimer = null;
        var AI_MINIMAP_AUTO_HIDE_MS = 4000;
        var aiMinimapMap = null;
        var AI_MINIMAP_ITALY_BBOX = '6.60,36.60,18.90,47.20';

        function clearMinimapAutoHideTimer() {
            if (minimapAutoHideTimer != null) {
                try {
                    clearTimeout(minimapAutoHideTimer);
                } catch (eT) {}
                minimapAutoHideTimer = null;
            }
        }

        function scheduleMinimapAutoHide() {
            clearMinimapAutoHideTimer();
            minimapAutoHideTimer = window.setTimeout(function () {
                minimapAutoHideTimer = null;
                if (minimapUserPinned) return;
                if (minimapWrapEl && !minimapWrapEl.hidden) {
                    showMinimapPanel(false);
                }
            }, AI_MINIMAP_AUTO_HIDE_MS);
        }

        var _aiChartJsInstance = null;
        var AI_LAST_TABLE_MAX_ROWS = 280;

        function destroyAiChartJs() {
            if (_aiChartJsInstance) {
                try {
                    _aiChartJsInstance.destroy();
                } catch (eCh) {}
                _aiChartJsInstance = null;
            }
        }

        function hideAiChartBlock() {
            destroyAiChartJs();
            if (chartBlock) {
                chartBlock.hidden = true;
            }
        }

        function destroyChartInstance(inst) {
            if (inst) {
                try { inst.destroy(); } catch (eDch) {}
            }
        }

        function vgAiChartPalette(n) {
            var base = [
                '#2563eb',
                '#16a34a',
                '#ea580c',
                '#9333ea',
                '#0891b2',
                '#ca8a04',
                '#db2777',
                '#4f46e5',
                '#0d9488',
                '#b45309'
            ];
            var out = [];
            for (var i = 0; i < n; i++) {
                out.push(base[i % base.length]);
            }
            return out;
        }

        
        function decodeHtmlEntities(s) {
            if (s == null) {
                return '';
            }
            var str = String(s);
            if (!str) {
                return '';
            }
            try {
                var txt = document.createElement('textarea');
                txt.innerHTML = str;
                return txt.value;
            } catch (e1) {
                return str;
            }
        }

        function renderAiChartInto(canvasEl, payload) {
            if (!canvasEl || !payload || typeof window.Chart === 'undefined') return null;
            try {
                var type = payload.type || 'pie';
                var labels = Array.isArray(payload.labels) ? payload.labels.slice() : [];
                var values = Array.isArray(payload.values) ? payload.values.slice() : [];
                var title = decodeHtmlEntities(payload.title || '');
                var subtitle = decodeHtmlEntities(payload.subtitle || '');
                var showLeg = payload.show_legend !== false;
                var colors = vgAiChartPalette(labels.length);

                var ctx = canvasEl.getContext('2d');
                return new window.Chart(ctx, {
                    type: type,
                    data: {
                        labels: labels,
                        datasets: [
                            {
                                label: subtitle || title || '',
                                data: values,
                                backgroundColor: colors,
                                borderWidth: 0
                            }
                        ]
                    },
                    options: {
                        responsive: true,
                        maintainAspectRatio: true,
                        aspectRatio: type === 'bar' ? 1.65 : 1.12,
                        plugins: {
                            legend: {
                                display: showLeg,
                                position: 'bottom'
                            },
                            title: title
                                ? {
                                      display: true,
                                      text: title
                                  }
                                : { display: false },
                            tooltip: {
                                callbacks: {
                                    label: function (ctx2) {
                                        var label = ctx2.label || '';
                                        var raw =
                                            ctx2.parsed &&
                                            typeof ctx2.parsed === 'object' &&
                                            ctx2.parsed.y != null
                                                ? ctx2.parsed.y
                                                : ctx2.parsed;
                                        var n = Number(raw);
                                        if (!isFinite(n)) {
                                            return label;
                                        }
                                        return (
                                            (label ? label + ': ' : '') +
                                            n.toLocaleString('it-IT', {
                                                minimumFractionDigits: 0,
                                                maximumFractionDigits: 2
                                            })
                                        );
                                    }
                                }
                            }
                        }
                    }
                });
            } catch (eChartAny) {
                return null;
            }
        }

        function renderAiChartFromPayload(chart) {
            if (!chartBlock || !chartCanvas) {
                return;
            }
            if (
                !chart ||
                !Array.isArray(chart.labels) ||
                !Array.isArray(chart.values) ||
                chart.labels.length === 0 ||
                chart.labels.length !== chart.values.length
            ) {
                hideAiChartBlock();
                return;
            }
            if (typeof Chart === 'undefined') {
                return;
            }
            destroyAiChartJs();
            chartBlock.hidden = false;
            if (chartTitleEl) {
                chartTitleEl.textContent = decodeHtmlEntities(chart.title || '');
            }
            if (chartSubEl) {
                var sub = decodeHtmlEntities(String(chart.subtitle || '').trim());
                chartSubEl.textContent = sub;
                chartSubEl.hidden = !sub;
            }
            var type = String(chart.type || 'pie').toLowerCase();
            if (type !== 'bar' && type !== 'pie' && type !== 'doughnut') {
                type = 'pie';
            }
            var labels = chart.labels.map(function (x) {
                return decodeHtmlEntities(String(x));
            });
            var values = chart.values.map(function (x) {
                var n = Number(x);
                return isFinite(n) ? n : 0;
            });
            var colors = vgAiChartPalette(labels.length);
            var showLeg = chart.show_legend !== false;
            var ctx2d = chartCanvas.getContext('2d');
            if (!ctx2d) {
                return;
            }
            _aiChartJsInstance = new Chart(ctx2d, {
                type: type,
                data: {
                    labels: labels,
                    datasets: [
                        {
                            label: '',
                            data: values,
                            backgroundColor: colors,
                            borderColor: type === 'pie' || type === 'doughnut' ? '#fff' : colors,
                            borderWidth: type === 'bar' ? 0 : type === 'pie' || type === 'doughnut' ? 1 : 0
                        }
                    ]
                },
                options: {
                    responsive: true,
                    maintainAspectRatio: true,
                    aspectRatio: type === 'bar' ? 1.65 : 1.12,
                    plugins: {
                        legend: {
                            display: showLeg,
                            position: 'bottom'
                        },
                        tooltip: {
                            callbacks: {
                                label: function (ctx) {
                                    var label = ctx.label || '';
                                    var raw =
                                        ctx.parsed &&
                                        typeof ctx.parsed === 'object' &&
                                        ctx.parsed.y != null
                                            ? ctx.parsed.y
                                            : ctx.parsed;
                                    var n = Number(raw);
                                    if (!isFinite(n)) {
                                        return label;
                                    }
                                    return (
                                        (label ? label + ': ' : '') +
                                        n.toLocaleString('it-IT', {
                                            minimumFractionDigits: 0,
                                            maximumFractionDigits: 2
                                        })
                                    );
                                }
                            }
                        }
                    }
                }
            });
        }

        function aiChatStorageKey() {
            var host = typeof location !== 'undefined' && location.hostname ? location.hostname : 'default';
            var mem = '';
            try {
                mem = getMemberUuidFromDom() || '';
            } catch (e1) {}
            return 'vg_ai_chat_v1:' + host + ':' + (mem || 'anon');
        }

        function persistAiChatState() {
            try {
                var snap = lastTabulatorSnapshot;
                var rows = (snap && snap.data) ? snap.data : [];
                if (rows.length > 400) {
                    snap = {
                        columns: (snap && snap.columns) ? snap.columns : [],
                        data: rows.slice(0, 400)
                    };
                }
                var payload = {
                    v: 1,
                    ts: Date.now(),
                    history: history.slice(-40),
                    lastConversationState: lastConversationState,
                    summaryHtml: summaryEl.innerHTML,
                    summaryDataOnly: summaryEl.classList.contains('vg-ai-results__summary--data-only'),
                    tabulator: snap
                };
                if (isBetaResultsUser && Array.isArray(resultsCards) && resultsCards.length) {
                    payload.resultsFeed = resultsCards
                        .slice(-resultsFeedMax())
                        .map(function (c) {
                            var p = c && c.payload ? c.payload : {};
                            var tabSnap = null;
                            try {
                                var cols = p && p.tabulator && Array.isArray(p.tabulator.columns) ? p.tabulator.columns : [];
                                var d = p && p.tabulator && Array.isArray(p.tabulator.data) ? p.tabulator.data : [];
                                tabSnap = { columns: cols.slice(), data: d.slice(0, 250) };
                            } catch (eS1) {}
                            var effSnap = null;
                            try {
                                if (p && p.effects && p.effects.density_heatmap) {
                                    effSnap = { density_heatmap: p.effects.density_heatmap };
                                }
                            } catch (eEff) {}
                            return {
                                summaryRight: (c && c.summaryRight) ? String(c.summaryRight) : '',
                                chart: p && p.chart ? p.chart : null,
                                tabulator: tabSnap,
                                effects: effSnap,
                                conversation_state: p && p.conversation_state ? p.conversation_state : null
                            };
                        });
                }
                var str = JSON.stringify(payload);
                if (str.length > 4200000 && payload.tabulator && payload.tabulator.data) {
                    payload.tabulator = {
                        columns: payload.tabulator.columns || [],
                        data: (payload.tabulator.data || []).slice(0, 200)
                    };
                    str = JSON.stringify(payload);
                }
                localStorage.setItem(aiChatStorageKey(), str);
            } catch (e2) {
                
            }
        }

        function restoreAiChatState() {
            try {
                var raw = localStorage.getItem(aiChatStorageKey());
                if (!raw) return;
                var s = JSON.parse(raw);
                if (!s || s.v !== 1 || !Array.isArray(s.history)) return;

                lastConversationState =
                    s.lastConversationState != null && typeof s.lastConversationState === 'object'
                        ? s.lastConversationState
                        : null;
                lastTabulatorSnapshot =
                    s.tabulator &&
                    s.tabulator.columns &&
                    Array.isArray(s.tabulator.data)
                        ? { columns: s.tabulator.columns, data: s.tabulator.data }
                        : null;

                history = s.history
                    .filter(function (m) {
                        return m && (m.role === 'user' || m.role === 'assistant');
                    })
                    .map(function (m) {
                        return { role: m.role, content: m.content || '' };
                    });

                messagesEl.innerHTML = '';
                history.forEach(function (m) {
                    addMsg(m.role, m.content || '');
                });

                if (typeof s.summaryHtml === 'string') {
                    summaryEl.innerHTML = s.summaryHtml;
                    if (s.summaryDataOnly) summaryEl.classList.add('vg-ai-results__summary--data-only');
                    else summaryEl.classList.remove('vg-ai-results__summary--data-only');
                }

                if (lastTabulatorSnapshot && lastTabulatorSnapshot.columns && lastTabulatorSnapshot.columns.length) {
                    ensureTabulator(lastTabulatorSnapshot.columns, lastTabulatorSnapshot.data || []);
                }
                hideAiChartBlock();

                try {
                    syncLastAiGeoFromConversationState(lastConversationState);
                } catch (eSync) {}

                // Beta: restore right-side results feed
                if (isBetaResultsUser && resultsFeedEl && Array.isArray(s.resultsFeed) && s.resultsFeed.length) {
                    // Clear existing cards (if any)
                    try {
                        while (resultsCards.length) {
                            destroyResultCard(resultsCards.shift());
                        }
                        resultsFeedEl.innerHTML = '';
                    } catch (eClr) {}
                    s.resultsFeed.slice(-resultsFeedMax()).forEach(function (it) {
                        var payload = {
                            summary_text: '', // not used here
                            tabulator: it && it.tabulator ? it.tabulator : { columns: [], data: [] },
                            chart: it && it.chart ? it.chart : null,
                            effects: it && it.effects ? it.effects : null,
                            conversation_state: it && it.conversation_state ? it.conversation_state : null
                        };
                        appendResultCardFromPayload(payload, (it && it.summaryRight) ? it.summaryRight : '');
                    });
                }
            } catch (e3) {
                
            }
        }

        function escapeHtmlPlain(s) {
            return String(s)
                .replace(/&/g, '&amp;')
                .replace(/</g, '&lt;')
                .replace(/>/g, '&gt;')
                .replace(/"/g, '&quot;');
        }

        
        function renderAiMarkdown(text) {
            var s = String(text || '');
            if (!s) return '';
            var html;
            try {
                if (typeof marked !== 'undefined' && marked && typeof marked.parse === 'function') {
                    html = marked.parse(s, { breaks: true, gfm: true });
                } else {
                    html = '<p>' + escapeHtmlPlain(s).replace(/\n/g, '<br>') + '</p>';
                }
                if (typeof DOMPurify !== 'undefined' && DOMPurify && typeof DOMPurify.sanitize === 'function') {
                    // Allow tooltips on inline spans in AI summaries (e.g. CPV codes with title=description).
                    html = DOMPurify.sanitize(html, {
                        USE_PROFILES: { html: true },
                        ADD_TAGS: ['span', 'details', 'summary', 'div'],
                        ADD_ATTR: ['title', 'open'],
                        // Be explicit: some DOMPurify builds/profiles are stricter on global attrs.
                        ALLOWED_ATTR: ['href', 'src', 'alt', 'title', 'target', 'rel', 'class', 'id', 'aria-label', 'role']
                    });
                }
            } catch (e) {
                html = '<p>' + escapeHtmlPlain(s).replace(/\n/g, '<br>') + '</p>';
            }
            return html;
        }

        function parseBboxFour(s) {
            var p = String(s || '').split(',').map(Number);
            if (p.length !== 4 || p.some(function (x) { return !isFinite(x); })) return null;
            return { west: p[0], south: p[1], east: p[2], north: p[3] };
        }

        function geoCirclePolygon(centerLon, centerLat, radiusKm, segments) {
            segments = segments || 64;
            var R = 6371;
            var lat1 = (centerLat * Math.PI) / 180;
            var lon1 = (centerLon * Math.PI) / 180;
            var dByR = radiusKm / R;
            var coords = [];
            var i;
            for (i = 0; i <= segments; i++) {
                var brng = (i / segments) * 2 * Math.PI;
                var lat2 = Math.asin(
                    Math.sin(lat1) * Math.cos(dByR) + Math.cos(lat1) * Math.sin(dByR) * Math.cos(brng)
                );
                var lon2 =
                    lon1 +
                    Math.atan2(
                        Math.sin(brng) * Math.sin(dByR) * Math.cos(lat1),
                        Math.cos(dByR) - Math.sin(lat1) * Math.sin(lat2)
                    );
                coords.push([(lon2 * 180) / Math.PI, (lat2 * 180) / Math.PI]);
            }
            return { type: 'Polygon', coordinates: [coords] };
        }

        function bboxPolygonGeom(west, south, east, north) {
            return {
                type: 'Polygon',
                coordinates: [[[west, south], [east, south], [east, north], [west, north], [west, south]]]
            };
        }

        function syncLastAiGeoFromConversationState(st) {
            if (!window.AppaltiMap) return;
            if (!st || typeof st !== 'object') return;
            if (st.intent === 'tenders_table') {
                var gk = String(st.geo_kind || '').toLowerCase();
                if (gk === 'polygon' || st.use_saved_area) {
                    window.AppaltiMap._lastAiGeo = null;
                    return;
                }
                if (gk === 'italy') {
                    var itB = parseBboxFour(AI_MINIMAP_ITALY_BBOX);
                    if (itB) {
                        window.AppaltiMap._lastAiGeo = {
                            kind: 'bbox',
                            west: itB.west,
                            south: itB.south,
                            east: itB.east,
                            north: itB.north
                        };
                    }
                    return;
                }
                if (gk === 'circle' && st.geo_center && st.geo_center.length === 2) {
                    var rC = Number(st.geo_radius_km);
                    if (isFinite(rC) && rC > 0) {
                        window.AppaltiMap._lastAiGeo = {
                            kind: 'circle',
                            center: [Number(st.geo_center[0]), Number(st.geo_center[1])],
                            radiusKm: rC
                        };
                        return;
                    }
                }
                if (gk === 'region_polygon' && st.region_preview_geojson) {
                    var rgg = st.region_preview_geojson;
                    if (rgg.type === 'Polygon' || rgg.type === 'MultiPolygon') {
                        window.AppaltiMap._lastAiGeo = { kind: 'polygon', geometry: rgg };
                        return;
                    }
                }
                if (gk === 'company_profile' && st.company_profile_geojson) {
                    var gco = st.company_profile_geojson;
                    if (gco.type === 'Polygon' || gco.type === 'MultiPolygon') {
                        window.AppaltiMap._lastAiGeo = { kind: 'polygon', geometry: gco };
                    }
                    return;
                }
                var bb = String(st.bbox_used || '').split(',').map(Number);
                if (bb.length === 4 && bb.every(isFinite)) {
                    window.AppaltiMap._lastAiGeo = {
                        kind: 'bbox',
                        west: bb[0],
                        south: bb[1],
                        east: bb[2],
                        north: bb[3]
                    };
                    return;
                }
                return;
            }
            if (st.intent === 'radar_density') {
                var gkd = String(st.geo_kind || '').toLowerCase();
                if (gkd === 'company_profile' && st.company_profile_geojson) {
                    var gc2 = st.company_profile_geojson;
                    if (gc2.type === 'Polygon' || gc2.type === 'MultiPolygon') {
                        window.AppaltiMap._lastAiGeo = { kind: 'polygon', geometry: gc2 };
                    }
                }
                return;
            }
            if (st.intent === 'radar_hub' && st.engine_area_bbox) {
                var b2 = String(st.engine_area_bbox).split(',').map(Number);
                if (b2.length === 4 && b2.every(isFinite)) {
                    window.AppaltiMap._lastAiGeo = {
                        kind: 'bbox',
                        west: b2[0],
                        south: b2[1],
                        east: b2[2],
                        north: b2[3]
                    };
                }
            }
        }

        function mergeCompanyTerritoriesFcToGeometry(fc) {
            if (!fc || fc.type !== 'FeatureCollection' || !Array.isArray(fc.features) || !fc.features.length) {
                return null;
            }
            var polys = [];
            fc.features.forEach(function (f) {
                var g = f && f.geometry;
                if (!g) return;
                if (g.type === 'Polygon' && g.coordinates) polys.push(g.coordinates);
                else if (g.type === 'MultiPolygon' && g.coordinates) {
                    (g.coordinates || []).forEach(function (p) {
                        if (p) polys.push(p);
                    });
                }
            });
            if (!polys.length) return null;
            if (polys.length === 1) return { type: 'Polygon', coordinates: polys[0] };
            return { type: 'MultiPolygon', coordinates: polys };
        }

        function minimapSelectionFromConversationState(st) {
            if (!st || typeof st !== 'object') return null;
            if (st.intent === 'radar_hub' && st.engine_area_bbox) {
                var rb = String(st.engine_area_bbox).split(',').map(Number);
                if (rb.length === 4 && rb.every(isFinite)) {
                    return { kind: 'bbox', geometry: bboxPolygonGeom(rb[0], rb[1], rb[2], rb[3]) };
                }
            }
            var gkCo = String(st.geo_kind || '').toLowerCase();
            if (
                (st.intent === 'tenders_table' || st.intent === 'radar_density') &&
                gkCo === 'company_profile' &&
                st.company_profile_geojson
            ) {
                var cg = st.company_profile_geojson;
                if (cg.type === 'Polygon' || cg.type === 'MultiPolygon') {
                    return { kind: 'polygon', geometry: cg };
                }
            }
            if (st.intent === 'radar_density') return null;
            if (st.intent !== 'tenders_table') return null;
            var gk = String(st.geo_kind || '').toLowerCase();
            if (st.use_saved_area || gk === 'polygon') {
                var sg =
                    window.AppaltiMap && window.AppaltiMap._savedAreaGeojson
                        ? window.AppaltiMap._savedAreaGeojson
                        : null;
                if (sg && sg.type === 'Polygon' && sg.coordinates && sg.coordinates[0] && sg.coordinates[0].length >= 3) {
                    return { kind: 'polygon', geometry: sg };
                }
            }
            if (gk === 'italy') {
                var it = parseBboxFour(AI_MINIMAP_ITALY_BBOX);
                if (it) {
                    return { kind: 'bbox', geometry: bboxPolygonGeom(it.west, it.south, it.east, it.north) };
                }
            }
            if (gk === 'circle' && st.geo_center && st.geo_center.length === 2) {
                var r = Number(st.geo_radius_km);
                if (isFinite(r) && r > 0) {
                    return {
                        kind: 'circle',
                        geometry: geoCirclePolygon(
                            Number(st.geo_center[0]),
                            Number(st.geo_center[1]),
                            r
                        )
                    };
                }
            }
            if (gk === 'region_polygon' && st.region_preview_geojson) {
                var rgj = st.region_preview_geojson;
                if (rgj.type === 'Polygon' || rgj.type === 'MultiPolygon') {
                    return { kind: 'polygon', geometry: rgj };
                }
            }
            var bb2 = String(st.bbox_used || '').split(',').map(Number);
            if (bb2.length === 4 && bb2.every(isFinite)) {
                return { kind: 'bbox', geometry: bboxPolygonGeom(bb2[0], bb2[1], bb2[2], bb2[3]) };
            }
            return null;
        }

        function resolveMinimapSelectionForAi() {
            var fromConv = minimapSelectionFromConversationState(lastConversationState);
            if (fromConv) return fromConv;
            var agPoly = window.AppaltiMap && window.AppaltiMap._lastAiGeo;
            if (
                agPoly &&
                agPoly.kind === 'polygon' &&
                agPoly.geometry &&
                (agPoly.geometry.type === 'Polygon' || agPoly.geometry.type === 'MultiPolygon')
            ) {
                return { kind: 'polygon', geometry: agPoly.geometry };
            }
            var geom = window.AppaltiMap && window.AppaltiMap._savedAreaGeojson;
            if (geom && geom.type === 'Polygon' && geom.coordinates && geom.coordinates[0] && geom.coordinates[0].length >= 3) {
                return { kind: 'polygon', geometry: geom };
            }
            var ag = window.AppaltiMap && window.AppaltiMap._lastAiGeo;
            if (ag && ag.kind === 'circle' && ag.center && ag.center.length === 2 && isFinite(ag.radiusKm) && ag.radiusKm > 0) {
                return {
                    kind: 'circle',
                    geometry: geoCirclePolygon(ag.center[0], ag.center[1], ag.radiusKm)
                };
            }
            if (
                ag &&
                ag.kind === 'bbox' &&
                isFinite(ag.west) &&
                isFinite(ag.south) &&
                isFinite(ag.east) &&
                isFinite(ag.north)
            ) {
                return { kind: 'bbox', geometry: bboxPolygonGeom(ag.west, ag.south, ag.east, ag.north) };
            }
            var mode = window.AppaltiMap && window.AppaltiMap._telegramNotifyMode;
            if (mode === 'all') {
                var it = parseBboxFour(AI_MINIMAP_ITALY_BBOX);
                if (it) {
                    return { kind: 'bbox', geometry: bboxPolygonGeom(it.west, it.south, it.east, it.north) };
                }
            }
            try {
                if (
                    window.AppaltiMap &&
                    window.AppaltiMap._homeMapAreaMode === 'company' &&
                    window.AppaltiMap._homeCompanyTerritoriesFC
                ) {
                    var cgGeom = mergeCompanyTerritoriesFcToGeometry(window.AppaltiMap._homeCompanyTerritoriesFC);
                    if (cgGeom) return { kind: 'polygon', geometry: cgGeom };
                }
            } catch (eComp) {}
            try {
                var mainMap = window.AppaltiMap && window.AppaltiMap._map;
                if (mainMap && mainMap.getBounds) {
                    var b = mainMap.getBounds();
                    return {
                        kind: 'bbox',
                        geometry: bboxPolygonGeom(b.getWest(), b.getSouth(), b.getEast(), b.getNorth())
                    };
                }
            } catch (eB) {}
            var it2 = parseBboxFour(AI_MINIMAP_ITALY_BBOX);
            if (it2) {
                return { kind: 'bbox', geometry: bboxPolygonGeom(it2.west, it2.south, it2.east, it2.north) };
            }
            return { kind: 'bbox', geometry: bboxPolygonGeom(6.6, 36.6, 18.9, 47.2) };
        }

        function boundsFromGeometry(geom) {
            if (!geom || !geom.coordinates) return null;
            var minLon = Infinity;
            var minLat = Infinity;
            var maxLon = -Infinity;
            var maxLat = -Infinity;
            function visitPt(pt) {
                if (!pt || pt.length < 2) return;
                var lon = Number(pt[0]);
                var lat = Number(pt[1]);
                if (!isFinite(lon) || !isFinite(lat)) return;
                minLon = Math.min(minLon, lon);
                minLat = Math.min(minLat, lat);
                maxLon = Math.max(maxLon, lon);
                maxLat = Math.max(maxLat, lat);
            }
            function walkCoords(coords) {
                if (!coords || !coords.length) return;
                if (typeof coords[0] === 'number') {
                    visitPt(coords);
                    return;
                }
                for (var i = 0; i < coords.length; i++) walkCoords(coords[i]);
            }
            walkCoords(geom.coordinates);
            if (!isFinite(minLon) || minLon >= maxLon || minLat >= maxLat) return null;
            return [minLon, minLat, maxLon, maxLat];
        }

        function ensureAiMinimapCreated() {
            return new Promise(function (resolve, reject) {
                if (aiMinimapMap) {
                    resolve(aiMinimapMap);
                    return;
                }
                var el = document.getElementById('vg-ai-minimap');
                if (!el || !window.maplibregl) {
                    reject(new Error('no minimap'));
                    return;
                }
                try {
                    aiMinimapMap = new window.maplibregl.Map({
                        container: el,
                        style: buildAppaltiMapBaseStyle(),
                        center: [12.5, 42.5],
                        zoom: 5,
                        attributionControl: true
                    });
                    aiMinimapMap.addControl(new window.maplibregl.NavigationControl(), 'top-right');
                } catch (eC) {
                    reject(eC);
                    return;
                }
                aiMinimapMap.once('load', function () {
                    clampMapToEurope(aiMinimapMap);
                    try {
                        aiMinimapMap.addSource('vg-ai-minimap-sel', {
                            type: 'geojson',
                            data: { type: 'FeatureCollection', features: [] }
                        });
                        aiMinimapMap.addLayer({
                            id: 'vg-ai-minimap-sel-fill',
                            type: 'fill',
                            source: 'vg-ai-minimap-sel',
                            paint: {
                                'fill-color': 'rgba(37, 99, 235, 0.2)',
                                'fill-outline-color': '#2563eb'
                            }
                        });
                        aiMinimapMap.addLayer({
                            id: 'vg-ai-minimap-sel-line',
                            type: 'line',
                            source: 'vg-ai-minimap-sel',
                            paint: { 'line-color': '#2563eb', 'line-width': 2 }
                        });
                    } catch (eL) {
                        reject(eL);
                        return;
                    }
                    resolve(aiMinimapMap);
                });
            });
        }

        function paintAiMinimapSelection(paintOpts) {
            if (!minimapWrapEl || minimapWrapEl.hidden) return;
            var po = paintOpts || {};
            var animateFit = po.animate !== false;
            ensureAiMinimapCreated()
                .then(function (m) {
                    var sel = resolveMinimapSelectionForAi();
                    var feat = { type: 'Feature', properties: {}, geometry: sel.geometry };
                    var src = m.getSource('vg-ai-minimap-sel');
                    if (src && src.setData) {
                        src.setData({ type: 'FeatureCollection', features: [feat] });
                    }
                    var bb = boundsFromGeometry(sel.geometry);
                    if (bb) {
                        m.fitBounds([[bb[0], bb[1]], [bb[2], bb[3]]], {
                            padding: vgMapFitPaddingPx(),
                            duration: animateFit ? 650 : 0,
                            maxZoom: 11
                        });
                    }
                    m.resize();
                })
                .catch(function () {});
        }

        function showMinimapPanel(visible) {
            if (!minimapWrapEl) return;
            minimapWrapEl.hidden = !visible;
            minimapWrapEl.setAttribute('aria-hidden', visible ? 'false' : 'true');
            if (minimapToggle) {
                minimapToggle.setAttribute('aria-pressed', visible ? 'true' : 'false');
            }
            if (visible) {
                window.requestAnimationFrame(function () {
                    window.requestAnimationFrame(function () {
                        paintAiMinimapSelection({ animate: false });
                    });
                });
            }
        }

        window.AppaltiMap._refreshAiMinimap = function () {
            try {
                if (minimapWrapEl && !minimapWrapEl.hidden) paintAiMinimapSelection({ animate: false });
            } catch (eRef) {}
        };

        function setOpen(open) {
            modal.hidden = !open;
            modal.setAttribute('aria-hidden', open ? 'false' : 'true');
            document.body.style.overflow = open ? 'hidden' : '';
            if (!open) {
                clearMinimapAutoHideTimer();
                minimapUserPinned = false;
                minimapShownForLoading = false;
                showMinimapPanel(false);
            } else {
                try {
                    syncAllHomeMapModeToggleButtons();
                } catch (eSync) {}
                try {
                    input.focus();
                } catch (e) {}
            }
        }

        function setRightLoading(isLoading, fromError) {
            try {
                modal.classList.toggle('vg-ai-loading', !!isLoading);
            } catch (eLd) {}
            if (isLoading) {
                clearMinimapAutoHideTimer();
                minimapShownForLoading = true;
                showMinimapPanel(true);
            } else {
                if (fromError) {
                    clearMinimapAutoHideTimer();
                    minimapShownForLoading = false;
                    if (!minimapUserPinned) {
                        showMinimapPanel(false);
                    }
                    return;
                }
                var scheduleHide = minimapShownForLoading && !minimapUserPinned;
                minimapShownForLoading = false;
                if (scheduleHide) {
                    scheduleMinimapAutoHide();
                } else if (!minimapUserPinned) {
                    showMinimapPanel(false);
                }
            }
        }

        function addMsg(role, text) {
            var div = document.createElement('div');
            div.className =
                'vg-ai-msg vg-ai-md ' + (role === 'user' ? 'vg-ai-msg--user' : 'vg-ai-msg--assistant');
            div.innerHTML = renderAiMarkdown(text);
            messagesEl.appendChild(div);
            try { messagesEl.scrollTop = messagesEl.scrollHeight; } catch (e) {}
        }

        /** Riga fissa sotto ogni risposta: modalità mappa, CPV effettivi, tipo esito bando. */
        function appendAiChatLeftFooter(eff) {
            if (!messagesEl) return;
            var meta = eff && eff.left_chat_meta;
            var modeLabel = 'esplorazione';
            var prefsStr = '—';
            var outcomesCsv = '';
            if (meta && typeof meta === 'object') {
                modeLabel = meta.map_area === 'company' ? 'territori' : 'esplorazione';
                if (Array.isArray(meta.cpv_prefixes) && meta.cpv_prefixes.length) {
                    prefsStr = meta.cpv_prefixes
                        .map(function (x) {
                            return String(x || '').trim();
                        })
                        .filter(Boolean)
                        .join(', ');
                }
                outcomesCsv = String(meta.outcomes_csv || '');
            } else {
                try {
                    modeLabel =
                        window.AppaltiMap && window.AppaltiMap._homeMapAreaMode === 'company'
                            ? 'territori'
                            : 'esplorazione';
                    if (
                        modeLabel === 'territori' &&
                        window.AppaltiMap._homeCompanyCpvPrefixes &&
                        window.AppaltiMap._homeCompanyCpvPrefixes.length
                    ) {
                        prefsStr = window.AppaltiMap._homeCompanyCpvPrefixes.join(', ');
                    } else {
                        var gp = getCpvFilterParamsForMap();
                        if (gp && gp.cpv_prefixes) {
                            prefsStr = String(gp.cpv_prefixes)
                                .split(',')
                                .map(function (x) {
                                    return String(x || '').trim();
                                })
                                .filter(Boolean)
                                .join(', ');
                        }
                    }
                } catch (eDom) {}
                try {
                    outcomesCsv = (getSelectedOutcomes() || []).join(',');
                } catch (eOut) {}
            }
            var parts = String(outcomesCsv || '')
                .toLowerCase()
                .split(',')
                .map(function (x) {
                    return x.trim();
                })
                .filter(Boolean);
            var tipo = 'misto';
            if (parts.length === 1 && parts[0] === 'ongoing') tipo = 'aperte';
            else if (parts.length === 1 && parts[0] === 'awarded') tipo = 'vinte';
            else if (parts.length === 1 && parts[0] === 'expired_unawarded') tipo = 'in sospeso';
            if (eff && eff.apply_filters && eff.apply_filters.outcome) {
                var po = String(eff.apply_filters.outcome).toLowerCase();
                if (po === 'ongoing') tipo = 'aperte';
                else if (po === 'awarded') tipo = 'vinte';
                else if (po === 'expired_unawarded') tipo = 'in sospeso';
            }
            var line = '(' + modeLabel + ') (CPV: ' + prefsStr + ') (Tipo gara: ' + tipo + ')';
            var wrap = document.createElement('div');
            wrap.className = 'vg-ai-msg vg-ai-msg--assistant vg-ai-msg-footer';
            wrap.textContent = line;
            messagesEl.appendChild(wrap);
            try {
                messagesEl.scrollTop = messagesEl.scrollHeight;
            } catch (eSc) {}
            try {
                history.push({ role: 'assistant', content: line });
            } catch (eH) {}
        }

        // Backend ChatMessage.content now allows up to 20k chars; keep UX readable but
        // avoid breaking inline HTML (CPV spans/details) by splitting too aggressively.
        var AI_MSG_MAX_CHARS = 18000;

        function splitAssistantHtmlIntoSafeChunks(html) {
            var s = String(html || '');
            if (!s) return [''];
            if (s.length <= AI_MSG_MAX_CHARS) return [s];

            // Try to split specifically the "Filtro CPV per: ..." tail which can be very long.
            var m = s.match(/([\s\S]*?\bFiltro CPV per:\s*)([\s\S]*)$/m);
            var head = m ? String(m[1] || '') : '';
            var tail = m ? String(m[2] || '') : s;
            var prefix = m ? head : '';

            // Tokenize by span items when possible (avoid breaking HTML tags).
            var items = [];
            if (tail.indexOf('<span') !== -1 && tail.indexOf('</span>') !== -1) {
                var parts = tail.split(/<\/span>,\s*/);
                for (var i = 0; i < parts.length; i++) {
                    var p = String(parts[i] || '').trim();
                    if (!p) continue;
                    // Re-add closing tag (except if it already contains it)
                    if (p.indexOf('</span>') === -1) p = p + '</span>';
                    items.push(p);
                }
            } else {
                // Fallback: split on commas.
                items = tail.split(/\s*,\s*/).map(function (x) { return String(x || '').trim(); }).filter(Boolean);
            }

            var chunks = [];
            var cur = prefix;
            for (var j = 0; j < items.length; j++) {
                var token = items[j];
                var sep = (cur && cur !== prefix) ? ', ' : '';
                var candidate = cur + sep + token;
                if (candidate.length > AI_MSG_MAX_CHARS - 32) {
                    if (cur && cur !== prefix) chunks.push(cur);
                    // Start new chunk without repeating the full prefix each time
                    cur = (prefix ? 'Filtro CPV per (continua): ' : '') + token;
                } else {
                    cur = candidate;
                }
            }
            if (cur) chunks.push(cur);

            // If we couldn't isolate tail, do a simple hard split as last resort.
            if (!chunks.length) {
                for (var k = 0; k < s.length; k += (AI_MSG_MAX_CHARS - 64)) {
                    chunks.push(s.slice(k, k + (AI_MSG_MAX_CHARS - 64)));
                }
            }
            return chunks;
        }

        function addAssistantMsgSplit(text) {
            var chunks = splitAssistantHtmlIntoSafeChunks(text);
            for (var i = 0; i < chunks.length; i++) {
                addMsg('assistant', chunks[i] || '—');
                history.push({ role: 'assistant', content: String(chunks[i] || '') });
            }
        }

        function aiChatTableOrigin() {
            return (typeof window !== 'undefined' && window.location && window.location.origin)
                ? window.location.origin
                : '';
        }
        function escAiCell(s) {
            if (s == null) return '';
            return String(s)
                .replace(/&/g, '&amp;')
                .replace(/</g, '&lt;')
                .replace(/>/g, '&gt;')
                .replace(/"/g, '&quot;');
        }
        function linkAiCell(text, path) {
            var t = text == null || text === '' ? '—' : String(text);
            if (!path) return escAiCell(t);
            var href = String(path).indexOf('http') === 0 ? path : (aiChatTableOrigin() + path);
            return (
                '<a href="' +
                escAiCell(href) +
                '" class="vg-ai-table-link" target="_blank" rel="noopener noreferrer">' +
                escAiCell(t) +
                '</a>'
            );
        }
        
        function aiTableHeaderColorsFromMap() {
            var wanted = getSelectedOutcomes();
            var primary = wanted.length ? wanted[0] : 'ongoing';
            if (primary === 'awarded') return { bg: '#16a34a', fg: '#ffffff' };
            if (primary === 'expired_unawarded') return { bg: '#ea580c', fg: '#ffffff' };
            return { bg: '#2563eb', fg: '#ffffff' };
        }

        function applyAiTabulatorHeaderTheme() {
            var c = aiTableHeaderColorsFromMap();
            try {
                tableEl.style.setProperty('--vg-ai-tab-header-bg', c.bg);
                tableEl.style.setProperty('--vg-ai-tab-header-fg', c.fg);
            } catch (eTh) {}
        }

        function aiChatRowFormatter(row) {
            var el = row.getElement();
            if (!el) return;
            el.classList.remove('vg-ai-row--ongoing', 'vg-ai-row--awarded', 'vg-ai-row--expired');
            var st = String(row.getData().status || '').toLowerCase();
            if (st === 'awarded') el.classList.add('vg-ai-row--awarded');
            else if (st === 'expired_unawarded') el.classList.add('vg-ai-row--expired');
            else if (st === 'ongoing') el.classList.add('vg-ai-row--ongoing');
        }

        function formatAiIntIt(v) {
            if (v == null || v === '') {
                return '—';
            }
            var n = parseAiNumberIt(v);
            if (!isFinite(n)) {
                return escAiCell(String(v));
            }
            return escAiCell(
                n.toLocaleString('it-IT', { maximumFractionDigits: 0, useGrouping: true })
            );
        }

        function parseAiNumberIt(v) {
            if (v == null) return NaN;
            if (typeof v === 'number') return v;
            if (typeof v === 'boolean') return v ? 1 : 0;
            var s = String(v);
            if (!s) return NaN;
            // Keep digits, separators and sign; drop currency symbols and other text.
            s = s.replace(/[^\d,.\-]/g, '').trim();
            if (!s) return NaN;
            // If both separators exist, assume IT format: '.' thousands, ',' decimals.
            if (s.indexOf(',') !== -1 && s.indexOf('.') !== -1) {
                s = s.replace(/\./g, '').replace(/,/g, '.');
            } else if (s.indexOf(',') !== -1) {
                // Only comma => decimal comma.
                s = s.replace(/,/g, '.');
            }
            var n = Number(s);
            return isFinite(n) ? n : NaN;
        }

        function aiNumberSorter(a, b) {
            var na = parseAiNumberIt(a);
            var nb = parseAiNumberIt(b);
            var aOk = isFinite(na);
            var bOk = isFinite(nb);
            if (!aOk && !bOk) return 0;
            if (!aOk) return 1;
            if (!bOk) return -1;
            return na - nb;
        }

        function formatAiEuroIt(v) {
            if (v == null || v === '') {
                return '—';
            }
            var n = parseAiNumberIt(v);
            if (!isFinite(n)) {
                return escAiCell(String(v));
            }
            return escAiCell(
                n.toLocaleString('it-IT', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + '\u00a0€'
            );
        }

        function enhanceAiChatColumns(columns) {
            var cols = Array.isArray(columns) ? columns.slice() : [];
            cols.forEach(function (col) {
                var field = col.field;
                if (!field) return;
                // Ensure numeric sorting for common currency/amount fields that might arrive formatted
                // with thousands separators (e.g. "1.234,56").
                if (
                    field === 'stats_total_awarded_amount_eur' ||
                    field === 'awarded_amount_eur_sum' ||
                    field === 'amount_eur' ||
                    field === 'amount' ||
                    /_amount(_eur)?$/i.test(field) ||
                    /_eur(_sum)?$/i.test(field)
                ) {
                    if (!col.sorter) {
                        col.sorter = aiNumberSorter;
                    }
                }
                col.formatter = function (cell) {
                    var row = cell.getRow().getData();
                    var v = cell.getValue();
                    if (field === 'canonical_name') {
                        return linkAiCell(v, row.supplier_url_path);
                    }
                    if (field === 'title') {
                        return linkAiCell(v, row.procedure_url_path);
                    }
                    if (field === 'buyer_name') {
                        return linkAiCell(v, row.buyer_intel_path);
                    }
                    if (field === 'procedure_id') {
                        return linkAiCell(v, row.procedure_url_path);
                    }
                    if (field === 'stats_participations_total' || field === 'stats_wins_total') {
                        return formatAiIntIt(v);
                    }
                    if (field === 'stats_total_awarded_amount_eur') {
                        return formatAiEuroIt(v);
                    }
                    return escAiCell(v == null ? '' : String(v));
                };
            });
            var hasProcCol = cols.some(function (c) {
                return c && c.field === 'procedure_id';
            });
            if (hasProcCol && window.VistaGareKanbanLamp) {
                cols.unshift({
                    title: '',
                    field: '_vg_lamp',
                    width: 44,
                    hozAlign: 'center',
                    headerSort: false,
                    download: false,
                    formatter: function (cell) {
                        return window.VistaGareKanbanLamp.formatterCell(cell.getRow().getData());
                    }
                });
            }
            return cols;
        }

        
        function aiTabulatorInitialSort(columns) {
            var cols = columns || [];
            if (!Array.isArray(cols)) {
                return [];
            }
            if (cols.some(function (c) { return c && c.field === 'stats_total_awarded_amount_eur'; })) {
                return [{ column: 'stats_total_awarded_amount_eur', dir: 'desc' }];
            }
            if (cols.some(function (c) { return c && c.field === 'awarded_amount_eur_sum'; })) {
                return [{ column: 'awarded_amount_eur_sum', dir: 'desc' }];
            }
            return [];
        }

        function ensureTabulator(columns, data) {
            if (typeof window.Tabulator === 'undefined') return;
            applyAiTabulatorHeaderTheme();
            var cols = enhanceAiChatColumns(columns || []);
            var rows = data || [];
            var initialSort = aiTabulatorInitialSort(columns || []);
            // We keep Tabulator in local pagination mode, but if the AI result reports a larger total,
            // we progressively load all pages (up to a safety cap) via /ai/tenders-page.
            var canLoadAll =
                lastConversationState &&
                lastConversationState.intent === 'tenders_table' &&
                lastConversationState.total != null &&
                Number(lastConversationState.total) > 0;
            var isRadarHub =
                lastConversationState &&
                lastConversationState.intent === 'radar_hub' &&
                lastConversationState.total != null &&
                Number(lastConversationState.total) > 0;
            // Rebuild when switching between local/remote modes (radar_hub uses remote paging).
            var desiredMode = isRadarHub ? 'remote-radar-hub' : 'local';
            if (tab && tab.__vgMode && tab.__vgMode !== desiredMode) {
                try { tab.destroy(); } catch (eDestroy) {}
                tab = null;
            }
            if (!tab) {
                var tabOpts = {
                    layout: 'fitColumns',
                    placeholder: 'Nessun dato',
                    data: rows,
                    columns: cols,
                    height: 400,
                    pagination: true,
                    paginationSize: 25,
                    paginationSizeSelector: [25, 50, 100, 200],
                    rowFormatter: aiChatRowFormatter,
                    paginationCounter: function (pageSize, currentRow, currentPage, totalRows) {
                        if (!totalRows) return '';
                        var last = Math.min(currentRow + pageSize - 1, totalRows);
                        return 'Mostrando ' + currentRow + '–' + last + ' di ' + totalRows;
                    }
                };
                if (isRadarHub) {
                    // Remote pagination for large radar hub tables.
                    tabOpts.paginationMode = 'remote';
                    tabOpts.ajaxURL = apiBase + '/ai/radar-hub-page';
                    tabOpts.ajaxConfig = 'POST';
                    tabOpts.ajaxContentType = 'json';
                    tabOpts.ajaxRequestFunc = function (url, config, params) {
                        var headers = { Accept: 'application/json', 'Content-Type': 'application/json' };
                        var t = authToken();
                        if (t) headers.Authorization = 'Bearer ' + t;
                        var pageNum = params && params.page ? Number(params.page) : 1;
                        if (!isFinite(pageNum) || pageNum < 1) pageNum = 1;
                        var payload = {
                            page: pageNum,
                            size: params && params.size ? params.size : (tabOpts.paginationSize || 25),
                            conversation_state: lastConversationState || {},
                            context: currentMapContext()
                        };
                        return fetch(url, { method: 'POST', headers: headers, body: JSON.stringify(payload) })
                            .then(function (r) { return r.ok ? r.json() : r.text().then(function (t2) { throw new Error(t2 || ('HTTP ' + r.status)); }); })
                            .then(function (j) {
                                var rows = Array.isArray(j && j.data) ? j.data : [];
                                var lp = j && j.last_page != null ? Number(j.last_page) : 1;
                                if (!isFinite(lp) || lp < 1) lp = 1;
                                return { data: rows, last_page: lp, current_page: pageNum };
                            });
                    };
                    tabOpts.dataSendParams = { page: 'page', size: 'size' };
                    tabOpts.dataReceiveParams = { data: 'data', last_page: 'last_page', current_page: 'current_page' };
                    // Keep the first page data we already received from /ai/chat to avoid an empty table
                    // if Tabulator does not immediately trigger the first remote request (e.g. modal timing).
                    tabOpts.data = rows;
                }
                if (initialSort.length) {
                    tabOpts.initialSort = initialSort;
                }
                tab = new window.Tabulator(tableEl, tabOpts);
                tab.__vgMode = desiredMode;
                if (window.VistaGareKanbanLamp && tab) {
                    window.VistaGareKanbanLamp.wireTabulator(tab);
                }
                if (isRadarHub) {
                    // Ensure first remote load is triggered deterministically.
                    try {
                        setTimeout(function () {
                            try { tab.setPage(1); } catch (eP0) {}
                        }, 0);
                    } catch (eT0) {}
                }
            } else {
                tab.setColumns(cols);
                if (isRadarHub) {
                    try { tab.setPage(1); } catch (eP) { tab.setData([]); }
                } else {
                    tab.setData(rows);
                }
                if (initialSort.length) {
                    try {
                        tab.setSort(initialSort);
                    } catch (eSort) {}
                }
            }

            // Progressive "load all" for tenders_table, bounded.
            try {
                var total = canLoadAll ? Number(lastConversationState.total) : 0;
                if (canLoadAll && isFinite(total) && total > rows.length) {
                    var key;
                    try { key = JSON.stringify(lastConversationState || {}); } catch (eKey) { key = String(Date.now()); }
                    if (_vgAiFullLoadKey === key) {
                        return;
                    }
                    _vgAiFullLoadKey = key;
                    var HARD_CAP = 5000;
                    if (total > HARD_CAP) {
                        // Too many to load in-memory; keep first page only.
                        return;
                    }
                    var pageSize = 200;
                    var pages = Math.ceil(total / pageSize);
                    var acc = [];
                    var headers = { Accept: 'application/json', 'Content-Type': 'application/json' };
                    var t = authToken();
                    if (t) headers.Authorization = 'Bearer ' + t;
                    var ctxNow = currentMapContext();
                    function fetchPage(p) {
                        var payload = {
                            page: p,
                            size: pageSize,
                            conversation_state: lastConversationState || {},
                            context: ctxNow
                        };
                        return fetch(apiBase + '/ai/tenders-page', { method: 'POST', headers: headers, body: JSON.stringify(payload) })
                            .then(function (r) { return r.ok ? r.json() : Promise.reject(new Error('HTTP ' + r.status)); })
                            .then(function (resp) {
                                var d = resp && resp.data ? resp.data : [];
                                if (Array.isArray(d) && d.length) {
                                    acc = acc.concat(d);
                                }
                            });
                    }
                    // Fetch from page 1 with size=pageSize, so we don't miss rows 101-200.
                    var chain = Promise.resolve();
                    for (var p = 1; p <= pages; p++) {
                        (function (pp) {
                            chain = chain.then(function () { return fetchPage(pp); });
                        })(p);
                    }
                    chain.then(function () {
                        // De-dup best-effort by id/ted_id if present
                        var seen = {};
                        var out = [];
                        acc.forEach(function (r) {
                            var k = (r && (r.id != null ? ('id:' + r.id) : (r.ted_id ? ('ted:' + r.ted_id) : null))) || null;
                            if (k && seen[k]) return;
                            if (k) seen[k] = 1;
                            out.push(r);
                        });
                        tab.setData(out);
                        lastTabulatorSnapshot = {
                            columns: (columns || []).slice(),
                            data: out.slice()
                        };
                        persistAiChatState();
                    }).catch(function () {});
                }
            } catch (eAll) {}
        }

        function createResultTabulator(containerEl, columns, data) {
            if (!containerEl || typeof window.Tabulator === 'undefined') return null;
            try {
                applyAiTabulatorHeaderTheme();
                var cols = enhanceAiChatColumns(columns || []);
                var rows = data || [];
                var initialSort = aiTabulatorInitialSort(columns || []);
                var tabOpts = {
                    layout: 'fitColumns',
                    placeholder: 'Nessun dato',
                    data: rows,
                    columns: cols,
                    height: 360,
                    pagination: true,
                    paginationSize: 25,
                    paginationSizeSelector: [25, 50, 100, 200],
                    rowFormatter: aiChatRowFormatter,
                    paginationCounter: function (pageSize, currentRow, currentPage, totalRows) {
                        if (!totalRows) return '';
                        var last = Math.min(currentRow + pageSize - 1, totalRows);
                        return 'Mostrando ' + currentRow + '–' + last + ' di ' + totalRows;
                    }
                };
                if (initialSort.length) tabOpts.initialSort = initialSort;
                var tInst = new window.Tabulator(containerEl, tabOpts);
                if (window.VistaGareKanbanLamp && tInst) {
                    window.VistaGareKanbanLamp.wireTabulator(tInst);
                }
                return tInst;
            } catch (eTabAny) {
                return null;
            }
        }

        function resultsFeedMax() { return 10; }

        function destroyResultCard(card) {
            if (!card) return;
            if (card.tab) {
                try { card.tab.destroy(); } catch (eDT) {}
            }
            if (card.density && card.density.tab) {
                try { card.density.tab.destroy(); } catch (eDT2) {}
            }
            if (card.density && typeof card.density.insightChart === 'function') {
                try {
                    var _ich = card.density.insightChart();
                    if (_ich && typeof _ich.destroy === 'function') _ich.destroy();
                } catch (eIc) {}
            }
            if (card.chart) {
                destroyChartInstance(card.chart);
            }
            if (card.el && card.el.parentNode) {
                try { card.el.parentNode.removeChild(card.el); } catch (eRm) {}
            }
        }

        function appendResultCardFromPayload(payload, summaryRightHtml) {
            if (!resultsFeedEl || !payload) return;
            var cardEl = document.createElement('div');
            cardEl.className = 'vg-ai-result-card';

            var headEl = document.createElement('div');
            headEl.className = 'vg-ai-result-card__summary vg-ai-md';
            headEl.innerHTML = renderAiMarkdown(summaryRightHtml || '—');
            cardEl.appendChild(headEl);

            var chartInst = null;
            if (payload.chart) {
                var chartWrap = document.createElement('div');
                chartWrap.className = 'vg-ai-result-card__chart';
                var c = document.createElement('canvas');
                c.setAttribute('aria-label', 'Grafico dati');
                chartWrap.appendChild(c);
                cardEl.appendChild(chartWrap);
                chartInst = renderAiChartInto(c, payload.chart);
            }

            var densityInst = null;
            try {
                var den = payload && payload.effects && payload.effects.density_heatmap;
                if (den && typeof den === 'object') {
                    densityInst = renderDensityHeatmapCardInto(cardEl, payload, den);
                }
            } catch (eDen) {}

            var tabInst = null;
            if (
                !densityInst &&
                payload.tabulator &&
                Array.isArray(payload.tabulator.columns) &&
                payload.tabulator.columns.length
            ) {
                var tableWrap = document.createElement('div');
                tableWrap.className = 'vg-ai-result-card__table';
                cardEl.appendChild(tableWrap);
                tabInst = createResultTabulator(
                    tableWrap,
                    payload.tabulator.columns || [],
                    payload.tabulator.data || []
                );
            }

            resultsFeedEl.appendChild(cardEl);
            resultsCards.push({
                el: cardEl,
                tab: tabInst,
                chart: chartInst,
                density: densityInst,
                payload: payload,
                summaryRight: summaryRightHtml || ''
            });

            // IMPORTANT: keep "last table" up to date so the user can ask for charts (intent=chart)
            // even when the right panel is in feed mode.
            try {
                if (payload && payload.tabulator && Array.isArray(payload.tabulator.columns) && Array.isArray(payload.tabulator.data)) {
                    lastTabulatorSnapshot = {
                        columns: (payload.tabulator.columns || []).slice(),
                        data: (payload.tabulator.data || []).slice()
                    };
                }
            } catch (eSnapBeta) {}

            while (resultsCards.length > resultsFeedMax()) {
                destroyResultCard(resultsCards.shift());
            }
            // Scroll right panel to the newest result (Tabulator/Chart can resize after a tick).
            function scrollRightToBottom() {
                try {
                    if (resultsWrap && typeof resultsWrap.scrollTop === 'number') {
                        resultsWrap.scrollTop = resultsWrap.scrollHeight;
                    }
                } catch (eScr1) {}
                try {
                    if (resultsFeedEl && resultsFeedEl.lastElementChild && resultsFeedEl.lastElementChild.scrollIntoView) {
                        resultsFeedEl.lastElementChild.scrollIntoView({ block: 'end' });
                    }
                } catch (eScr2) {}
            }
            scrollRightToBottom();
            try { setTimeout(scrollRightToBottom, 0); } catch (eT) {}
            try { requestAnimationFrame(scrollRightToBottom); } catch (eRaf) {}
        }

        function resetAiTable() {
            if (tab) {
                try {
                    tab.destroy();
                } catch (eD) {}
                tab = null;
            }
            tableEl.innerHTML = '';
        }

        function setConfirmOpen(open) {
            if (!confirmWrap) return;
            confirmWrap.hidden = !open;
            confirmWrap.setAttribute('aria-hidden', open ? 'false' : 'true');
        }

        function exportRightPanelToPdf() {
            try {
                if (!resultsWrap) return;

                function esc(s) {
                    if (s == null) return '';
                    return String(s)
                        .replace(/&/g, '&amp;')
                        .replace(/</g, '&lt;')
                        .replace(/>/g, '&gt;')
                        .replace(/"/g, '&quot;');
                }
                function fmtDate(it) {
                    var s = String(it || '').trim();
                    if (!s) return '';
                    try {
                        var d = new Date(s);
                        if (isNaN(d.getTime())) return s;
                        return d.toLocaleDateString('it-IT');
                    } catch (e) {
                        return s;
                    }
                }
                function fmtEur(it) {
                    var n = Number(it);
                    if (!isFinite(n)) return String(it || '');
                    try {
                        return n.toLocaleString('it-IT', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
                    } catch (e) {
                        return String(it || '');
                    }
                }

                function buildHtmlTable(tabSpec) {
                    var cols = (tabSpec && Array.isArray(tabSpec.columns)) ? tabSpec.columns : [];
                    var rows = (tabSpec && Array.isArray(tabSpec.data)) ? tabSpec.data : [];
                    if (!cols.length || !rows.length) return '';

                    var th = cols
                        .map(function (c) { return '<th>' + esc(c && (c.title || c.field || '')) + '</th>'; })
                        .join('');
                    var body = rows
                        .map(function (r) {
                            var tds = cols
                                .map(function (c) {
                                    var f = c && c.field ? String(c.field) : '';
                                    var v = r && f ? r[f] : '';
                                    if (/_end$/.test(f) || /date/i.test(f)) v = fmtDate(v);
                                    if (/amount|_eur/i.test(f)) v = fmtEur(v);
                                    return '<td>' + esc(v) + '</td>';
                                })
                                .join('');
                            return '<tr>' + tds + '</tr>';
                        })
                        .join('');
                    return '<table class="vg-ai-export-table"><thead><tr>' + th + '</tr></thead><tbody>' + body + '</tbody></table>';
                }

                function collectCardsForExport() {
                    // Prefer payload-backed cards (feed).
                    if (Array.isArray(resultsCards) && resultsCards.length) {
                        return resultsCards
                            .map(function (c) {
                                var p = c && c.payload ? c.payload : {};
                                // Try to capture chart image from the card canvas.
                                var chartPng = '';
                                try {
                                    if (c.el) {
                                        var canv = c.el.querySelector('canvas');
                                        if (canv && canv.toDataURL) chartPng = canv.toDataURL('image/png');
                                    }
                                } catch (eImg) {}
                                var densitySpec = null;
                                try {
                                    densitySpec = p && p.effects && p.effects.density_heatmap ? p.effects.density_heatmap : null;
                                } catch (eDenSpec) {
                                    densitySpec = null;
                                }
                                return {
                                    summaryHtml: c && c.el ? (c.el.querySelector('.vg-ai-result-card__summary') || {}).innerHTML : '',
                                    chartPng: chartPng,
                                    tabulator: p && p.tabulator ? p.tabulator : null,
                                    densitySpec: densitySpec
                                };
                            })
                            .filter(function (x) {
                                return x && (x.summaryHtml || x.chartPng || x.densitySpec || (x.tabulator && x.tabulator.data && x.tabulator.data.length));
                            });
                    }
                    // Fallback (non-feed): last snapshot
                    if (lastTabulatorSnapshot && lastTabulatorSnapshot.columns && lastTabulatorSnapshot.data && lastTabulatorSnapshot.data.length) {
                        return [{ summaryHtml: String(summaryEl && summaryEl.innerHTML ? summaryEl.innerHTML : ''), chartPng: '', tabulator: lastTabulatorSnapshot }];
                    }
                    return [];
                }

                var cards = collectCardsForExport();
                if (!cards.length) return;

                var blocks = cards
                    .map(function (c) {
                        var html = '<section class="vg-ai-export-card">';
                        if (c.summaryHtml) html += '<div class="vg-ai-export-summary">' + c.summaryHtml + '</div>';
                        if (c.chartPng) html += '<div class="vg-ai-export-chart"><img src="' + c.chartPng + '" alt="Grafico"/></div>';
                        if (c.densitySpec) {
                            html += '<div class="vg-ai-export-densitywrap">' + renderDensityHeatmapForPrint(c.densitySpec) + '</div>';
                        }
                        if (c.tabulator) html += '<div class="vg-ai-export-tablewrap">' + buildHtmlTable(c.tabulator) + '</div>';
                        html += '</section>';
                        return html;
                    })
                    .join('');

                var w = window.open('', '_blank');
                if (!w) return;
                w.document.open();
                w.document.write(
                    '<!doctype html><html><head><meta charset="utf-8"/>' +
                        '<title>VistaGare AI – Export</title>' +
                        '<style>' +
                        '@page{margin:14mm;}' +
                        'body{font-family: -apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Arial,sans-serif; padding:0; color:#111;-webkit-print-color-adjust:exact;print-color-adjust:exact;}' +
                        '.vg-ai-export-card{border:1px solid #ddd;border-radius:10px;overflow:hidden;margin:0 0 12px;page-break-inside:avoid;}' +
                        '.vg-ai-export-summary{padding:10px 12px;border-bottom:1px solid #eee;font-size:13px;line-height:1.35;}' +
                        '.vg-ai-export-chart{padding:10px 12px;border-bottom:1px solid #eee;}' +
                        '.vg-ai-export-chart img{max-width:100%;height:auto;display:block;}' +
                        '.vg-ai-export-densitywrap{padding:10px 12px;border-bottom:1px solid #eee;}' +
                        '.vg-ai-export-density-notes{margin:0 0 10px;padding:8px 10px;border:1px solid #e5e7eb;border-radius:8px;font-size:11px;line-height:1.35;}' +
                        '.vg-ai-export-density-notes ul{margin:4px 0 0;padding-left:1.2em;}' +
                        '.vg-ai-export-tablewrap{padding:10px 12px;}' +
                        '.vg-ai-export-table{width:100%;border-collapse:collapse;font-size:11px;}' +
                        '.vg-ai-export-table th,.vg-ai-export-table td{border:1px solid #e5e7eb;padding:6px 7px;vertical-align:top;}' +
                        '.vg-ai-export-table th{background:#f8fafc;font-weight:700;}' +
                        '.radar-density__heatmap-block{padding:10px;border:1px solid #e5e7eb;border-radius:10px;}' +
                        '.radar-density__title-row{display:flex;align-items:baseline;justify-content:space-between;gap:8px;flex-wrap:wrap;}' +
                        '.radar-page__table-title{margin:0;font-size:12px;}' +
                        '.radar-density__title-meta{color:#6b7280;font-size:10px;}' +
                        '.radar-density__legend{margin:6px 0 10px;display:flex;justify-content:center;}' +
                        '.radar-density__legend-inner{display:inline-flex;align-items:center;gap:8px;}' +
                        '.radar-density__legend-label{font-size:10px;color:#6b7280;white-space:nowrap;}' +
                        '.radar-density__legend-steps{display:inline-flex;gap:4px;align-items:center;}' +
                        '.radar-density__cell{display:inline-block;width:12px;height:12px;border:1px solid #000;box-sizing:border-box;}' +
                        '.vg-ai-export-heatmap-svg{display:block;max-width:100%;height:auto;}' +
                        '.rd-count.level-0{background:#f1f5f9;}.rd-count.level-1{background:#dcfce7;}.rd-count.level-2{background:#86efac;}.rd-count.level-3{background:#22c55e;}.rd-count.level-4{background:#15803d;}' +
                        '.rd-amount.level-0{background:#f1f5f9;}.rd-amount.level-1{background:#fee2e2;}.rd-amount.level-2{background:#fca5a5;}.rd-amount.level-3{background:#ef4444;}.rd-amount.level-4{background:#9a3412;}' +
                        'a{color:#111;text-decoration:none;}' +
                        '</style></head><body>' +
                        blocks +
                        '<script>window.onload=function(){setTimeout(function(){try{window.focus();}catch(e){};window.print();}, 1200);};<\/script>' +
                        '</body></html>'
                );
                w.document.close();
            } catch (e) {}
        }

        function renderDensityHeatmapForPrint(den) {
            try {
                var metric = String(den && den.metric ? den.metric : 'count').toLowerCase();
                var df = parseISODate(den && den.date_from ? den.date_from : '');
                var dt = parseISODate(den && den.date_to ? den.date_to : '');
                if (!df || !dt) return '';

                var series = Array.isArray(den.series) ? den.series : [];
                var mapCount = {};
                var mapSum = {};
                var counts = [];
                var sums = [];
                series.forEach(function (it) {
                    var d = String(it.date || '').slice(0, 10);
                    if (!d) return;
                    var c = Number(it.tenders_count || 0);
                    var s = Number(it.amount_sum || 0);
                    mapCount[d] = c;
                    mapSum[d] = s;
                    counts.push(c);
                    sums.push(s);
                });
                var levelCount = quantizeLevels(counts);
                var levelSum = quantizeLevels(sums);

                var windowDf = new Date(dt.getFullYear(), dt.getMonth() - 11, 1);
                var windowDt = new Date(dt.getFullYear(), dt.getMonth(), dt.getDate());

                function esc(s) {
                    return String(s || '')
                        .replace(/&/g, '&amp;')
                        .replace(/</g, '&lt;')
                        .replace(/>/g, '&gt;')
                        .replace(/"/g, '&quot;');
                }

                function titleRow(title) {
                    var meta = esc(String(den.query_label || '').trim());
                    return (
                        '<div class="radar-density__title-row">' +
                        '<div class="radar-page__table-title">' +
                        esc(title) +
                        '</div>' +
                        (meta ? '<div class="radar-density__title-meta">' + meta + '</div>' : '') +
                        '</div>'
                    );
                }

                function legendHtml(kind) {
                    var left = kind === 'amount' ? 'importo minore' : 'meno gare';
                    var right = kind === 'amount' ? 'importo maggiore' : 'più gare';
                    var palette = kind === 'amount'
                        ? ['#f1f5f9', '#fee2e2', '#fca5a5', '#ef4444', '#9a3412']
                        : ['#f1f5f9', '#dcfce7', '#86efac', '#22c55e', '#15803d'];
                    var cell = 12;
                    var gap = 4;
                    var stepsW = 5 * cell + 4 * gap;
                    var stepsH = cell;
                    var steps = '<svg width="' + stepsW + '" height="' + stepsH + '" viewBox="0 0 ' + stepsW + ' ' + stepsH + '" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="Legenda" shape-rendering="crispEdges">';
                    for (var i = 0; i < 5; i++) {
                        var x = i * (cell + gap);
                        var fill = palette[i] || palette[0];
                        steps += '<rect x="' + x + '" y="0" width="' + cell + '" height="' + cell + '" fill="' + fill + '" stroke="#000" stroke-width="1"/>';
                    }
                    steps += '</svg>';
                    return (
                        '<div class="radar-density__legend"><div class="radar-density__legend-inner">' +
                        '<span class="radar-density__legend-label">' + esc(left) + '</span>' +
                        '<div class="radar-density__legend-steps">' + steps + '</div>' +
                        '<span class="radar-density__legend-label">' + esc(right) + '</span>' +
                        '</div></div>'
                    );
                }

                function chartSvgHtml(kind) {
                    var days = buildCalendarDays(windowDf, windowDt);
                    var cols = Math.ceil(days.length / 7);
                    // Use SVG rects with inline styles for maximum print/PDF reliability.
                    var palette = kind === 'amount'
                        ? ['#f1f5f9', '#fee2e2', '#fca5a5', '#ef4444', '#9a3412']
                        : ['#f1f5f9', '#dcfce7', '#86efac', '#22c55e', '#15803d'];
                    var cell = 12;
                    var labelW = 12;
                    var labelH = 12;
                    var w = labelW + cols * cell;
                    var h = labelH + 7 * cell;
                    var out =
                        '<svg class="vg-ai-export-heatmap-svg" width="' +
                        w +
                        '" height="' +
                        h +
                        '" viewBox="0 0 ' +
                        w +
                        ' ' +
                        h +
                        '" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="Heatmap" ' +
                        'style="display:block;max-width:100%;height:auto" shape-rendering="crispEdges">';

                    var lastMonth = null;
                    for (var c0 = 0; c0 < cols; c0++) {
                        var pick0 = null;
                        for (var r0 = 0; r0 < 7; r0++) {
                            var dx0 = days[c0 * 7 + r0];
                            if (dx0 && dx0 >= windowDf && dx0 <= windowDt) { pick0 = dx0; break; }
                        }
                        if (!pick0) continue;
                        var m0 = pick0.getMonth();
                        if (lastMonth === null || m0 !== lastMonth) {
                            lastMonth = m0;
                            var monthStart0 = new Date(pick0.getFullYear(), pick0.getMonth(), 1);
                            var monthEnd0 = new Date(pick0.getFullYear(), pick0.getMonth() + 1, 0);
                            var inRange0 = monthEnd0 >= df && monthStart0 <= dt;
                            out +=
                                '<text x="' +
                                (labelW + c0 * cell + 1) +
                                '" y="9" font-size="9" ' +
                                'fill="' +
                                (inRange0 ? '#111' : '#6b7280') +
                                '" ' +
                                (inRange0 ? 'font-weight="700" ' : '') +
                                'font-family="-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Arial,sans-serif">' +
                                esc(MONTHS_IT[m0] || '') +
                                '</text>';
                        }
                    }

                    for (var i0 = 0; i0 < 7; i0++) {
                        out +=
                            '<text x="2" y="' +
                            (labelH + i0 * cell + 9) +
                            '" font-size="8" font-weight="600" fill="#6b7280" ' +
                            'font-family="-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Arial,sans-serif">' +
                            esc(DOW_IT[i0] || '') +
                            '</text>';
                    }

                    var now = new Date();
                    var today0 = new Date(now.getFullYear(), now.getMonth(), now.getDate());
                    // days is column-major (weeks). Build table row-major (Mon..Sun) with cols columns.
                    for (var r = 0; r < 7; r++) {
                        for (var c = 0; c < cols; c++) {
                            var idx = c * 7 + r;
                            var d = days[idx];
                            var isWindowDay = d && d >= windowDf && d <= windowDt;
                            if (!isWindowDay) {
                                continue;
                            }
                            var iso = toISODate(d);
                            var inRange = d >= df && d <= dt;
                            var isPast = d < today0;
                            var val = kind === 'amount'
                                ? (mapSum[iso] != null ? mapSum[iso] : 0)
                                : (mapCount[iso] != null ? mapCount[iso] : 0);
                            var level = kind === 'amount' ? levelSum(val) : levelCount(val);
                            var bg = palette[Math.max(0, Math.min(4, level))] || palette[0];
                            var op = !inRange ? 0.35 : (isPast ? 0.5 : 1);
                            var x = labelW + c * cell;
                            var y = labelH + r * cell;
                            out +=
                                '<rect x="' +
                                x +
                                '" y="' +
                                y +
                                '" width="' +
                                cell +
                                '" height="' +
                                cell +
                                '" fill="' +
                                bg +
                                '" fill-opacity="' +
                                op +
                                '" stroke="#000" stroke-width="1"/>';
                        }
                    }
                    out += '</svg>';
                    return out;
                }

                function block(kind) {
                    var title = kind === 'amount' ? 'Somma importi (EUR, per giorno)' : 'Numero gare (per giorno)';
                    return (
                        '<div class="radar-density__heatmap-block">' +
                        titleRow(title) +
                        legendHtml(kind) +
                        chartSvgHtml(kind) +
                        '</div>'
                    );
                }

                var pre = '';
                try {
                    if (den.summary && den.summary.count) {
                        var psP = den.summary;
                        var cP = psP.count;
                        var aP = psP.amount || {};
                        var linesP = [];
                        if (cP.peak_day) linesP.push('Picco n. gare: ' + cP.peak_day + ' (' + cP.peak_value + ')');
                        if (aP.peak_day) linesP.push('Picco importi: ' + aP.peak_day + ' (' + aP.peak_value_eur + ' EUR)');
                        if (cP.avg_per_day != null) linesP.push('Media gare/giorno: ' + cP.avg_per_day);
                        if (aP.avg_per_day_eur != null) linesP.push('Media importi/giorno: ' + aP.avg_per_day_eur + ' EUR');
                        if (cP.delta_pct_vs_prev != null) {
                            linesP.push('Variazione gare vs periodo precedente: ' + cP.delta_pct_vs_prev + '%');
                        }
                        if (aP.delta_pct_vs_prev != null) {
                            linesP.push('Variazione importi vs periodo precedente: ' + aP.delta_pct_vs_prev + '%');
                        }
                        if (linesP.length) {
                            pre +=
                                '<div class="vg-ai-export-density-notes"><strong>Sintesi periodo</strong><ul><li>' +
                                linesP.map(function (x) { return esc(x); }).join('</li><li>') +
                                '</li></ul></div>';
                        }
                    }
                } catch (eSn) {}
                try {
                    if (den.analysis_text_md) {
                        pre +=
                            '<div class="vg-ai-export-density-notes">' +
                            densityRenderMarkdownSimple(den.analysis_text_md) +
                            '</div>';
                    }
                } catch (eAn) {}

                var html = pre;
                if (metric === 'both' || metric === 'count') html += block('count');
                if (metric === 'both' || metric === 'amount') html += block('amount');
                return html;
            } catch (e) {
                return '';
            }
        }

        function clearChatAndStorage() {
            clearMinimapAutoHideTimer();
            history = [];
            lastConversationState = null;
            lastTabulatorSnapshot = null;
            messagesEl.innerHTML = '';
            summaryEl.innerHTML = '';
            summaryEl.classList.remove('vg-ai-results__summary--data-only');
            resetAiTable();
            hideAiChartBlock();
            // Beta feed: clear right-side history too.
            try {
                if (resultsCards && resultsCards.length) {
                    while (resultsCards.length) {
                        destroyResultCard(resultsCards.shift());
                    }
                }
                if (resultsFeedEl) {
                    resultsFeedEl.innerHTML = '';
                }
                if (resultsWrap) {
                    resultsWrap.scrollTop = 0;
                }
            } catch (eFeedClr) {}
            _vgAiForceResetNext = true;
            try {
                localStorage.removeItem(aiChatStorageKey());
            } catch (eLs) {}
            setConfirmOpen(false);
            try {
                input.focus();
            } catch (eF) {}
        }

        function currentMapContext() {
            // best-effort context: bbox + zoom + selected filters
            var ctx = {};
            try {
                var mapMode = window.AppaltiMap && window.AppaltiMap._homeMapAreaMode === 'company' ? 'company' : 'explore';
                ctx.map_area_mode = mapMode;
            } catch (eM0) {}
            try {
                if (window.AppaltiMap && window.AppaltiMap._map && typeof window.AppaltiMap._map.getBounds === 'function') {
                    var b = window.AppaltiMap._map.getBounds();
                    ctx.bbox = [b.getWest(), b.getSouth(), b.getEast(), b.getNorth()].join(',');
                    ctx.zoom = Math.floor(Number(window.AppaltiMap._map.getZoom())) || 0;
                }
            } catch (e) {}
            try {
                if (window.AppaltiMap && window.AppaltiMap._homeMapAreaMode === 'company' && window.AppaltiMap._homeCompanyTerritoriesFC) {
                    var bbUnion = featureCollectionBboxToQueryString(window.AppaltiMap._homeCompanyTerritoriesFC);
                    if (bbUnion) ctx.bbox = bbUnion;
                }
            } catch (eB0) {}
            // Poligono salvato (stesso schema della ricerca pin): bbox min/max del poligono per /ai/chat
            try {
                var geom = window.AppaltiMap && window.AppaltiMap._savedAreaGeojson;
                if (geom && geom.type === 'Polygon' && geom.coordinates && geom.coordinates.length) {
                    var ring = geom.coordinates[0] || [];
                    var minLon = 999, minLat = 999, maxLon = -999, maxLat = -999;
                    ring.forEach(function (p) {
                        if (!p || p.length < 2) return;
                        var lon = Number(p[0]);
                        var lat = Number(p[1]);
                        if (isNaN(lon) || isNaN(lat)) return;
                        minLon = Math.min(minLon, lon);
                        minLat = Math.min(minLat, lat);
                        maxLon = Math.max(maxLon, lon);
                        maxLat = Math.max(maxLat, lat);
                    });
                    if (minLon <= maxLon && minLat <= maxLat) {
                        ctx.bbox_saved_area = [minLon, minLat, maxLon, maxLat].join(',');
                    }
                }
            } catch (e2) {}
            try { ctx.outcomes = getSelectedOutcomes().join(','); } catch (e) {}
            try { ctx.cpv = getCpvFilterStringForAiContext(); } catch (e) {}
            try {
                var cpvMap = getCpvFilterParamsForMap();
                if (cpvMap.cpv_prefixes) ctx.cpv_prefixes = cpvMap.cpv_prefixes;
            } catch (eCpvP) {}
            try { ctx.member_uuid = getMemberUuidFromDom(); } catch (e) {}
            try {
                var mid = getMemberIdFromDom();
                if (mid) ctx.member_id = mid;
            } catch (e) {}
            return ctx;
        }

        function send(text) {
            var msg = String(text || '').trim();
            if (!msg) return Promise.resolve();
            history.push({ role: 'user', content: msg });
            addMsg('user', msg);
            summaryEl.classList.remove('vg-ai-results__summary--data-only');
            summaryEl.textContent = 'Caricamento…';
            setRightLoading(true);

            var headers = { Accept: 'application/json', 'Content-Type': 'application/json' };
            var t = authToken();
            if (t) headers.Authorization = 'Bearer ' + t;

            var ctx = currentMapContext();
            if (_vgAiForceResetNext) {
                ctx.force_reset = true;
                _vgAiForceResetNext = false;
            }
            if (lastConversationState && typeof lastConversationState === 'object') {
                ctx.conversation_state = lastConversationState;
            }
            if (
                lastTabulatorSnapshot &&
                lastTabulatorSnapshot.columns &&
                lastTabulatorSnapshot.data &&
                lastTabulatorSnapshot.data.length
            ) {
                ctx.last_result_table = {
                    columns: lastTabulatorSnapshot.columns.slice(),
                    data: lastTabulatorSnapshot.data.slice(0, AI_LAST_TABLE_MAX_ROWS)
                };
            } else if (isBetaResultsUser && resultsCards && resultsCards.length) {
                // Fallback: derive last table from most recent feed card payload.
                try {
                    var lastCard = resultsCards[resultsCards.length - 1];
                    var p = lastCard && lastCard.payload ? lastCard.payload : null;
                    if (p && p.tabulator && Array.isArray(p.tabulator.columns) && Array.isArray(p.tabulator.data) && p.tabulator.data.length) {
                        ctx.last_result_table = {
                            columns: (p.tabulator.columns || []).slice(),
                            data: (p.tabulator.data || []).slice(0, AI_LAST_TABLE_MAX_ROWS)
                        };
                    }
                } catch (eLastCard) {}
            }
            var payload = {
                messages: history.slice(-12),
                context: ctx
            };

            return fetch(apiBase + '/ai/chat', { method: 'POST', headers: headers, body: JSON.stringify(payload) })
                .then(function (r) {
                    if (!r.ok) {
                        return r.text().then(function (t2) {
                            var raw = t2 || r.statusText || '';
                            var msg = raw;
                            try {
                                var j = JSON.parse(raw);
                                if (j && j.detail != null) {
                                    msg = typeof j.detail === 'string' ? j.detail : JSON.stringify(j.detail);
                                }
                            } catch (ignore) {}
                            var err = new Error(msg);
                            err.status = r.status;
                            throw err;
                        });
                    }
                    return r.json();
                })
                .then(function (data) {
                    var summary = (data && data.summary_text) ? String(data.summary_text) : '';
                    var eff = data && data.effects;
                    var skipRight = data && data.skip_results_summary === true;
                    var noRightPanel = eff && eff.no_right_panel === true;
                    // Compute right-panel summary text (may be empty in data-only mode).
                    var summaryRight = summary;
                    try {
                        if (eff && eff.hide_right_cpv_list) {
                            summaryRight = String(summaryRight || '').replace(/\s+Filtro CPV per:[\s\S]*$/m, '');
                        }
                    } catch (eStrip0) {}

                    // If backend says "do not touch right panel", keep it as-is (no feed entry, no summary/table changes).
                    if (!(noRightPanel === true)) {
                        // Feed mode: append each result into right-side history (summary optional).
                        if (isBetaResultsUser && resultsFeedEl) {
                            appendResultCardFromPayload(data, skipRight ? '' : (summaryRight || '—'));
                        }
                    }
                    if (skipRight) {
                        if (!(noRightPanel === true)) {
                            summaryEl.innerHTML = '';
                            summaryEl.classList.add('vg-ai-results__summary--data-only');
                        }
                    } else {
                        summaryEl.classList.remove('vg-ai-results__summary--data-only');
                        // Show full summary in left chat, but optionally hide the CPV list in the right panel.
                        // For the beta user, push each result into a scrollable feed.
                        if (!(noRightPanel === true) && !(isBetaResultsUser && resultsFeedEl)) {
                            summaryEl.innerHTML = renderAiMarkdown(summaryRight || '—');
                        }
                    }
                    addAssistantMsgSplit(summary || '—');
                    appendAiChatLeftFooter(eff);

                    var nextConvState =
                        data && data.conversation_state != null && typeof data.conversation_state === 'object'
                            ? data.conversation_state
                            : null;
                    if (nextConvState) {
                        lastConversationState = nextConvState;
                    } else if (
                        data &&
                        data.chart &&
                        lastConversationState &&
                        (lastConversationState.intent === 'tenders_table' ||
                            lastConversationState.intent === 'radar_hub')
                    ) {
                        
                    } else {
                        lastConversationState = nextConvState;
                    }

                    var tabData = (data && data.tabulator) || {};
                    if (!isBetaResultsUser) {
                        ensureTabulator(tabData.columns || [], tabData.data || []);
                        lastTabulatorSnapshot = {
                            columns: (tabData.columns || []).slice(),
                            data: (tabData.data || []).slice()
                        };
                        if (data && data.chart) {
                            renderAiChartFromPayload(data.chart);
                        } else {
                            hideAiChartBlock();
                        }
                    }
                    persistAiChatState();

                    if (eff && eff.home_map_area_mode === 'explore') {
                        try {
                            if (typeof window.AppaltiMap._applyExploreModeFromAi === 'function') {
                                window.AppaltiMap._applyExploreModeFromAi();
                            }
                        } catch (eHm) {}
                    }

                    // Effects (optional)
                    if (eff && eff.apply_filters) {
                        try {
                            if (eff.apply_filters.outcome) {
                                document.querySelectorAll('.appaltimap-filter-input').forEach(function (inp) {
                                    inp.checked = (inp.getAttribute('data-outcome') === eff.apply_filters.outcome);
                                });
                            }
                            if (eff.apply_filters.cpv_prefix != null && window.AppaltiMap._homeMapAreaMode !== 'company') {
                                var cpvPrefixEl = document.getElementById('appaltimap-cpv-prefix');
                                var cpvInputEl = document.getElementById('appaltimap-cpv-query');
                                if (cpvPrefixEl) cpvPrefixEl.value = String(eff.apply_filters.cpv_prefix || '');
                                if (cpvInputEl) cpvInputEl.value = String(eff.apply_filters.cpv_label || eff.apply_filters.cpv_prefix || '');
                            }
                        } catch (e) {}
                    }
                    var hadPanZoom = false;
                    if (eff && eff.pan_zoom && window.AppaltiMap && window.AppaltiMap._map) {
                        try {
                            var pz = eff.pan_zoom;
                            var rKm = pz.radius_km != null ? Number(pz.radius_km) : NaN;
                            if (pz.bbox) {
                                var pzB = String(pz.bbox).split(',').map(Number);
                                if (pzB.length === 4 && pzB.every(isFinite)) {
                                    hadPanZoom = true;
                                    window.AppaltiMap._map.fitBounds([[pzB[0], pzB[1]], [pzB[2], pzB[3]]], { padding: vgMapFitPaddingPx(), duration: 700 });
                                    var gjPz = pz.geojson;
                                    if (gjPz && gjPz.type === 'Feature' && gjPz.geometry) gjPz = gjPz.geometry;
                                    if (
                                        gjPz &&
                                        (gjPz.type === 'Polygon' || gjPz.type === 'MultiPolygon')
                                    ) {
                                        window.AppaltiMap._lastAiGeo = { kind: 'polygon', geometry: gjPz };
                                    } else if (pz.center && pz.center.length === 2 && isFinite(rKm) && rKm > 0) {
                                        window.AppaltiMap._lastAiGeo = {
                                            kind: 'circle',
                                            center: pz.center,
                                            radiusKm: rKm
                                        };
                                    } else {
                                        window.AppaltiMap._lastAiGeo = {
                                            kind: 'bbox',
                                            west: pzB[0],
                                            south: pzB[1],
                                            east: pzB[2],
                                            north: pzB[3]
                                        };
                                    }
                                }
                            } else if (pz.center && pz.zoom != null) {
                                hadPanZoom = true;
                                window.AppaltiMap._map.flyTo({ center: pz.center, zoom: pz.zoom, duration: 700 });
                                if (isFinite(rKm) && rKm > 0) {
                                    window.AppaltiMap._lastAiGeo = {
                                        kind: 'circle',
                                        center: pz.center,
                                        radiusKm: rKm
                                    };
                                } else {
                                    window.setTimeout(function () {
                                        try {
                                            var bz = window.AppaltiMap._map.getBounds();
                                            window.AppaltiMap._lastAiGeo = {
                                                kind: 'bbox',
                                                west: bz.getWest(),
                                                south: bz.getSouth(),
                                                east: bz.getEast(),
                                                north: bz.getNorth()
                                            };
                                        } catch (ePz) {}
                                    }, 750);
                                }
                            }
                        } catch (e) {}
                    }
                    if (!hadPanZoom) {
                        try {
                            syncLastAiGeoFromConversationState(lastConversationState);
                        } catch (eSync2) {}
                    }
                    try {
                        if (minimapWrapEl && !minimapWrapEl.hidden) {
                            paintAiMinimapSelection({ animate: true });
                        }
                    } catch (ePaint) {}

                    // highlight_results not implemented yet (requires a dedicated map layer)
                    setRightLoading(false);
                })
                .catch(function (e) {
                    var msg2 = 'Errore AI.';
                    try { msg2 = String(e && e.message ? e.message : msg2); } catch (ignore) {}
                    summaryEl.textContent = msg2;
                    summaryEl.classList.remove('vg-ai-results__summary--data-only');
                    hideAiChartBlock();
                    addAssistantMsgSplit(msg2);
                    appendAiChatLeftFooter(null);
                    persistAiChatState();
                    setRightLoading(false, true);
                });
        }

        if (isBetaResultsUser) {
            enableResultsFeedMode();
        }
        restoreAiChatState();

        (function bindAiMapModeToggle() {
            var aiModeBtn = qsAi('[data-vg-ai-map-mode-toggle]');
            if (!aiModeBtn) return;
            aiModeBtn.addEventListener('click', function (e) {
                if (e) e.stopPropagation();
                if (!getMemberUuidFromDom()) return;
                if (typeof window.AppaltiMap._runHomeMapAreaModeToggle === 'function') {
                    window.AppaltiMap._runHomeMapAreaModeToggle();
                }
            });
        })();

        openBtn.addEventListener('click', function () {
            setOpen(true);
            applyAiTabulatorHeaderTheme();
        });
        closeBtn.addEventListener('click', function () { setOpen(false); });
        if (clearBtn && confirmWrap && confirmCancel && confirmOk) {
            clearBtn.addEventListener('click', function (e) {
                if (e) e.stopPropagation();
                setConfirmOpen(true);
            });
            confirmCancel.addEventListener('click', function () {
                setConfirmOpen(false);
            });
            confirmOk.addEventListener('click', function () {
                clearChatAndStorage();
            });
            if (confirmBackdrop) {
                confirmBackdrop.addEventListener('click', function () {
                    setConfirmOpen(false);
                });
            }
        }
        if (exportPdfBtn) {
            exportPdfBtn.addEventListener('click', function (e) {
                if (e) e.stopPropagation();
                exportRightPanelToPdf();
            });
        }
        if (minimapToggle && minimapWrapEl) {
            minimapToggle.addEventListener('click', function (e) {
                if (e) e.stopPropagation();
                var visible = !minimapWrapEl.hidden;
                if (visible) {
                    minimapUserPinned = false;
                    clearMinimapAutoHideTimer();
                    showMinimapPanel(false);
                } else {
                    minimapUserPinned = true;
                    clearMinimapAutoHideTimer();
                    showMinimapPanel(true);
                }
            });
        }
        modal.addEventListener('click', function (e) {
            if (e && e.target === modal) setOpen(false);
        });
        document.addEventListener('keydown', function (e) {
            if (!e || e.key !== 'Escape') return;
            if (confirmWrap && !confirmWrap.hidden) {
                e.preventDefault();
                setConfirmOpen(false);
                return;
            }
            if (!modal.hidden) setOpen(false);
        });

        form.addEventListener('submit', function (e) {
            e.preventDefault();
            var msg = String(input.value || '').trim();
            input.value = '';
            send(msg);
        });
    })();

    function runRegionalGareGateOnReady() {
        try {
            applyRegionalGareGate();
        } catch (eRg) { /* ignore */ }
    }
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', runRegionalGareGateOnReady);
    } else {
        runRegionalGareGateOnReady();
    }
})(window, document);
